<template>
    <div>
        <div class="custom-loader-wrapper payslip-custom-loader" v-if="download_loader">
            <div class="text-center">
                <span class="d-block max-450 m-auto" v-if="import_loader"><template
                        v-if="file_imported"></template><template v-else>{{ download_text }}</template></span>
                <span class="d-block max-450 m-auto" v-else>{{ download_text }}</span>
                <div class="card mt-4" v-if="import_loader && file_imported">
                    <div class="card-body p-2">
                        <div class="deprtment-top-block border mt-0 mb-0 pt-5 position-relative px-0"
                            style="z-index: 9; min-height: 450px;">
                            <div class="col-md-12 pay-run-loader overflow-hidden">
                                <!--<p style="color: #fff;">Alright world, time to take you on!<br/>Payrun import in progress ...</p>-->
                                <p style="color:#0060c9;">{{ download_text }}</p>

                                <!-- alpha fix- chnaged image here  -->
                                <img :src="$api_url + '/images/payrun-loader.png'" width="40"class="loader-logo">
                                <div class="loading-stroke"></div>
                                <b-progress :max="number_of_employees" class="payroll-progress" show-progress animated>
                                    <b-progress-bar :value="progress_value"
                                        :label="(progress_value) + ' / ' + (number_of_employees)"></b-progress-bar>
                                </b-progress>
                            </div>
                        </div>
                    </div>
                </div>
                <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo" width="100px" v-else />
                <p class="mt-5">Please click <a target="_blank" :href="$api_url + '/company/dashboard'">here</a> or below
                    if you want to
                    continue surfing the system.</p>
                <b-button class="mb-1" target="_blank" :href="$api_url + '/company/dashboard'">Dashboard</b-button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <h4 class="atlhr-dashboard-title mt-10"><template v-if="fdata.status != '1'">Draft </template><template
                        v-else>Approved </template> {{ fdata.name }} <b-icon v-if="fdata.status == '1'"
                        icon="check-circle-fill" class="ml-2" variant="success"></b-icon><span><a
                            v-bind:href="$api_url + '/company/dashboard'">Dashboard
                        </a>/ Payrun Details </span></h4>
            </div>
            <div class="col-md-6 col-sm-12 d-flex align-items-center justify-content-end">
                <b-button class="mb-1" :href="$api_url + '/payruns/'"><b-icon icon="chevron-left" rotate="0" class="mr-2"
                        scale="1"></b-icon> Back to Payroll</b-button>
            </div>
        </div>
        <div class="" v-if="payslipids.length > 0">Selected Employee(s): {{ payslipids.length }}</div>
        <div class="card mt-0 border-0 no-shadow reports-tab-nav mt-4">
            <div v-if="modalsuccess != ''" class="alert alert-success" role="alert"> {{ modalsuccess }} </div>

            <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin">
                    <div class="col-sm-8 pl-0">
                        <div class="employee-btn-holder trz_ppl_wrapper_2">

                            <b-dropdown
                                v-if="fdata.status != '1' && fdata.run_type != '8' && fdata.run_type != '9' && ($acl['payrun/export'] == 2 || $acl['payrun/import/uploadfile'] == 2)"
                                text="Upload Variable Input" class="trz-custom-dropdown mb-1">
                                <template #button-content>
                                    <b-icon icon="upload" class="mr-2"></b-icon> Upload Variable Input
                                </template>
                                <b-dropdown-group id="dropdown-group-1" header="Monthly Payrol Run">
                                    <b-dropdown-item @click="exportPayslips('regular')"
                                        v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down" class="mr-2"
                                            scale="1"></b-icon>Export file for upload ( Selected Employee
                                        )</b-dropdown-item>
                                    <b-dropdown-item @click="exportAll('regular')"
                                        v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down" class="mr-2"
                                            scale="1"></b-icon>Export file for upload (
                                        All Employee )</b-dropdown-item>
                                    <template v-if="payrun_department_data.department == 'yes'">
                                        <b-dropdown-item @click="exportAll('department')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload ( Department wise
                                            )</b-dropdown-item>
                                    </template>
                                    <template v-if="payrun_department_data.work_location == 'yes'">
                                        <b-dropdown-item @click="exportAll('work_location')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload ( Work Location
                                            wise )</b-dropdown-item>
                                    </template>

                                </b-dropdown-group>

                                <b-form-file id="datafile" name="datafile" style="display: none" @change="uploadFile"
                                    accept=".xlsx,.xls"></b-form-file>
                                <b-dropdown-group id="dropdown-group-1"
                                    v-if="fdata.run_type == 11 || fdata.run_type == 12">
                                    <b-dropdown-item v-if="fdata.status != '1' && $acl['payrun/import/uploadfile'] == 2"
                                        @click="importAll('off_cycle')"><b-icon icon="box-arrow-up" class="mr-2"
                                            scale="1"></b-icon>Import file for Processing</b-dropdown-item>
                                </b-dropdown-group>
                                <b-dropdown-group id="dropdown-group-1" v-else>
                                    <b-dropdown-item v-if="fdata.status != '1' && $acl['payrun/import/uploadfile'] == 2"
                                        @click="importAll('regular')"><b-icon icon="box-arrow-up" class="mr-2"
                                            scale="1"></b-icon>Import file for Processing</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>

                                <b-dropdown-group id="dropdown-group-1" header="OT, Holiday Comp & LOP">
                                    <b-dropdown-item @click="exportOvertimeDataSelected('regular')"
                                        v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down" class="mr-2"
                                            scale="1"></b-icon>Export file for upload ( Selected Employee
                                        )</b-dropdown-item>
                                    <b-dropdown-item @click="exportOvertimeData('regular')"
                                        v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down" class="mr-2"
                                            scale="1"></b-icon>Export file for upload ( All Employee )</b-dropdown-item>
                                    <template v-if="payrun_department_data.department == 'yes'">
                                        <b-dropdown-item @click="exportOvertimeData('department')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload ( Department wise
                                            )</b-dropdown-item>
                                    </template>
                                    <template v-if="payrun_department_data.work_location == 'yes'">
                                        <b-dropdown-item @click="exportOvertimeData('work_location')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload ( Work Location
                                            wise )</b-dropdown-item>
                                    </template>
                                </b-dropdown-group>

                                <b-form-file id="datafile_overtime" name="datafile_overtime" style="display: none"
                                    @change="uploadFile_overtime" accept=".xlsx,.xls"></b-form-file>
                                <b-dropdown-group id="dropdown-group-1"
                                    v-if="fdata.run_type == 11 || fdata.run_type == 12">
                                    <b-dropdown-item v-if="fdata.status != '1' && $acl['payrun/import/uploadfile'] == 2"
                                        @click="importOvertimeData('off_cycle')"><b-icon icon="box-arrow-up"
                                            class="mr-2" scale="1"></b-icon>Import file for Processing</b-dropdown-item>
                                </b-dropdown-group>
                                <b-dropdown-group id="dropdown-group-1" v-else>
                                    <b-dropdown-item v-if="fdata.status != '1' && $acl['payrun/import/uploadfile'] == 2"
                                        @click="importOvertimeData('regular')"><b-icon icon="box-arrow-up" class="mr-2"
                                            scale="1"></b-icon>Import file for Processing</b-dropdown-item>
                                </b-dropdown-group>
                            </b-dropdown>
                            <!-- For manual payslips only -->
                            <template v-if="fdata.run_type != '11' && fdata.run_type != '12'">
                                <b-dropdown
                                    v-if="fdata.status != '1' && ($acl['payrun/export'] == 2 || $acl['payrun/import/uploadfile'] == 2)"
                                    text="Upload Variable Input (Manual)" class="trz-custom-dropdown mb-1">
                                    <template #button-content>
                                        <b-icon icon="upload" class="mr-2"></b-icon> Upload Variable Input (Manual)
                                    </template>
                                    <b-dropdown-group id="dropdown-group-1" header="Monthly Payrol Run">
                                        <b-dropdown-item @click="exportPayslips('manual')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload (
                                            Selected Employee )</b-dropdown-item>
                                        <b-dropdown-item @click="exportAll('manual')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload ( All
                                            Employee )</b-dropdown-item>

                                    </b-dropdown-group>

                                    <b-form-file id="datafile" name="datafile" style="display: none"
                                        @change="uploadFile" accept=".xlsx,.xls"></b-form-file>
                                    <b-dropdown-group id="dropdown-group-1">
                                        <b-dropdown-item
                                            v-if="fdata.status != '1' && $acl['payrun/import/uploadfile'] == 2"
                                            @click="importAll('manual')"><b-icon icon="box-arrow-up" class="mr-2"
                                                scale="1"></b-icon>Import file for Processing</b-dropdown-item>
                                    </b-dropdown-group>

                                    <b-dropdown-divider></b-dropdown-divider>

                                    <!--<b-dropdown-group id="dropdown-group-1" header="Variable Contract Data">
                                        <b-dropdown-item @click="exportVariableContractDataSelected('manual')" v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Export file for upload ( Selected Employee )</b-dropdown-item>
                                        <b-dropdown-item @click="exportVariableContractData('manual')" v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Export file for upload ( All Employee )</b-dropdown-item>

                                    </b-dropdown-group>

                                    <b-form-file id="datafile_vr_contract" name="datafile_vr_contract" style="display: none" @change="uploadFile_vr_contract"  accept=".xlsx,.xls"></b-form-file>
                                    <b-dropdown-group id="dropdown-group-1">
                                        <b-dropdown-item v-if="fdata.status != '1' && $acl['payrun/import/uploadfile'] == 2" @click="importVariableContractData('manual')"><b-icon icon="box-arrow-up" class="mr-2" scale="1"></b-icon>Import file for Processing</b-dropdown-item>
                                    </b-dropdown-group>

                                    <b-dropdown-divider></b-dropdown-divider>-->

                                    <b-dropdown-group id="dropdown-group-1" header="OT, Holiday Comp & LOP">
                                        <b-dropdown-item @click="exportOvertimeDataSelected('manual')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload ( Selected
                                            Employee )</b-dropdown-item>
                                        <b-dropdown-item @click="exportOvertimeData('manual')"
                                            v-if="$acl['payrun/export'] == 2"><b-icon icon="box-arrow-in-down"
                                                class="mr-2" scale="1"></b-icon>Export file for upload ( All
                                            Employee )</b-dropdown-item>

                                    </b-dropdown-group>

                                    <b-form-file id="datafile_overtime" name="datafile_overtime" style="display: none"
                                        @change="uploadFile_overtime" accept=".xlsx,.xls"></b-form-file>
                                    <b-dropdown-group id="dropdown-group-1">
                                        <b-dropdown-item
                                            v-if="fdata.status != '1' && $acl['payrun/import/uploadfile'] == 2"
                                            @click="importOvertimeData('manual')"><b-icon icon="box-arrow-up"
                                                class="mr-2" scale="1"></b-icon>Import file for
                                            Processing</b-dropdown-item>
                                    </b-dropdown-group>
                                </b-dropdown>
                            </template>
                            <!-- For manual payslips only -->
                            <b-dropdown text="Downloads" class="trz-custom-dropdown mb-1"
                                v-if="$acl['payroll_bankfile'] == 2 || $acl['payroll_monthly_report_custom'] == 2 || $acl['downloadpayslips'] == 2 || $acl['downloadtaxcards'] == 2">
                                <template #button-content>
                                    <b-icon icon="download" class="mr-2"></b-icon> Downloads
                                </template>
                                <b-dropdown-group id="dropdown-group-1" header="Payroll"
                                    v-if="$acl['payroll_bankfile'] == 2 || $acl['payroll_monthly_report_custom'] == 2">
                                    <b-dropdown-item @click="getSalaryReport(fdata.year, fdata.mn)"
                                        v-if="fdata.status == '0' && $acl['payroll_monthly_report_custom'] == 2"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Draft Payroll
                                        Report</b-dropdown-item>
                                    <b-dropdown-item @click="getSalaryReport(fdata.year, fdata.mn)"
                                        v-if="fdata.status == '1' && $acl['payroll_monthly_report_custom'] == 2"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Approved Payroll
                                        Report</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-group id="dropdown-group-1" header="Payroll Bank Files"
                                    v-if="$acl['payroll_bankfile'] == 2">
                                    <b-dropdown-item @click="downloadBankfile('default')"
                                        v-if="$acl['payroll_bankfile'] == 2"><b-icon icon="box-arrow-in-down"
                                            class="mr-2" scale="1"></b-icon>Default</b-dropdown-item>
                                    <b-dropdown-item @click="downloadBankfile(checked_bank)"
                                        v-for="checked_bank in checked_banks" :key="checked_bank"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>{{ checked_bank
                                        }}</b-dropdown-item>
                                    <b-dropdown-item @click="downloadBankfile('none')"
                                        v-if="checked_banks.length > 0"><b-icon icon="box-arrow-in-down" class="mr-2"
                                            scale="1"></b-icon>No Payment
                                        Banks</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider v-if="$acl['downloadpayslips'] == 2"></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Pay Slips"
                                    v-if="$acl['downloadpayslips'] == 2">
                                    <b-dropdown-item @click="downloadPayslips()"><b-icon icon="box-arrow-in-down"
                                            class="mr-2" scale="1"></b-icon>Download Selected (100 max)
                                    </b-dropdown-item>
                                    <!-- <b-dropdown-item  @click="downloadAllPayslips()"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download All</b-dropdown-item> -->
                                    <b-dropdown-item @click="showDownloadModal('downloadpayslips')"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Schedule Download
                                        All
                                    </b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider v-if="$acl['downloadtaxcards'] == 2"></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Tax Cards"
                                    v-if="$acl['downloadtaxcards'] == 2">
                                    <b-dropdown-item @click="downloadTaxcards()"><b-icon icon="box-arrow-in-down"
                                            class="mr-2" scale="1"></b-icon>Download Selected (100 max)
                                    </b-dropdown-item>
                                    <!-- <b-dropdown-item @click="downloadAllTaxcards()"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download All</b-dropdown-item> -->
                                    <b-dropdown-item @click="showDownloadModal('downloadtaxcards')"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Schedule Download
                                        All
                                    </b-dropdown-item>
                                </b-dropdown-group>




                                <!--<b-dropdown-divider v-if="fdata.parent==0 && fdata.status == '1'"></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item  @click="downloadBankfile()" v-if="fdata.parent==0 && fdata.status == '1'"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download Bank File</b-dropdown-item>
                                </b-dropdown-group>-->
                            </b-dropdown>
                            <b-dropdown
                                v-if="fdata.status != '1' && ($acl['resetpayslips'] == 2 || $acl['deletepayslips'] == 2 || $acl['deletepayrun'] == 2)"
                                text="Payroll Run Settings" class="trz-custom-dropdown mb-1">
                                <!-- <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslips(1)" v-if="$acl['resetpayslips'] == 2">Reset Payslip</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider v-if="$acl['deletepayslips'] == 2 && $acl['resetpayslips'] == 2"></b-dropdown-divider> -->

                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslips(2)"
                                        v-if="$acl['deletepayslips'] == 2">Delete Pay
                                        Slip</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider
                                    v-if="($acl['deletepayrun'] == 2 && $acl['deletepayslips'] == 2) || $acl['resetpayslips'] == 2"></b-dropdown-divider>

                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="showDeleteModal(3)" v-if="$acl['deletepayrun'] == 2">Delete
                                        Run</b-dropdown-item>
                                </b-dropdown-group>

                            </b-dropdown>
                            <b-dropdown v-if="fdata.status == '1' && $acl['challans'] == 2" text="Challans"
                                class="trz-custom-dropdown mb-1">
                                <template #button-content>
                                    <b-icon icon="file-text-fill" class="mr-2"></b-icon> Challans
                                </template>
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item
                                        :href="$api_url + '/challans/?payrun_id=' + fdata.id + '&month=' + fdata.month + '&fiscal_year=' + fdata.fiscal_year"><b-icon
                                            icon="plus" class="mr-2" scale="1"></b-icon>Create Challan</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>

                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item
                                        :href="$api_url + '/challans/?payrun_id=' + fdata.id + '&month=' + fdata.month + '&fiscal_year=' + fdata.fiscal_year"><b-icon
                                            icon="list" class="mr-2" scale="1"></b-icon>Challan List
                                        ({{ fdata.total_challans }})</b-dropdown-item>
                                </b-dropdown-group>

                            </b-dropdown>
                            <b-dropdown v-if="fdata.status == '1' && $acl['modifypayslips'] == 2" text="Email"
                                class="trz-custom-dropdown mb-1">
                                <template #button-content>
                                    <b-icon icon="envelope-fill" class="mr-2"></b-icon> Email
                                </template>
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslipsEmail(3)">Email Selected Pay
                                        Slip(s)</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>

                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item @click="modifyPayslipsEmail(4)">Email Selected Tax
                                        Card(s)</b-dropdown-item>
                                </b-dropdown-group>

                            </b-dropdown>
                            <!--<span v-if="emailing != ''"><img :src="$api_url+'/images/loading.gif'" width="20"> We are initiating email sending process. Please wait, this may take few seconds...</span>-->
                            <template v-if="addons.includes('LeaveAttendances') || addons.includes('Roster')">
                                <b-button v-if="fdata.status != '1'" @click="showLeaveEncashmentList(fdata.id)"
                                    class="mb-1">Process Leave Encashment</b-button>
                            </template>
                            <template v-if="addons.includes('Roster')">
                                <roster-process-overtime v-if="fdata.status != '1'" :payrun_id="fdata.id"></roster-process-overtime>
                            </template>
                            <template v-if="addons.includes('Roster')">
                                <roster-process-penalty v-if="fdata.status != '1'" :payrun_id="fdata.id"></roster-process-penalty>
                            </template>
                        </div>

                    </div>
                    <div class="col-sm-4 pr-0">
                        <div class="col-12 text-right pr-0 trz_ppl_wrapper_2">
                            <template v-if="payrun_department_data.department == 'yes'">
                                <b-button v-if="fdata.status != '1'" @click="showDepartmentList(fdata.id)"
                                    class="mb-1">Manage By Department</b-button>
                            </template>
                            <template v-if="payrun_department_data.work_location == 'yes'">
                                <b-button v-if="fdata.status != '1'" @click="showWorkLocationList(fdata.id)"
                                    class="mb-1">Manage By Work Location</b-button>
                            </template>
                            <b-dropdown v-if="fdata.status != '1' && $acl['createpayslipbyid'] == 2"
                                text="Create Pay Slip" class="trz-custom-dropdown mb-1">
                                <template #button-content>
                                    <b-icon icon="plus" class="mr-0"></b-icon> Create Pay Slip
                                </template>
                                <b-dropdown-group id="dropdown-group-1"
                                    v-if="fdata.run_type != '8' && fdata.run_type != '9'">
                                    <b-dropdown-item @click="displaynewpayslipmodal(fdata.id)">Regular Pay
                                        Slip(s)</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-group id="dropdown-group-1"
                                    v-if="fdata.run_type != '11' && fdata.run_type != '12'">
                                    <b-dropdown-item @click="displaynewpayslipmodalManual(fdata.id)">Manual Pay
                                        Slip(s)</b-dropdown-item>
                                </b-dropdown-group>

                            </b-dropdown>
                            <b-button class="mb-1 btn-approved"
                                v-if="fdata.status != '1' && $acl['payrun-update-status'] == 2"
                                href="javascript:void(0);" @click="showApproveModal()"><b-icon icon="check-circle-fill"
                                    class="mr-2" scale="1"></b-icon>Approve Payrun</b-button>
                            <span class="btn mb-1 d-none" style="color: green !important; border: 1px solid green;"
                                v-if="fdata.status == '1'">Approved</span>
                        </div>
                    </div>
                </div>
                <!--<div v-if="emailsuccess != ''" class="alert alert-success" role="alert"> {{emailsuccess}} </div>-->
                <div v-if="emailing != ''" class="alert alert-info" role="alert"><img
                        :src="$api_url + '/images/loading.gif'" width="20" class="mr-2"> We are initiating email sending
                    process. Please wait, this may take few
                    seconds... </div>
                <div v-if="emailing_success != ''" class="alert alert-success" role="alert"><b-icon
                        icon="check-circle-fill" class="mr-2" variant="success"></b-icon> {{ emailing_success }} </div>
                <div class="col-sm-12 text-center">








                </div>
                <!--<div class="card-header-inner clearfix mt-3">
                    <div class="float-left align-self-center pt-1 col-sm-3 px-0" style="font-size: 18px;">Total Payslip(s) <span class="ml-2" style="color: #5A8DEE;">{{pagination.total}}</span></div>
                    <div class="float-left align-self-center col-sm-9 custom-search pr-0">
                        <b-input-group >
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search by employee / position / branch / email / phone"  v-model="search.allparams" @input="setSearch()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>-->
            </div>



            <div><b-modal id="delete-payrun-modal" :title="payrun_delete_msg" hide-footer>Please enter your password to
                    continue:
                    <br />
                    <input id="approvepass" type="password" class="form-control" v-model="approvepass"
                        name="approvepass">

                    <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert"
                        style="clear: both; margin-top: 10px;"> {{ incorrectpass }} </div>
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width" @click="deletePayrun(2)">Delete
                        Run
                        <span v-if="loading != ''"><img :src="$api_url + '/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                        @click="$bvModal.hide('delete-payrun-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>

                </b-modal></div>



            <div><b-modal id="pass-modal" title="Are you sure to Approve?" hide-footer>All the previous payrun/pay slips
                    will be
                    locked after this process is done.<br>Please enter your password to continue:
                    <br />

                    <form enctype="multipart/form-data">
                        <input type="text" style="display:none" />
                        <input id="approvepass" type="password" class="form-control" v-model="approvepass"
                            name="approvepass">
                    </form>

                    <!-- Abdullah 13-05-26 commented this and added next line -->
                    <!-- <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div> -->
                    <div v-if="incorrectpass != ''" style="clear: both; margin-top: 10px; color: red;">
                        {{ incorrectpass }}
                    </div>
                    <!-- Abdullah 13-05-26 commented this and added next line upto this-->
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                        @click="approvePayrun(fdata.id)">Approve <span v-if="loading != ''"><img
                                :src="$api_url + '/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                        @click="$bvModal.hide('pass-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>
                </b-modal></div>

            <div><b-modal id="unsaved-alert-modal" title="Are you sure to close the window?" hide-footer>
                    <p class="text-center">There are unsaved data in the form.<br>Please press OK to continue:
                        <br />
                    </p>
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                        @click="hidePayslipModal()">OK</a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                        @click="$bvModal.hide('unsaved-alert-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>
                </b-modal></div>

            <div>
                <!-- <b-modal id="payslip_modal" :title="'Draft Payslip: '+fiscal_year"  size="lg" :dialog-class="'w-1200'" hide-footer  @hide="onHidden"> -->
                <!-- Mustafijur: 05-05-2026 Commented-->
                <b-modal id="payslip_modal"
                    :title="(fdata.status == '1' ? 'Approved Payslip: ' : 'Draft Payslip: ') + fiscal_year" size="lg"
                    :dialog-class="'w-1200'" hide-footer @hide="onHidden"> <!-- Mustafijur: 05-05-2026 -->

                    <div class="custom-loader-wrapper" v-if="payslip_loader">
                        <div class="text-center">
                            <span class="d-block max-450">{{ payslip_loader_text }}</span>
                            <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                                width="100px" />
                        </div>
                    </div>
                    <div style="margin: 0 30px 30px 30px;">
                        <form @submit="formSubmit" enctype="multipart/form-data">
                            <input class="input" type="hidden" v-model="fadatamodal.id">
                            <input class="input" type="hidden" v-model="employee_id">
                            <input class="input" type="hidden" v-model="fiscal_year">
                            <input class="input" type="hidden" v-model="from_date">
                            <input class="input" type="hidden" v-model="to_date">
                            <input class="input" type="hidden" v-model="pay_slip_ref">
                            <input class="input" type="hidden" v-model="pay_slip_name">

                            <span v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                v-if="salaryhead.head == 'One-off Tax Deduct'" style="display: none;">
                                {{ one_off_tx=salaryhead.value }}
                            </span>

                            <span v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                v-if="salaryhead.head == 'Monthely Tax Deduct'" style="display: none;">
                                {{ monthly_tx=salaryhead.value }}
                            </span>


                            <span v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                v-if="salaryhead.head == 'Total Tax Deduct'" style="display: none;">
                                {{ total_tx=salaryhead.value }}
                            </span>



                            <div class="row">
                                <div class="col-md-12" style="font-size: 20px;">
                                    <img v-if="fadatamodal.pic == 'demo.jpg'" :src="$api_url + '/avatar/no-image.jpg'"
                                        width="50" height="50"
                                        style="border-radius: 50%; height: auto; margin-right: 10px;">
                                    <img v-else :src="$api_url + '/avatar/' + fdata.company_id + '/' + fadatamodal.pic + ''"
                                        width="50" height="50"
                                        style="border-radius: 50%; height: auto; margin-right: 10px;">
                                    {{ fadatamodal.employee_name }}
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <span class="info-head"><b>Designation:</b>
                                    </span>&nbsp;&nbsp;&nbsp;&nbsp;{{ fadatamodal.position }}<br />
                                    <span class="info-head">Employee ID:
                                    </span>&nbsp;&nbsp;&nbsp;&nbsp;{{ fadatamodal.employee_id }}
                                </div>
                                <div class="col-md-6">
                                    <span class="info-head">Fiscal Year:
                                    </span>&nbsp;&nbsp;&nbsp;&nbsp;{{ fiscal_year }}<br />
                                    <span class="info-head">Month: </span>&nbsp;&nbsp;&nbsp;&nbsp;{{ month }}
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-md-12 border rounded mt-4">
                                    <h4 class="payslip-modal-headers px-3 py-2 mb-0 border-bottom rounded-top text-left"
                                        style="font-size: 16px;">TDS calculation at a glance</h4>
                                    <table cellpadding="10" style=" width:100%">
                                        <tr class="table-head">
                                            <td class="px-3">Gross Salary</td>
                                            <td class="px-3">Variable Pay</td>
                                            <td class="px-3">Total Deductions</td>
                                            <td class="px-3">Income Tax</td>
                                            <td class="px-3">Net Pay</td>
                                        </tr>
                                        <tr class="table-row">
                                            <!-- alpha fix- added class text-right -->
                                            <td class="px-3 text-right">
                                                <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'salary_without_additions'">
                                                    &#2547; {{ salaryhead.value.replace("-", "") }}
                                                </div>
                                            </td>

                                            <!-- alpha fix- added class text-right -->
                                            <td class="px-3 text-right">
                                                <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'total_additions'">
                                                    &#2547; {{ salaryhead.value.replace("-", "") }}
                                                </div>
                                            </td>



                                            <!-- alpha fix- added class text-right -->
                                            <td class="px-3 text-right">
                                                <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == '500'">
                                                    &#2547; {{ salaryhead.value.replace("-", "") }}
                                                </div>
                                            </td>



                                            <!-- alpha fix- added class text-right -->
                                            <td class="px-3 text-right">
                                                <div v-for="salaryhead in taxinfo" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'ait_adjusted_total_tax'">
                                                    &#2547; {{ salaryhead.value }}
                                                </div>
                                            </td>


                                            <!-- alpha fix- added class text-right -->
                                            <td class="px-3 text-right">
                                                <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == '7'">
                                                    &#2547; {{ salaryhead.value }}
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                            </div>

                            <h4 class="payslip-modal-headers px-3 py-2 mb-0 border rounded-top mt-4 text-left border-bottom-0"
                                style="font-size: 16px;">Pay Slip Summary</h4>
                            <table style="width: 100%;">
                                <tr class="table-head">
                                    <td class="pl-3 py-2" style="width: 55%;">Details</td>
                                    <!-- <td class="py-2" style="width: 5%;"></td> -->
                                    <td class="py-2 px-2" style="width: 20%;">Amount ( &#2547; )</td>
                                    <td class="pr-3 py-2" align="right" style="width: 20%;">Total ( &#2547; )</td>
                                </tr>
                            </table>
                            <div class="row accordion-block">
                                <div class="col-md-12">
                                    <div>
                                        <b-button v-b-toggle.collapse-1 variant="primary" class="custom-accordion-btn">
                                            <table style="width: 100%;">
                                                <tr style="">
                                                    <td style="width: 90%;">Fixed Salary Components</td>
                                                    <td align="right" style="width: 10%;"><i
                                                            class="fas fa-angle-down rotate-icon"></i></td>
                                                </tr>
                                            </table>
                                        </b-button>
                                        <b-collapse visible id="collapse-1" class="mt-2">
                                            <b-card>
                                                <div v-if="fixed_component_edit_status != ''" class="alert alert-success">
                                                    {{ fixed_component_edit_status }}</div>
                                                <!--<table style="width: 100%;" v-if="show_edit_div==1">-->
                                                <table style="width: 100%;">

                                                    <tr style="border-bottom: dotted 1px #ccc;">
                                                        <td>Arrear Gross Salary</td>
                                                        <td>&#2547;</td>
                                                        <td><input id="edit_gross" type="text" class="form-control"
                                                                v-model="edit_gross" name="edit_gross"
                                                                v-on:keyup="getOptimized()"></td>
                                                    </tr>

                                                    <tr style="border-bottom: dotted 1px #ccc;">
                                                        <td>Arrear Basic Salary</td>
                                                        <td>&#2547;</td>
                                                        <td><input id="edit_basic" type="text" class="form-control"
                                                                v-model="edit_basic" name="edit_basic"
                                                                v-on:keyup="calculateGross()"></td>
                                                    </tr>

                                                    <tr style="border-bottom: dotted 1px #ccc;">
                                                        <td>Arrear House Rent Allowance</td>
                                                        <td>&#2547;</td>
                                                        <td><input id="edit_hra" type="text" class="form-control"
                                                                v-model="edit_hra" name="edit_hra"
                                                                v-on:keyup="calculateGross()"></td>
                                                    </tr>

                                                    <tr style="border-bottom: dotted 1px #ccc;">
                                                        <td>Arrear Conveyance Allowance</td>
                                                        <td>&#2547;</td>
                                                        <td><input id="edit_conv" type="text" class="form-control"
                                                                v-model="edit_conv" name="edit_conv"
                                                                v-on:keyup="calculateGross()"></td>
                                                    </tr>


                                                    <tr style="border-bottom: dotted 1px #ccc;">
                                                        <td>Arrear Medical Allowance</td>
                                                        <td>&#2547;</td>
                                                        <td><input id="edit_medical" type="text" class="form-control"
                                                                v-model="edit_medical" name="edit_medical"
                                                                v-on:keyup="calculateGross()"></td>
                                                    </tr>

                                                    <template v-if="custom_gross_heads.length > 0">
                                                        <tr style="border-bottom: dotted 1px #ccc;"
                                                            v-for="(custom_gross_head, index) in custom_gross_heads"
                                                            :key="'custom_gross_head_' + (index + 1)">
                                                            <td>Arrear {{ custom_gross_head }}</td>
                                                            <td>&#2547;</td>
                                                            <td><input :id="'custom_gross_head_' + (index + 1)" type="text"
                                                                    class="form-control"
                                                                    v-model="custom_gross_heads_models[index]['value']"
                                                                    :name="'custom_gross_head_' + (index + 1)"
                                                                    v-on:keyup="calculateGross()"></td>
                                                        </tr>
                                                    </template>

                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>&nbsp;&nbsp; <a v-if="fdata.status != '1'"
                                                                href="javascript:void(0);"
                                                                class="btn btn-primary btn-full-width" block
                                                                @click="update_fixed_salary()">Update</a></td>
                                                    </tr>


                                                </table>




                                                <table style="width: 100%;" v-if="show_edit_div == 0">

                                                    <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == '1.0' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                        <template
                                                            v-if="salaryhead.field_key == 'basic_salary_before_pregross'">
                                                            <td
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                                {{ salaryhead.head }}</td>
                                                            <td
                                                                style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                            <td class="px-2"
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                                &#2547; {{ salaryhead.value }} <span class="d-block"
                                                                    v-for="salaryhead in salaryheads"
                                                                    :key="salaryhead.head"
                                                                    v-if="salaryhead.displayset == '1.0' && salaryhead.value != '0.00' && salaryhead.value != '0' && salaryhead.field_key == 'basic_salary'">[&#2547;
                                                                    {{ salaryhead.value }}]</span></td>
                                                            <td
                                                                style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                        </template>
                                                        <template
                                                            v-else-if="salaryhead.field_key == 'house_rent_before_pregross'">
                                                            <td
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                                {{ salaryhead.head }}</td>
                                                            <td
                                                                style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                            <td class="px-2"
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                                &#2547; {{ salaryhead.value }} <span class="d-block"
                                                                    v-for="salaryhead in salaryheads"
                                                                    :key="salaryhead.head"
                                                                    v-if="salaryhead.displayset == '1.0' && salaryhead.value != '0.00' && salaryhead.value != '0' && salaryhead.field_key == 'house_rent'">[&#2547;
                                                                    {{ salaryhead.value }}]</span></td>
                                                            <td
                                                                style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                        </template>
                                                        <template
                                                            v-else-if="salaryhead.field_key == 'conveyance_allowance_before_pregross'">
                                                            <td
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                                {{ salaryhead.head }}</td>
                                                            <td
                                                                style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                            <td class="px-2"
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                                &#2547; {{ salaryhead.value }} <span class="d-block"
                                                                    v-for="salaryhead in salaryheads"
                                                                    :key="salaryhead.head"
                                                                    v-if="salaryhead.displayset == '1.0' && salaryhead.value != '0.00' && salaryhead.value != '0' && salaryhead.field_key == 'conveyance_allowance'">[&#2547;
                                                                    {{ salaryhead.value }}]</span></td>
                                                            <td
                                                                style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                        </template>
                                                        <template
                                                            v-else-if="salaryhead.field_key == 'medical_allowance_before_pregross'">
                                                            <td
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                                {{ salaryhead.head }}</td>
                                                            <td
                                                                style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                            <td class="px-2"
                                                                style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                                &#2547; {{ salaryhead.value }} <span class="d-block"
                                                                    v-for="salaryhead in salaryheads"
                                                                    :key="salaryhead.head"
                                                                    v-if="salaryhead.displayset == '1.0' && salaryhead.value != '0.00' && salaryhead.value != '0' && salaryhead.field_key == 'medical_allowance'">[&#2547;
                                                                    {{ salaryhead.value }}]</span></td>
                                                            <td
                                                                style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                            </td>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="pre_gross_flag == 1">
                                                                <td class="d-none"
                                                                    style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                                    {{ salaryhead.head }}</td>
                                                                <td class="d-none"
                                                                    style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                                </td>
                                                                <td class="d-none"
                                                                    style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                                    &#2547; {{ salaryhead.value }}</td>
                                                                <td class="d-none"
                                                                    style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                                </td>
                                                            </template>
                                                            <template v-else>
                                                                <td
                                                                    style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                                    {{ salaryhead.head }}</td>
                                                                <td
                                                                    style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                                </td>
                                                                <td class="px-2"
                                                                    style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                                    &#2547; {{ salaryhead.value }}</td>
                                                                <td
                                                                    style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                                </td>
                                                            </template>
                                                        </template>
                                                    </tr>

                                                    <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == 'custom_gross_salary_components' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                        <td
                                                            style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                            {{ salaryhead.head }}</td>
                                                        <td
                                                            style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                        </td>
                                                        <td class="px-2"
                                                            style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                            &#2547; {{ salaryhead.value }}<span class="d-block"
                                                                v-if="salaryhead.value_after_pregross && salaryhead.value_after_pregross != '0.00' && salaryhead.value_after_pregross != '0'">[&#2547;
                                                                {{ salaryhead.value_after_pregross }}]</span></td>
                                                        <td
                                                            style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                        </td>
                                                    </tr>



                                                    <tr style="" v-for="salaryhead in salaryheads"
                                                        :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == 'total_fixed_salary_component' && show_edit_div == 0">
                                                        <template v-if="pre_gross_flag == 1">
                                                            <template
                                                                v-if="salaryhead.field_key == 'gross_before_pre_gross_deduction'">
                                                                <td style="padding: 10px 5px; width: 55%;"></td>
                                                                <td style="width: 5%; padding: 10px 5px;"></td>
                                                                <td class="px-2" style="padding: 10px 5px; width: 20%;">
                                                                </td>
                                                                <td align="right"
                                                                    style="width: 20%; padding: 10px 5px;">&#2547;
                                                                    {{ salaryhead.value }}<span class="d-block"
                                                                        v-for="salaryhead in salaryheads"
                                                                        :key="salaryhead.head"
                                                                        v-if="salaryhead.displayset == 'salary_without_additions' && salaryhead.head == 'Salary Without Additions'">[&#2547;
                                                                        {{ salaryhead.value }}]</span></td>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <td style="padding: 10px 5px; width: 55%;"></td>
                                                            <td style="width: 5%; padding: 10px 5px;"></td>
                                                            <td class="px-2" style="padding: 10px 5px; width: 20%;">
                                                            </td>
                                                            <td align="right" style="width: 20%; padding: 10px 5px;">
                                                                &#2547; {{ salaryhead.value }}</td>
                                                        </template>
                                                    </tr>


                                                    <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == '1.1' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                        <td
                                                            style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                            {{ salaryhead.head }} (Taxable)</td>
                                                        <td
                                                            style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                        </td>
                                                        <td class="px-2"
                                                            style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                            &#2547; {{ salaryhead.value }}</td>
                                                        <td
                                                            style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                        </td>
                                                    </tr>


                                                    <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == '2' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                        <td
                                                            style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 55%;">
                                                            {{ salaryhead.head }} (Non Taxable)</td>
                                                        <td
                                                            style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                        </td>
                                                        <td class="px-2"
                                                            style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); padding: 10px 0; width: 20%;">
                                                            &#2547; {{ salaryhead.value }}</td>
                                                        <td
                                                            style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3);">
                                                        </td>
                                                    </tr>

                                                </table>

                                            </b-card>
                                        </b-collapse>
                                    </div>
                                </div>
                            </div>

                            <div class="row accordion-block">
                                <div class="col-md-12">
                                    <b-button v-b-toggle.collapse-2 variant="primary" class="custom-accordion-btn">
                                        <table style="width: 100%;">
                                            <tr style="">
                                                <td style="width: 90%;">Variable Salary Components</td>
                                                <td align="right" style="width: 10%;"><i
                                                        class="fas fa-angle-down rotate-icon"></i></td>
                                            </tr>
                                        </table>
                                    </b-button>
                                    <b-collapse visible id="collapse-2" class="mt-2">
                                        <b-card>

                                            <table style="width: 100%;">

                                                <!--  Bonus and Incentives -->
                                                <!--<tr>
                                         <td style="padding: 10px 0; width: 55%;">Bonus and Incentives (Taxable)</td>
                                         <td style="width: 5%;"></td>
                                         <td class="px-2" style="width: 20%;"></td>
                                         <td style="width: 20%;"></td>
                                         </tr>

                                         <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"  v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'bonus_and_incentives' && salaryhead.value!='0.00' && salaryhead.value!='0'">
    						              <td class="py-1" style="padding: 10px 0; width: 55%;">{{salaryhead.head}}</td>
                                          <td class="py-1" style="width: 5%;"><a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="removeItem(salaryhead.id)"  v-if="fdata.status != '1'">-</a></td>
                                          <td class="py-1 px-2" style="width: 20%;">&#2547; {{salaryhead.value}}</td>
                                          <td class="py-1" style="width: 20%;"></td>
                                        </tr>




                                         <tr v-if="fdata.status != '1'">
                                         <td style="width: 55%;" class="py-3">
                                         <div class="row no-margin">
                                            <div class="col-md-7">
                                            <select id="bonus_incentive_field" v-model="bonus_incentive_field" name="bonus_incentive_field" class="form-control ">
                                            <option value="">Add Salary Head</option>
                                            <option v-for='ahf in bonus_incentive_fields'  :value='ahf.title'>{{ ahf.title }}</option>
                                            </select>
                                            </div>

                                            <div class="col-md-3">
                                            <input id="bonus_incentive_field_value" type="text" placeholder="" class="form-control" v-model="bonus_incentive_field_value" name="bonus_incentive_field_value">
                                            </div>

                                            <div class="col-md-2">

                                            </div>
                                         </div>

                                         </td>

                                          <td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveBonusIncentive()" >+</button></td>
                                          <td class="px-2" style="width: 20%;"></td>
                                          <td style="width: 20%;"></td>
                                         </tr>-->

                                                <!--  Adhoc allowance (Taxable) -->
                                                <tr>
                                                    <!--<td style="padding: 10px 0; width: 55%;">Adhoc allowance (Taxable)</td>-->
                                                    <td style="padding: 10px 0; width: 55%;">Bonus and Incentives
                                                        (Taxable)</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>


                                                <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.head == 'MRI Availed'">
                                                    <td style="padding: 10px 0; width: 55%;">
                                                        <div class="row">
                                                            <div class="col-md-12">

                                                                <table style="width: 100%;">
                                                                    <tr style="">
                                                                        <td style="width: 55%;"></td>
                                                                        <td style="width: 25%;"></td>
                                                                        <td style="width: 15%;"></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colspan="2">
                                                                            <div class="row">
                                                                                <div class="col-md-6">
                                                                                    Medical Reimbursement :
                                                                                </div>

                                                                                <div class="col-md-3"
                                                                                    v-if="fdata.status != '1'">
                                                                                    <input
                                                                                        v-if="medical_reimbursement_show_control != '0'"
                                                                                        id="medical_reimbursement_value"
                                                                                        type="text" class="form-control"
                                                                                        v-model="medical_reimbursement_value"
                                                                                        name="medical_reimbursement_value"
                                                                                        value="0.00">
                                                                                </div>

                                                                            </div>

                                                                        </td>

                                                                        <td></td>
                                                                    </tr>

                                                                </table>

                                                            </div>
                                                        </div>

                                                    </td>
                                                    <td style="width: 5%;"><button href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width" @click="removemri()"
                                                            v-if="fdata.status != '1' && medical_reimbursement_show_control == '0'">-</button><!--<button id="mri_add" v-if="medical_reimbursement_show_control!='0'" class="btn btn-primary btn-width btn-full-width" @click="savemri()" > + </button>-->
                                                    </td>
                                                    <td class="px-2" style="width: 20%;"><span
                                                            v-if="medical_reimbursement_show_control == '0'">&#2547;
                                                            {{ medical_reimbursement_value_display }}</span></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'adhoc' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>




                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="adhoc_field" v-model="adhoc_field"
                                                                    name="adhoc_field" class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option v-for='ahf in adhocfields'
                                                                        :value='ahf.title'>{{
                                                                        ahf.title }}</option>
                                                                    <option v-for='ahf in bonus_incentive_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="adhoc_field_value" type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="adhoc_field_value"
                                                                    name="adhoc_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveAdhoc()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Overtime and Holiday Compensation -->

                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Overtime and Holiday
                                                        Compensation
                                                        (Taxable)</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Overtime and Holiday Manual -->

                                                <!--<tr v-if="overtime_holiday_manual_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Manual Bonus</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_manual' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_manual_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_manual_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_manual_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_manual_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="overtime_holiday_manual_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_manual_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_manual_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in overtime_holiday_manual_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="overtime_holiday_manual_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_manual_field_value"
                                                                    name="overtime_holiday_manual_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeManual()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Overtime and Holiday Fixed -->
                                                <!--<tr v-if="overtime_holiday_fixed_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Fixed Bonus <b-icon
                                                            class="" icon="info-circle"
                                                            title="Please input number of days to calculate bonus"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_fixed' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_fixed_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_fixed_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_fixed_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_fixed_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="overtime_holiday_fixed_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_fixed_field"
                                                                    class="form-control"
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_fixed_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option v-for='ahf in overtime_holiday_fixed_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="overtime_holiday_fixed_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_fixed_field_value"
                                                                    name="overtime_holiday_fixed_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeFixed()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Overtime and Holiday Incremental Days -->

                                                <!--<tr v-if="overtime_holiday_incremental_days_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental Bonus (Days)
                                                        <b-icon class="" icon="info-circle"
                                                            title="Please input number of days to calculate bonus"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_incremental_days' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_days_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_days_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_days_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_days_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="overtime_holiday_incremental_days_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_incremental_days_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_days_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in overtime_holiday_incremental_days_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    id="overtime_holiday_incremental_days_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_incremental_days_field_value"
                                                                    name="overtime_holiday_incremental_days_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeIncrementalDays()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Overtime and Holiday Incremental Hours -->

                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental Bonus (Hours)
                                                        <b-icon class="" icon="info-circle"
                                                            title="Please input number of hours to calculate bonus"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_incremental_hours' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_hours_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_hours_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_hours_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_hours_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="overtime_holiday_incremental_hours_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_incremental_hours_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_hours_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in overtime_holiday_incremental_hours_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    id="overtime_holiday_incremental_hours_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_incremental_hours_field_value"
                                                                    name="overtime_holiday_incremental_hours_field_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeIncrementalHours()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>


                                                <!--  Non taxable Adhoc starts-->

                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Adhoc allowance (Non
                                                        Taxable)</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'adhoc_nontax' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_nontax_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_nontax_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="adhoc_nontaxable_field"
                                                                    v-model="adhoc_field" name="adhoc_nontaxable_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_nontax_arr)">
                                                                    <option value="">Non-Taxable Head</option>
                                                                    <option v-for='anthf in adhocnontaxablefields'
                                                                        :value='anthf.title'>{{ anthf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="adhoc_nontaxable_field_value" type="text"
                                                                    class="form-control d-none"
                                                                    v-model="adhoc_nontaxable_field_value"
                                                                    name="adhoc_nontaxable_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td style="width: 5%;" class="py-3"><button class="btn btn-primary btn-full-width" @click="saveAdhocnontaxable()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Non taxable Overtime and Holiday Compensation -->

                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Overtime and Holiday
                                                        Compensation
                                                        (Non taxable)</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Non taxable Overtime and Holiday Manual -->

                                                <!--<tr v-if="overtime_holiday_manual_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Manual Bonus Non taxable
                                                    </td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_manual_non_taxable' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_manual_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_manual_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_nontax_manual_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_nontax_manual_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="overtime_holiday_manual_non_taxable_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_manual_non_taxable_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_nontax_manual_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in overtime_holiday_manual_non_taxable_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    id="overtime_holiday_manual_non_taxable_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_manual_non_taxable_field_value"
                                                                    name="overtime_holiday_manual_non_taxable_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeManualNonTaxable()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Non taxable Overtime and Holiday Fixed -->
                                                <!--<tr v-if="overtime_holiday_fixed_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Fixed Bonus Non taxable
                                                        <b-icon class="" icon="info-circle"
                                                            title="Please input number of days to calculate bonus"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_fixed_non_taxable' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_fixed_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_fixed_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_nontax_fixed_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_nontax_fixed_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="overtime_holiday_fixed_non_taxable_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_fixed_non_taxable_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_nontax_fixed_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in overtime_holiday_fixed_non_taxable_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    id="overtime_holiday_fixed_non_taxable_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_fixed_non_taxable_field_value"
                                                                    name="overtime_holiday_fixed_non_taxable_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeFixedNonTaxable()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Non taxable Overtime and Holiday Incremental Days -->

                                                <!--<tr v-if="overtime_holiday_incremental_days_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental Bonus (Days)
                                                        Non
                                                        taxable <b-icon class="" icon="info-circle"
                                                            title="Please input number of days to calculate bonus"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_incremental_days_non_taxable' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_days_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_days_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_nontax_days_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_nontax_days_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select
                                                                    id="overtime_holiday_incremental_days_non_taxable_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_incremental_days_non_taxable_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_nontax_days_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in overtime_holiday_incremental_days_non_taxable_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    id="overtime_holiday_incremental_days_non_taxable_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_incremental_days_non_taxable_field_value"
                                                                    name="overtime_holiday_incremental_days_non_taxable_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeIncrementalDaysNonTaxable()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Non taxable Overtime and Holiday Incremental Hours -->

                                                <!--<tr v-if="overtime_holiday_incremental_days_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental Bonus (Hours)
                                                        Non
                                                        taxable <b-icon class="" icon="info-circle"
                                                            title="Please input number of hours to calculate bonus"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'overtime_holiday_incremental_hours_non_taxable' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_hours_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_nontax_hours_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_nontax_hours_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_nontax_hours_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select
                                                                    id="overtime_holiday_incremental_hours_non_taxable_field"
                                                                    v-model="adhoc_field"
                                                                    name="overtime_holiday_incremental_hours_non_taxable_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_nontax_hours_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in overtime_holiday_incremental_hours_non_taxable_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    id="overtime_holiday_incremental_hours_non_taxable_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="overtime_holiday_incremental_hours_non_taxable_field_value"
                                                                    name="overtime_holiday_incremental_hours_non_taxable_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="saveOvertimeIncrementalHoursNonTaxable()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>
                                                <!--<tr style="" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_taxable_adhoc'">
        							            <td style="padding: 10px 5px; width: 55%;"></td>
        							            <td style="padding: 10px 5px; width: 5%;"></td>
        							            <td style="padding: 10px 5px; width: 20%;"></td>
                                                <td align="right" style="padding: 10px 5px; width: 20%;">&#2547; {{salaryhead.value}}</td>
                                         </tr>-->

                                                <!-- Contracted Bonus starts -->

                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Contracted Bonus</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'contracted_variable_payslip' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_contracted_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_adhc_fields_contracted_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_adhc_fields_contracted_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_adhc_fields_contracted_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="contracted_variable_field"
                                                                    v-model="adhoc_field"
                                                                    name="contracted_variable_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_adhc_fields_contracted_arr)">
                                                                    <option value="">Contracted Bonus Head</option>
                                                                    <option v-for='cvf in contracted_variable_fields'
                                                                        :value='cvf.title'>{{ cvf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="contracted_variable_field_value" type="text"
                                                                    class="form-control d-none"
                                                                    v-model="contracted_variable_field_value"
                                                                    name="contracted_variable_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td style="width: 5%;" class="py-3"><button class="btn btn-primary btn-full-width" @click="saveContractedVariable()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.head == 'Gross Pay' && show_edit_div == 0"
                                                    style="background: #DDF5F9;">
                                                    <!-- Mustafijur: 12-05-2026 Added style="background: #DDF5F9;"-->
                                                    <td class="gross-salary" style="width: 55%; padding-left: 10px;">
                                                        {{ salaryhead.head }}</td> <!-- Mustafijur: 17-05-2026 padding -->
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td class="p-2" align="right" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                </tr>


                                                <tr v-if="show_edit_div == 1">
                                                    <td class="gross-salary" style="width: 55%;">
                                                        <!--<b-button v-b-toggle.collapse-GS variant="primary" class="custom-accordion-btn">Arrear Gross </b-button>-->
                                                    </td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>
                                            </table>

                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>



                            <!--fixed deduction starts-->
                            <div class="row accordion-block">
                                <div class="col-md-12">
                                    <b-button v-b-toggle.collapse-3 variant="primary" class="custom-accordion-btn">
                                        <table style="width: 100%;">
                                            <tr style="">
                                                <td style="width: 90%;">Fixed Deduction Components</td>
                                                <td align="right" style="width: 10%;"><i
                                                        class="fas fa-angle-down rotate-icon"></i></td>
                                            </tr>
                                        </table>
                                    </b-button>
                                    <!-- Card body -->
                                    <b-collapse visible id="collapse-3" class="mt-2">
                                        <b-card>

                                            <table style="width: 100%;">
                                                <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.head == 'Employer\'s Contribution to PF' && salaryhead.value != '0' && salaryhead.value != '-0'">
                                                    <td
                                                        style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 55%; padding: 10px 0;">
                                                        {{ salaryhead.head }}</td>
                                                    <td
                                                        style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)">
                                                    </td>
                                                    <td class="px-2"
                                                        style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 20%; padding: 10px 0;">
                                                        &#2547; {{ salaryhead.value }}</td>
                                                    <td
                                                        style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)">
                                                    </td>
                                                </tr>
                                                <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.head == 'Arrear Employer\'s Contribution to PF' && salaryhead.value != '0' && salaryhead.value != '-0'">
                                                    <td
                                                        style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 55%; padding: 10px 0;">
                                                        {{ salaryhead.head }}</td>
                                                    <td
                                                        style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)">
                                                    </td>
                                                    <td class="px-2"
                                                        style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 20%; padding: 10px 0;">
                                                        &#2547; {{ salaryhead.value }}</td>
                                                    <td
                                                        style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)">
                                                    </td>
                                                </tr>
                                                <tr v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == '5' && salaryhead.value != '0' && salaryhead.value != '-0'">
                                                    <td
                                                        style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 55%; padding: 10px 0;">
                                                        {{ salaryhead.head }}</td>
                                                    <td
                                                        style="width: 5%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)">
                                                    </td>
                                                    <td class="px-2"
                                                        style="border-bottom: solid 1px rgba(204, 204, 204, 0.3); width: 20%; padding: 10px 0;">
                                                        &#2547; {{ salaryhead.value }}</td>
                                                    <td
                                                        style="width: 20%; border-bottom: solid 1px rgba(204, 204, 204, 0.3)">
                                                    </td>
                                                </tr>
                                            </table>

                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>






                            <!--variable deduction starts-->
                            <div class="row accordion-block">
                                <div class="col-md-12">
                                    <b-button v-b-toggle.collapse-4 variant="primary" class="custom-accordion-btn">
                                        <table style="width: 100%;">
                                            <tr style="">
                                                <td style="width: 90%;">Variable Deduction Components</td>
                                                <td align="right" style="width: 10%;"><i
                                                        class="fas fa-angle-down rotate-icon"></i></td>
                                            </tr>
                                        </table>
                                    </b-button>
                                    <!-- Card body -->
                                    <b-collapse visible id="collapse-4" class="mt-2">
                                        <b-card class="rounded-bottom">

                                            <table style="width: 100%;">

                                                <tr>
                                                    <td>Pre Gross Deduction</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'pre_adhoc_deduction' && salaryhead.value != '0.00' && salaryhead.value != '0'">

                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_pre_deduction_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_pre_deduction_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_pre_deduction_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_pre_deduction_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="adhoc_pre_deduction_field"
                                                                    v-model="adhoc_field"
                                                                    name="adhoc_pre_deduction_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_pre_deduction_fields_arr)">
                                                                    <option value="">Add Deduction Head</option>
                                                                    <option v-for='adhf in adhocpredeductionfields'
                                                                        :value='adhf.title'>{{ adhf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="adhoc_pre_deduction_field_value" type="text"
                                                                    class="form-control d-none"
                                                                    v-model="adhoc_pre_deduction_field_value"
                                                                    name="adhoc_pre_deduction_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td style="width: 5%;" class="py-3"><button class="btn btn-primary btn-full-width" @click="savePreAdhocdeduction()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Pre Gross LOP -->

                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Pre Gross LOP</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Manual LOP -->

                                                <!--<tr v-if="overtime_holiday_manual_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Manual LOP</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'pre_deduction_manual' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_pre_manual_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_pre_manual_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_pre_manual_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_pre_manual_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="pre_deduction_manual_field"
                                                                    v-model="adhoc_field"
                                                                    name="pre_deduction_manual_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_pre_manual_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option v-for='ahf in pre_deduction_manual_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="pre_deduction_manual_field_value" type="text"
                                                                    placeholder="" class="form-control d-none"
                                                                    v-model="pre_deduction_manual_field_value"
                                                                    name="pre_deduction_manual_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePreLopManual()" >+</button></td> -->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Fixed LOP -->
                                                <!--<tr v-if="overtime_holiday_fixed_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Fixed LOP <b-icon class=""
                                                            icon="info-circle"
                                                            title="Please input number of days to calculate LOP"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'pre_deduction_fixed' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_pre_fixed_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_pre_fixed_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_pre_fixed_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_pre_fixed_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="pre_deduction_fixed_field"
                                                                    v-model="adhoc_field"
                                                                    name="pre_deduction_fixed_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_pre_fixed_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option v-for='ahf in pre_deduction_fixed_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="pre_deduction_fixed_field_value" type="text"
                                                                    placeholder="" class="form-control d-none"
                                                                    v-model="pre_deduction_fixed_field_value"
                                                                    name="pre_deduction_fixed_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePreLopFixed()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Incremental LOP (Days) -->

                                                <!--<tr v-if="overtime_holiday_incremental_days_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental LOP (Days)
                                                        <b-icon class="" icon="info-circle"
                                                            title="Please input number of days to calculate LOP"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'pre_deduction_incremental_days' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_pre_days_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_pre_days_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_pre_days_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_pre_days_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="pre_deduction_incremental_days_field"
                                                                    v-model="adhoc_field"
                                                                    name="pre_deduction_incremental_days_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_pre_days_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in pre_deduction_incremental_days_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="pre_deduction_incremental_days_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="pre_deduction_incremental_days_field_value"
                                                                    name="pre_deduction_incremental_days_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePreLopIncrementalDays()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Incremental LOP (Hours) -->

                                                <!--<tr v-if="overtime_holiday_incremental_days_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental LOP (Hours)
                                                        <b-icon class="" icon="info-circle"
                                                            title="Please input number of hours to calculate LOP"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'pre_deduction_incremental_hours' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_pre_hours_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_pre_hours_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_pre_hours_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_pre_hours_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="pre_deduction_incremental_hours_field"
                                                                    v-model="adhoc_field"
                                                                    name="pre_deduction_incremental_hours_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_pre_hours_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in pre_deduction_incremental_hours_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="pre_deduction_incremental_hours_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="pre_deduction_incremental_hours_field_value"
                                                                    name="pre_deduction_incremental_hours_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePreLopIncrementalHours()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!----------------------------------------------------------------------------------------------------------------------------->


                                                <tr>
                                                    <td>Post Gross Deduction</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'adhoc_deduction' && salaryhead.value != '0.00' && salaryhead.value != '0'">

                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_post_deduction_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_post_deduction_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_post_deduction_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_post_deduction_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="adhoc_deduction_field" v-model="adhoc_field"
                                                                    name="adhoc_deduction_field" class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_post_deduction_fields_arr)">
                                                                    <option value="">Select Deduction Head</option>
                                                                    <option v-for='adhf in adhocdeductionfields'
                                                                        :value='adhf.title'>{{ adhf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="adhoc_deduction_field_value" type="text"
                                                                    class="form-control d-none"
                                                                    v-model="adhoc_deduction_field_value"
                                                                    name="adhoc_deduction_field_value">
                                                            </div>

                                                            <div class="col-md-2">
                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td style="width: 5%;" class="py-3"><button class="btn btn-primary btn-full-width" @click="saveAdhocdeduction()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Post Gross LOP -->

                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Post Gross LOP</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Manual LOP -->

                                                <!--<tr v-if="overtime_holiday_manual_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Manual LOP</td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'post_deduction_manual' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_post_manual_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_post_manual_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_post_manual_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_post_manual_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="post_deduction_manual_field"
                                                                    v-model="adhoc_field"
                                                                    name="post_deduction_manual_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_post_manual_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option v-for='ahf in post_deduction_manual_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="post_deduction_manual_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="post_deduction_manual_field_value"
                                                                    name="post_deduction_manual_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePostLopManual()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Fixed LOP -->
                                                <!--<tr v-if="overtime_holiday_fixed_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Fixed LOP <b-icon class=""
                                                            icon="info-circle"
                                                            title="Please input number of days to calculate LOP"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'post_deduction_fixed' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>

                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_post_fixed_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_post_fixed_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_post_fixed_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_post_fixed_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="post_deduction_fixed_field"
                                                                    v-model="adhoc_field"
                                                                    name="post_deduction_fixed_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_post_fixed_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option v-for='ahf in post_deduction_fixed_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="post_deduction_fixed_field_value" type="text"
                                                                    placeholder="" class="form-control d-none"
                                                                    v-model="post_deduction_fixed_field_value"
                                                                    name="post_deduction_fixed_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePostLopFixed()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Incremental LOP (Days) -->

                                                <!--<tr v-if="overtime_holiday_incremental_days_fields.length > 0">-->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental LOP (Days)
                                                        <b-icon class="" icon="info-circle"
                                                            title="Please input number of days to calculate LOP"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'post_deduction_incremental_days' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_post_days_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_post_days_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_post_days_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_post_days_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="post_deduction_incremental_days_field"
                                                                    v-model="adhoc_field"
                                                                    name="post_deduction_incremental_days_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_post_days_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in post_deduction_incremental_days_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="post_deduction_incremental_days_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="post_deduction_incremental_days_field_value"
                                                                    name="post_deduction_incremental_days_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePostLopIncrementalDays()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!--  Incremental LOP (Hours) -->
                                                <tr>
                                                    <td style="padding: 10px 0; width: 55%;">Incremental LOP (Hours)
                                                        <b-icon class="" icon="info-circle"
                                                            title="Please input number of hours to calculate LOP"
                                                            v-b-tooltip></b-icon></td>
                                                    <td style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <tr style="border-bottom: solid 1px rgba(204, 204, 204, 0.3);"
                                                    v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                    v-if="salaryhead.displayset == 'post_deduction_incremental_hours' && salaryhead.value != '0.00' && salaryhead.value != '0'">
                                                    <td class="py-1" style="padding: 10px 0; width: 55%;">
                                                        {{ salaryhead.head }}
                                                    </td>
                                                    <td class="py-1" style="width: 5%;"><a href="javascript:void(0);"
                                                            class="btn btn-primary btn-full-width"
                                                            @click="removeItem(salaryhead.id)"
                                                            v-if="fdata.status != '1'">-</a>
                                                    </td>
                                                    <td class="py-1 px-2" style="width: 20%;">&#2547;
                                                        {{ salaryhead.value }}</td>
                                                    <td class="py-1" style="width: 20%;"></td>
                                                </tr>


                                                <tr v-if="fdata.status != '1'">
                                                    <td style="width: 55%;" class="py-3">
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <template
                                                                    v-for="(add_adhc_field, index) in add_post_hours_fields_arr">
                                                                    <input :key="index" type="text" placeholder=""
                                                                        class="form-control mb-2"
                                                                        v-model="add_adhc_field.title" readonly
                                                                        name="adhoc_field_title[]"><b-icon
                                                                        v-if="add_adhc_field.has_data == 'yes'"
                                                                        class="ml-2" icon="info-circle"
                                                                        title="This action will overwrite the existing head in the pay slip"
                                                                        v-b-tooltip></b-icon>
                                                                </template>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input
                                                                    v-for="(add_adhc_field, index) in add_post_hours_fields_arr"
                                                                    :key="index" type="text" placeholder=""
                                                                    class="form-control mb-2"
                                                                    v-model="add_adhc_field.value"
                                                                    name="adhoc_field_value[]">
                                                            </div>

                                                            <div class="col-md-2">
                                                                <a v-for="(add_adhc_field, index) in add_post_hours_fields_arr"
                                                                    :key="index" href="javascript:void(0);"
                                                                    class="btn btn-primary btn-full-width mb-2"
                                                                    @click="removeBonusItem(add_adhc_field.title, add_post_hours_fields_arr)">-</a>
                                                            </div>
                                                        </div>
                                                        <div class="row no-margin">
                                                            <div class="col-md-7">
                                                                <select id="post_deduction_incremental_hours_field"
                                                                    v-model="adhoc_field"
                                                                    name="post_deduction_incremental_hours_field"
                                                                    class="form-control "
                                                                    @change="addAdhcFields(adhoc_field, add_post_hours_fields_arr)">
                                                                    <option value="">Add Salary Head</option>
                                                                    <option
                                                                        v-for='ahf in post_deduction_incremental_hours_fields'
                                                                        :value='ahf.title'>{{ ahf.title }}</option>
                                                                </select>
                                                            </div>

                                                            <div class="col-md-3">
                                                                <input id="post_deduction_incremental_hours_field_value"
                                                                    type="text" placeholder=""
                                                                    class="form-control d-none"
                                                                    v-model="post_deduction_incremental_hours_field_value"
                                                                    name="post_deduction_incremental_hours_field_value">
                                                            </div>

                                                            <div class="col-md-2">

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <!--<td class="py-1" style="width: 5%;"><button class="btn btn-primary btn-full-width" @click="savePostLopIncrementalHours()" >+</button></td>-->
                                                    <td class="py-1" style="width: 5%;"></td>
                                                    <td class="px-2" style="width: 20%;"></td>
                                                    <td style="width: 20%;"></td>
                                                </tr>

                                                <!----------------------------------------------------------------------------------------------------------------------------->
                                            </table>

                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>



                            <!-- Investment and AIT Adjustment Starts -->
                            <!--
                             <br />
                             <div class="row">
                                <div class="col-md-12">
                                 <b-card>

                                 <table style="width: 100%;">
                                 <tr style=""> <td style="width: 55%;"></td> <td style="width: 25%;"></td> <td style="width: 15%;"></td> </tr>

                                <tr v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.displayset == 'max_investment_limit'">
							              <td colspan="3">(Assumed Max allowable yearly investment &#2547; {{taxhead.value}} for tax rebet benifit)</td>
                                </tr>

                                <tr v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.displayset == 'investment_rebet'">
							              <td colspan="3">(Investment Rebet/ Tax Credit &#2547; {{taxhead.value}})</td>
                                </tr>

                                <tr v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.displayset == 'invested_amount'">
							              <td colspan="3">(Actual Investment till now &#2547; {{taxhead.value}})</td>
                                </tr>


                                 <tr> <td colspan="2"> &nbsp; </td> </tr>

                                 <tr>
                                 <td colspan="2">
                                 <div class="row">
                                 <div class="col-md-12 p-top">
                                 <span class="col-md-12 p-top" v-if="ait_adjust_value>0">
                                        AIT Adjustment : &#2547; {{ait_adjust_value}}
                                 </span>
                                 <span class="col-md-9 p-top" v-else>
                                        AIT Adjustment : &#2547; 0
                                        </span>

                                 (Cumulative Amount : <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'ait_adjustment'">
							              &#2547; {{salaryhead.annual}}
                                </span>)


                                    </div>

                                    <div class="col-md-3" style="display: none;">
                                    <input id="ait_adjust_value" type="text" class="form-control" v-model="ait_adjust_value" name="ait_adjust_value" value="0.00">
                                    </div>


                                    </div>
                                 </td>

                                  <td></td>
                                 </tr>

                                 </table>

                                 </b-card>
                                 </div>
                             </div>


                             <br /> -->


                            <b-card>
                                <div class="row">
                                    <div class="col-md-3">
                                        <h4 class="summery-header">Summary</h4>
                                    </div>

                                    <div class="col-md-9">
                                        <table cellpadding="5" style=" width:100%">
                                            <tr>
                                                <td>Gross Salary</td>
                                                <td>Variable Pay</td>
                                                <td>Total Deductions</td>
                                                <td>Income Tax</td>
                                                <td>Net Pay</td>
                                            </tr>
                                            <tr>

                                                <td>
                                                    <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == 'salary_without_additions'">
                                                        &#2547; {{ salaryhead.value.replace("-", "") }}
                                                    </div>
                                                </td>

                                                <td>
                                                    <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == 'total_additions'">
                                                        &#2547; {{ salaryhead.value.replace("-", "") }}
                                                    </div>
                                                </td>



                                                <td>
                                                    <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == '500'">
                                                        &#2547; {{ salaryhead.value.replace("-", "") }}
                                                    </div>
                                                </td>



                                                <td>
                                                    <div v-for="salaryhead in taxinfo" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == 'ait_adjusted_total_tax'">
                                                        &#2547; {{ salaryhead.value }}
                                                    </div>
                                                </td>


                                                <td>
                                                    <div v-for="salaryhead in salaryheads" :key="salaryhead.head"
                                                        v-if="salaryhead.displayset == '7'">
                                                        &#2547; {{ salaryhead.value }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </b-card>

                            <br />
                            <!-- alpha fix commented this  -->
                            <!-- <div align="right" style="float: right; bottom: 20px;" v-if="fdata.status != '1'" class="position-sticky w-100 bg-white">
                                   <a href="javascript:void(0);" class="btn btn-primary btn-width"  @click="reviewed(fadatamodal.id)">Reviewed</a>
                                  &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-width" block @click="$bvModal.hide('payslip_modal')">Close</a>
                                  &nbsp;&nbsp; <button class="btn btn-primary btn-width" @click="formSubmit" >Update</button>
                                  </div> -->

                                  <!-- alpha fix added this  -->
                            <div align="right" style="" class="w-100 mt-4 text-center">
                                <a href="javascript:void(0);" class="btn btn-primary btn-width"
                                    @click="reviewed(fadatamodal.id)">Reviewed</a>
                                &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-width" block
                                    @click="$bvModal.hide('payslip_modal')">Close</a>
                                &nbsp;&nbsp; <button class="btn btn-primary btn-width"
                                    @click="formSubmit">Update</button>
                            </div>
                        </form>


                        <!-- Modal Content Ends -->
                    </div>
                </b-modal>
            </div>


            <!--Challan Modal Starts-->

            <div>
                <b-modal id="challan_modal" :title="'Challan'" size="lg" hide-footer>

                    <b-card>
                        <form @submit="challanformSubmit" enctype="multipart/form-data">
                            <div class="form-group row">
                                <label for="name" class="col-md-3 col-form-label">Challan Title: </label>
                                <div class="col-md-9">
                                    <input id="challan_title" type="text" class="form-control"
                                        v-model="challanfdata.challan_title" name="challan_title">
                                </div>
                            </div>


                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Company Code:</label> <br />
                                    <input id="company_code" type="text" class="form-control" v-model="company_code"
                                        name="company_code" disabled>
                                </div>

                                <div class="col-md-4">
                                    <label>Month:</label> <br />
                                    <select id="month" v-model="challanfdata.month" name="Month" required
                                        class="form-control" disabled>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                </div>

                                <div class="col-md-4">
                                    <label>Fiscal year:</label> <br />
                                    <input id="year" type="text" class="form-control" v-model="challanfdata.fiscal_year"
                                        required name="year" placeholder="Year" disabled>
                                </div>
                            </div>



                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Cheque No:</label> <br />
                                    <input id="cheque_no" type="text" class="form-control"
                                        v-model="challanfdata.cheque_no" name="cheque_no">
                                </div>

                                <div class="col-md-4">
                                    <label>Cheque Date:</label> <br />
                                    <b-form-datepicker id="cheque_date" type="text" class="form-control"
                                        v-model="challanfdata.cheque_date" name="cheque_date"></b-form-datepicker>
                                </div>



                                <div class="col-md-4">
                                    <label>Bank Name:</label> <br />
                                    <input id="bank_name" type="text" class="form-control"
                                        v-model="challanfdata.bank_name" name="bank_name">
                                </div>
                            </div>



                            <div class="form-group row">
                                <div class="col-md-6">
                                    <label>Add People <br> in the Challan List</label> <br />
                                    <input type="hidden" v-model="current_employee_id">
                                    <input type="hidden" v-model="current_employee_etin">
                                    <input class="form-control" type="text" v-model="challansearch.name"
                                        placeholder="Search People.." @input="challansetSearch()">

                                    <table class="list1" id="employee_dropdown"
                                        style="width: 91%; border: 1px solid #CCC; border-collapse:separate; border-radius:6px; -moz-border-radius:6px; position: absolute; z-index: 9999999; background-color: #FFFFFF; display: none;">
                                        <tr v-for="user in users" :key="user.employee_id"
                                            style="border-bottom: 1px solid #CCC;">
                                            <td style="min-width:200px" v-if="user.etin == ''"> <a
                                                    style="cursor:pointer;"
                                                    @click="chooseemployee(user.name, user.employee_id, user.etin)">{{ user.name }}</a>
                                            </td>
                                            <td style="min-width:200px" v-if="user.etin != ''"> <a
                                                    style="cursor:pointer;"
                                                    @click="chooseemployee(user.name, user.employee_id, user.etin)">{{ user.name }}-eTIN-{{ user.etin }}</a>
                                            </td>
                                        </tr>
                                    </table>


                                </div>

                                <div class="col-md-2">
                                    <label>TDS</label> <br /><br />

                                    <input id="tds_field" type="text" class="form-control" v-model="tds_field"
                                        name="tds_field">
                                </div>



                                <div class="col-md-2">
                                    <label>TDS (Remaining):</label> <br />

                                    <input id="tds_remaining" type="text" class="form-control" v-model="tds_remaining"
                                        required name="tds_remaining" disabled>

                                </div>

                                <div class="col-md-2">
                                    <label> &nbsp;</label> <br /><br />

                                    <a class="btn btn-primary btn-full-width" @click="addemployee()"
                                        style="color: #FFFFFF;">+Add</a>

                                </div>


                            </div>

                            <div v-if="employee_counter != '0'">
                                <table class="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <td>Name</td>
                                            <td>eTIN</td>
                                            <td>TDS (&#2547;)</td>
                                            <td>Actions</td>
                                        </tr>

                                    </thead>
                                    <tbody>


                                        <tr v-for="(value, index) in employeenames" :key="index">
                                            <td style="min-width:200px">{{ value }} </td>
                                            <td> {{ employeeetins[index] }} </td>
                                            <td> {{ employeetds[index] }} </td>
                                            <td>&nbsp;&nbsp;&nbsp;&nbsp;<a style="cursor:pointer; color:blue;"
                                                    @click="removeemployee(index)">Remove</a></td>
                                        </tr>


                                        <tr>
                                            <td colspan="2">TDS Total (&#2547;)</td>

                                            <td colspan="2">{{ tds_total }}</td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <br />
                            <div class="form-group row">
                                <div class="col-md-6">
                                    <label>Payee: </label> <br />
                                    <textarea class="form-control" v-model="challanfdata.payee" rows="5"
                                        placeholder=""></textarea>
                                </div>

                                <div class="col-md-6">
                                    <label>Paying For: </label> <br />
                                    <textarea class="form-control" v-model="challanfdata.paying_for" rows="5"
                                        placeholder=""></textarea>
                                </div>
                            </div>


                            <br />
                            <div class="form-group row">
                                <div class="col-md-6">
                                    <label>Payment Reason: </label> <br />
                                    <textarea class="form-control" v-model="challanfdata.citation" rows="5"
                                        placeholder=""></textarea>
                                </div>
                            </div>


                            <div class="form-group row">
                                <div class="col-md-10">
                                    &nbsp;
                                </div>

                                <div class="col-md-2">
                                    <button class="btn btn-primary btn-full-width"
                                        v-if="employeenames.length > 0">Submit</button>
                                    <div v-if="employeenames.length < 1" v-b-tooltip.hover
                                        title="Add an Employee to Submit"> <a class="btn btn-primary disabled"
                                            style="color: #FFFFFF;">Submit</a></div>

                                </div>
                            </div>
                        </form>
                    </b-card>
                </b-modal>
            </div>

            <!-- New payslip Modal Starts-->

            <div>
                <b-modal id="new_payslip_modal" title="Create a New Pay Slip" size="lg" hide-footer>
                    <!-- Modal Content Starts -->
                    <b-card style="">

                        <div class="card-body p-0">
                            <div v-if="success_np != ''" class="alert alert-success" role="alert"> {{ success_np }} </div>
                            <form @submit="newpayslipformSubmit" enctype="multipart/form-data">
                                <div class="form-group row">
                                    <label for="status" class="col-md-4 col-form-label">Employee</label>
                                    <div class="col-md-12">
                                        <div class="">
                                            <div class="align-self-center custom-search pr-0 mt-2"
                                                style="max-width: 480px;">
                                                <b-input-group>
                                                    <b-input-group-prepend is-text>
                                                        <b-icon icon="search"></b-icon>
                                                    </b-input-group-prepend>
                                                    <b-form-input type="search"
                                                        placeholder="Search by employee / position / code / branch / email / phone"
                                                        v-model="this_search" @input="resetPagination()"></b-form-input>
                                                </b-input-group>
                                            </div>
                                            <!-- <table class="list1 bg-white w-100 opacity-0" id="employee_dropdown_payslip" style="border: 1px solid #CCC; border-collapse:separate; border-radius:0.25rem; -moz-border-radius:0.25rem; position: absolute; z-index: 9999999; display: none;">
                    <tr v-for="emply in paginatedData" :key="emply.employee_id" style="border-bottom: 1px solid #CCC; display: block;">
                        <td style="min-width:200px" class="border-bottom px-3 py-2 d-block"> <a style="cursor:pointer;"  @click="choosenewpayslip(emply.name, emply.employee_id)">{{emply.name}}</a></td>
                    </tr>
                </table> -->
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-3 employee-table-wrapper">
                                        <!-- <div class="d-none">
                <select id="employee_np" v-model="employee_np" name="employee_np" required class="form-control ">
                    <option value="">Select an Employee</option>
    			    <option v-for='emply in paginatedData'  :value='emply.employee_id'>{{ emply.name }}</option>
    		    </select>
            </div> -->
                                        <!-- <table class="employee-list-table dataTable table-overflow table-sticky"> -->
                                        <table class="employee-list-table table-overflow table-sticky">
                                            <thead>
                                                <tr class="table-head ">
                                                     <!-- alpha fix- added class text-center  -->
                                                    <td class="text-center"><input type="checkbox" v-model="selectAllNewEmployee"
                                                            class=""><label style="width: 15px; height: 15px;"></label>
                                                    </td>
                                                    <td class="sorting"><span class="pr-2">Name</span></td>
                                                    <td class="sorting"><span class="pr-2">Mobile Number</span></td>
                                                    <td class="sorting"><span class="pr-2">Email</span></td>
                                                    <td class="sorting"><span class="pr-2">Job Position</span></td>
                                                    <td class="sorting"><span class="pr-2">Department</span></td>
                                                    <td class="sorting"><span class="pr-2">Work Location</span></td>
                                                    <td class="sorting"><span class="pr-2">Employee Code</span></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="table-row hover-bg" v-for='emply in paginatedData'
                                                    :key="emply.employee_id">
                                                    <!-- alpha fix- added class text-center  -->
                                                    <td class="text-center"><input type="checkbox" class="justify-content-center"
                                                            v-model="employee_np" :value="emply.employee_id"
                                                            number><label class="mb-0 custom-label"
                                                            style="width: 15px; height: 15px;"></label></td>
                                                    <td>{{ emply.name }}</td>
                                                    <td>{{ emply.phone }}</td>
                                                    <td>{{ emply.email }}</td>
                                                    <td>{{ emply.jobposition }}</td>
                                                    <td>{{ emply.department }}</td>
                                                    <td>{{ emply.branch }}</td>
                                                    <td>{{ emply.employee_code }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                                            <li class="page-item disabled m-2">View</li>
                                            <li class="page-item disabled"><b-form-select v-model="temp_length"
                                                    :options="length_options_np"
                                                    @change="setFirstPage()"></b-form-select></li>
                                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.
                                            </li>
                                        </ul>
                                        <b-pagination-nav class="float-right mt-1" v-model="this_pagination.currentPage"
                                            :number-of-pages="this_pagination.pages" prev-text="Previous"
                                            next-text="Next" base-url="#" first-number last-number></b-pagination-nav>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="mt-3 text-center">
                                        <button class="btn btn-primary">Create Pay Slip</button>
                                        <span v-if="new_payslip_loading != ''"><img
                                                :src="$api_url + '/images/loading.gif'" width="30"></span>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </b-card>

                    <!-- Modal Content Ends -->
                </b-modal>
            </div>

            <div>
                <b-modal id="new_payslip_modal_manual" title="Create manual pay Slip(s)" size="lg" hide-footer>
                    <!-- Modal Content Starts -->
                    <b-card style="">

                        <div class="card-body p-0">
                            <div v-if="success_np != ''" class="alert alert-success" role="alert"> {{ success_np }} </div>
                            <form @submit="newpayslipformSubmitManual" enctype="multipart/form-data">
                                <div class="row no-margin">
                                    <label for="status" class="col-md-4 col-form-label px-0">Employee</label>
                                    <div class="col-md-12 px-0">
                                        <div class="">
                                            <div class="align-self-center custom-search pr-0 mt-2"
                                                style="max-width: 480px;">
                                                <b-input-group>
                                                    <b-input-group-prepend is-text>
                                                        <b-icon icon="search"></b-icon>
                                                    </b-input-group-prepend>
                                                    <b-form-input type="search"
                                                        placeholder="Search by employee / position / code / branch / email / phone"
                                                        v-model="this_search" @input="resetPagination()"></b-form-input>
                                                </b-input-group>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 employee-table-wrapper mt-3 px-0">
                                        <!-- <b-form-group label="" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group id="employee_np_manual" class="row" v-model="employee_np_manual" :aria-describedby="ariaDescribedby" name="employee_np_manual">
                    <b-form-checkbox class="col-md-6 mr-0" v-for='emply in paginatedData' :value="emply.employee_id" :key="emply.employee_id">{{emply.name}}</b-form-checkbox>
                </b-form-checkbox-group>
            </b-form-group> -->
                                        <table class="employee-list-table dataTable table-overflow table-sticky">
                                            <thead>
                                                <tr class="table-head ">
                                                    <td class=""><input type="checkbox"
                                                            v-model="selectAllNewEmployeeManual" class=""><label
                                                            style="width: 15px; height: 15px;"></label></td>
                                                    <td class="sorting"><span class="pr-2">Name</span></td>
                                                    <td class="sorting"><span class="pr-2">Mobile Number</span></td>
                                                    <td class="sorting"><span class="pr-2">Email</span></td>
                                                    <td class="sorting"><span class="pr-2">Job Position</span></td>
                                                    <td class="sorting"><span class="pr-2">Department</span></td>
                                                    <td class="sorting"><span class="pr-2">Work Location</span></td>
                                                    <td class="sorting"><span class="pr-2">Employee Code</span></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="table-row hover-bg" v-for='emply in paginatedData'
                                                    :key="emply.employee_id">
                                                    <td><input type="checkbox" class="justify-content-center"
                                                            v-model="employee_np_manual" :value="emply.employee_id"
                                                            number><label class="mb-0 custom-label"
                                                            style="width: 15px; height: 15px;"></label></td>
                                                    <td>{{ emply.name }}</td>
                                                    <td>{{ emply.phone }}</td>
                                                    <td>{{ emply.email }}</td>
                                                    <td>{{ emply.jobposition }}</td>
                                                    <td>{{ emply.department }}</td>
                                                    <td>{{ emply.branch }}</td>
                                                    <td>{{ emply.employee_code }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                                            <li class="page-item disabled m-2">View</li>
                                            <li class="page-item disabled"><b-form-select v-model="temp_length"
                                                    :options="length_options_np"
                                                    @change="setFirstPage()"></b-form-select></li>
                                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.
                                            </li>
                                        </ul>
                                        <b-pagination-nav class="float-right mt-1" v-model="this_pagination.currentPage"
                                            :number-of-pages="this_pagination.pages" prev-text="Previous"
                                            next-text="Next" base-url="#" first-number last-number></b-pagination-nav>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="mt-3 text-center">
                                        <button class="btn btn-primary">Create Pay Slip</button>
                                        <span v-if="new_payslip_loading != ''"><img
                                                :src="$api_url + '/images/loading.gif'" width="30"></span>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </b-card>

                    <!-- Modal Content Ends -->
                </b-modal>
            </div>

            <div>
                <b-modal id="download-all-modal" :title="payrun_download_msg" hide-footer>

                    <!-- alpha fix- fixed spelling  -->
                    Please note, this will overwrite any existing schedule request(s) having the same month and fiscal
                    year for
                    the day.
                    <br />
                    <br />
                    You will receive an email notification regarding the process initiation soon.
                    <br />
                    <br />
                    Please enter your password to continue:
                    <br />
                    <br />
                    <input id="approvepass" type="password" class="form-control" v-model="approvepass"
                        name="approvepass">
                    <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert"
                        style="clear: both; margin-top: 10px;"> {{ incorrectpass }} </div>
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                        @click="downloadAll(bulk_download)">Download <span v-if="loading != ''"><img
                                :src="$api_url + '/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                        @click="$bvModal.hide('download-all-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>

                </b-modal>
            </div>


            <!-- taxcard modals--->
            <div v-for="pslip in custom_list" :key="pslip.id" v-if="pslip.id > 0">
                <b-modal :id="'taxcard' + pslip.id" :modal-class="'payslip_modal'" title="Taxcard" size="lg" hide-footer>
                    <!-- Modal Content Starts -->
                    <div class="embed-responsive embed-responsive-16by9 z-depth-1">
                        <iframe class="embed-responsive-item" loading="lazy" :src="$api_url + '/drafttaxcard/' + pslip.id"
                            style="height: 101%" allowfullscreen />
                    </div>
                    <!-- Modal Content Ends -->
                </b-modal>
            </div>

            <!-- Leave Encashment Modal Starts-->

            <div>
                <b-modal id="leave-encashment-list" title="Employee List for Leave Encashment" size="lg" hide-footer>
                    <div class="custom-loader-wrapper" v-if="encashment_processing">
                        <div class="text-center">
                            <span class="d-block max-450">{{ download_text }}</span>
                            <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                                width="100px" />
                        </div>
                    </div>
                    <!-- Modal Content Starts -->
                    <b-card style="">

                        <div class="card-body p-0">
                            <div class="" v-if="employeeids.length > 0">Selected Employee(s): {{ employeeids.length }}
                            </div>
                            <p>Please select employee(s) to process Leave Encashment in bulk or you can process / undo
                                Leave
                                Encashment for individual employee through the action column.</p>
                            <div class="align-self-center custom-search pr-0 mt-2" style="max-width: 480px;">
                                <b-input-group>
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search employee" v-model="this_search_two"
                                        @input="resetPaginationTwo()"></b-form-input>
                                </b-input-group>
                            </div>
                            <table class="table" style="margin-top: 20px;">
                                <tbody>
                                    <tr class="table-head table-head-center">
                                        <td class="text-left"><input type="checkbox" v-model="selectAll" class="" />
                                        </td>
                                        <td class="text-left">Name</td>
                                        <td>Carried Leaves (days)</td>
                                        <td>Current Leaves (days)</td>
                                        <td>Total Encashments (days)</td>
                                        <td>Action</td>
                                    </tr>
                                    <tr class="table-row hover-bg" v-for="pslip in paginatedDataTwo"
                                        :key="pslip.employee_id">
                                        <td class="align-middle"><input v-if="pslip.encash_data == 'yes'"
                                                type='checkbox' disabled="disabled" v-model="employeeids"
                                                name='employeeids[]' :value="pslip.employee_id"><input v-else
                                                type='checkbox' v-model="employeeids" name='employeeids[]'
                                                :value="pslip.employee_id"></td>
                                        <td class="align-middle">
                                            <span style="color:#1d68a7; cursor:pointer;">{{ pslip.employee_name }}</span>
                                        </td>
                                        <td class="align-middle text-left"><template
                                                v-for="lv_data in pslip.encash_details">{{ lv_data.leave_type }}:
                                                {{ lv_data.carried }}<br /></template>
                                        </td>
                                        <td class="align-middle text-left"><template
                                                v-for="lv_data in pslip.encash_details">{{ lv_data.leave_type }}:
                                                {{ lv_data.encash }}<br /></template>
                                        </td>
                                        <td class="text-right">{{ pslip.encash_days }}</td>
                                        <td class="align-middle text-right position-relative">
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"><b-icon
                                                    icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <span v-if="pslip.encash_data == 'yes'">
                                                    <button class="btn btn-primary float-right"
                                                        @click="undoLeaveEncashment(pslip.employee_id)"><b-icon
                                                            icon="x-circle" class="mr-2 mt-n1" scale="1"></b-icon>Undo
                                                        Encashment</button>
                                                </span>
                                                <span v-else>
                                                    <button class="btn btn-primary float-right" v-model="employeeids"
                                                        @click="processSingleLeaveEncashment(pslip.employee_id)"><b-icon
                                                            icon="gear" class="mr-2 mt-n1" scale="1"></b-icon>Process
                                                        Encashment</button>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="paginatedDataTwo.length > 0">
                                        <td :colspan=100>
                                            <div class="row py-2">
                                                <div class="col-md-12 p-0 no-margin">
                                                    <ul class="pagination b-pagination float-left">
                                                        <li class="page-item disabled m-2">View</li>
                                                        <li class="page-item disabled"><b-form-select
                                                                v-model="temp_length" :options="length_options"
                                                                @change="setFirstPageTwo()"></b-form-select></li>
                                                        <li class="page-item disabled m-2">per page. Total
                                                            {{ encashment_list.length }} records found.</li>
                                                    </ul>
                                                    <b-pagination-nav class="float-right"
                                                        v-model="this_pagination_two.currentPage"
                                                        :number-of-pages="this_pagination_two.pages" base-url="#"
                                                        first-number last-number></b-pagination-nav>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <button class="btn btn-primary float-left" @click="reverseLeaveEncashment()">Undo Leave
                                Encashment</button>
                            <button class="btn btn-primary float-right" @click="processLeaveEncashment()">Process Leave
                                Encashment (selected)</button>
                        </div>

                    </b-card>

                    <!-- Modal Content Ends -->
                </b-modal>
            </div>
            <!-- Payrun department list modal -->
            <b-modal id="payrun-department-list" title="Department wise payslip breakdown" size="lg" hide-footer
                @hidden="onHiddenPayrun">
                <!-- Modal Content Starts -->
                 <!-- alpha fix- chnaged background colcor  -->
                <div class="custom-loader-wrapper position-absolute" style="background: #fff;"
                    v-if="download_loader_dep">
                    <div class="text-center">
                        <span class="d-block max-450 m-auto">{{ department_loader_text }}</span>
                        <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo mt-3"
                            width="100px" />
                    </div>
                </div>
                <div>
                    <template v-if="confirm_box">
                        <div class="row no-margin justify-content-center align-items-center">
                            <div class="col-md-12 float-left px-3 department-checkbox text-center">
                                Are you sure? This action will delete {{ department_payslips_sum }} pay slips from the
                                selected departments.<br><br>
                                Departments selected: {{ department_names.join(', ') }}
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left"
                                    @click="deleteDepartmentPayslips(fdata.id)">Ok</button>
                                <button class="btn btn-primary float-right"
                                    @click="confirm_box = !confirm_box;">Cancel</button>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="confirm_box_create">
                        <div class="row no-margin justify-content-center align-items-center" v-if="ask_leaver">
                            <div class="col-md-12">
                                <div class="py-2 mb-3 border-bottom mx-n-custom">
                                    <div class="company-form-box-title">Process Leavers</div>
                                </div>
                                <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                    <h6 class="mb-4" style='font-size:24px;'>Do you have any Leavers in this Month?</h6>
                                    <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary"
                                        @click="showHideBlock()">Yes</b-button>
                                    <b-button class="ml-2 w-auto px-4" type="button" variant="primary"
                                        @click="leaver_process = false; ask_leaver = false;">No</b-button>
                                </div>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center" v-if="show_leaver">
                            <div class="col-md-12">
                                <div class="py-2 mb-3 border-bottom mx-n-custom">
                                    <div class="company-form-box-title">Process Leavers</div>
                                </div>
                                <div class=" ">
                                    <leaver-wizard :company_id="fdata.company_id" :key="'leaver' + componentKey"
                                        :current_fiscal_year="fdata.fiscal_year" :current_month="fdata.mn"
                                        :departments="this.department"></leaver-wizard>
                                </div>

                                <div class="clearfix row mt-4 form-btn-container">
                                    <div class="col-md-12 pr-0 text-right"><b-button type="button" variant="primary"
                                            @click="moveNext('leaver')">Move Next</b-button></div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center" v-if="!leaver_process">
                            <div class="col-md-12 float-left px-3 department-checkbox text-center">
                                Hold tight there, we will process {{ department_payslips_to_create_sum }} pay slips for
                                this payrun as per your selection.<br>
                                Selected Departments: {{ department_names.join(', ') }}<br>
                                Want to change departments selections, please click cancel!
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5"
                            v-if="!leaver_process">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left"
                                    @click="processDepartmentPayrun(fdata.id)">Ok</button>
                                <button class="btn btn-primary float-right"
                                    @click="confirm_box_create = !confirm_box_create; if (fdata.run_type != 11) { ask_leaver = true; leaver_process = true; }">Cancel</button>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row no-margin align-items-center">
                            <span style="color: #28a745;">{{ department_success_text }}</span>
                            <div class="col-md-12 float-left px-3 department-checkbox">
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                    <div class="department-select-all position-relative text-left px-2 custom-checkbox">
                                        <input type="checkbox" id="departmentAll" v-model="selectAllDepartment"
                                            class="custom-control-input" v-on:change="setDepartment()" />
                                        <label class="custom-control-label" for="departmentAll"><span>Select
                                                All</span></label>
                                    </div>
                                    <b-form-checkbox-group id="department" class="row" v-model="department"
                                        :aria-describedby="ariaDescribedby" name="department"
                                        v-on:change="setDepartment()">
                                        <template v-for="department in departments">
                                            <b-form-checkbox class="col-md-6 mr-0"
                                                v-if="department.has_employee == 'no'" :value="department.id"
                                                :key="department.id" disabled><span
                                                    v-if="department.payrun_processed == 'yes'"
                                                    style="color: rgb(29, 104, 167);">{{ department.name }}
                                                    ({{ department.employee_count }})</span><span
                                                    v-else>{{ department.name }} ({{ department.employee_count }})</span>
                                                <b-icon v-if="department.payrun_processed == 'yes'"
                                                    icon="check-circle-fill" class="ml-3 mt-1 float-right"
                                                    variant="success"></b-icon><b-icon class="ml-2" icon="info-circle"
                                                    title="This department does not have any employee assigned"
                                                    v-b-tooltip></b-icon></b-form-checkbox>
                                            <b-form-checkbox class="col-md-6 mr-0" v-else :value="department.id"
                                                :key="department.id"><span v-if="department.payrun_processed == 'yes'"
                                                    style="color: rgb(29, 104, 167);">{{ department.name }}
                                                    ({{ department.employee_count }})</span><span
                                                    v-else>{{ department.name }} ({{ department.employee_count }})</span>
                                                <b-icon v-if="department.payrun_processed == 'yes'"
                                                    icon="check-circle-fill" class="ml-3 mt-1 float-right"
                                                    variant="success"></b-icon></b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left"
                                    @click="deleteDepartmentPayslipsPre(fdata.id)">Delete Pay
                                    Slip(s)</button>
                                <button class="btn btn-primary float-right"
                                    @click="processDepartmentPayrunPre(fdata.id)">Create Pay
                                    Slip(s)</button>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="col-md-12 pay-run-loader overflow-hidden text-center" style="z-index: 9; min-height: 250px;"
                    v-if="loading != ''">
                    <h3 style="color: #fff;">
                        {{ fdata.month }} - {{ fdata.year }}
                    </h3>
                    <h4 style="color: #fff;">

                    </h4>
                    <p style="color: #fff;">
                        Alright world, time to take you on!
                        <br />
                        Payrun calculations in progress ...
                    </p>
                    <img :src="$api_url + '/images/loading.gif'" width="40" style="margin-bottom: 89px !important;">
                    <div class="loading-stroke"></div>
                    <b-progress :max="number_of_employees" class="payroll-progress" show-progress animated>
                        <b-progress-bar :value="progress_value"
                            :label="(progress_value) + ' / ' + (number_of_employees)"></b-progress-bar>
                    </b-progress>
                </div>
                <!-- Modal Content Ends -->
            </b-modal>

            <!-- Payrun work location list modal -->
            <b-modal id="payrun-work-location-list" title="Work location wise pay slip breakdown" size="lg" hide-footer
                @hidden="onHiddenPayrun">
                <!-- Modal Content Starts -->
                <div class="custom-loader-wrapper position-absolute" style="background: #3c5e64;"
                    v-if="download_loader_dep">
                    <div class="text-center">
                        <span class="d-block max-450 m-auto">{{ department_loader_text }}</span>
                        <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo mt-3"
                            width="100px" />
                    </div>
                </div>
                <div>
                    <template v-if="confirm_box">
                        <div class="row no-margin justify-content-center align-items-center">
                            <div class="col-md-12 float-left px-3 department-checkbox text-center">
                                Are you sure? This action will delete {{ department_payslips_sum }} pay slips from the
                                selected work locations.<br><br>
                                Work locations selected: {{ department_names.join(', ') }}
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left"
                                    @click="deleteWorkLocationPayslips(fdata.id)">Ok</button>
                                <button class="btn btn-primary float-right"
                                    @click="confirm_box = !confirm_box">Cancel</button>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="confirm_box_create">
                        <div class="row no-margin justify-content-center align-items-center" v-if="ask_leaver">
                            <div class="col-md-12">
                                <div class="py-2 mb-3 border-bottom mx-n-custom">
                                    <div class="company-form-box-title">Process Leavers</div>
                                </div>
                                <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                    <h6 class="mb-4" style='font-size:24px;'>Do you have any Leavers in this Month?</h6>
                                    <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary"
                                        @click="showHideBlock()">Yes</b-button>
                                    <b-button class="ml-2 w-auto px-4" type="button" variant="primary"
                                        @click="leaver_process = false; ask_leaver = false;">No</b-button>
                                </div>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center" v-if="show_leaver">
                            <div class="col-md-12">
                                <div class="py-2 mb-3 border-bottom mx-n-custom">
                                    <div class="company-form-box-title">Process Leavers</div>
                                </div>
                                <div class=" ">
                                    <leaver-wizard :company_id="fdata.company_id" :key="'leaver' + componentKey"
                                        :current_fiscal_year="fdata.fiscal_year" :current_month="fdata.mn"
                                        :work_location="this.work_location"></leaver-wizard>
                                </div>

                                <div class="clearfix row mt-4 form-btn-container">
                                    <div class="col-md-12 pr-0 text-right"><b-button type="button" variant="primary"
                                            @click="moveNext('leaver')">Move Next</b-button></div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center" v-if="!leaver_process">
                            <div class="col-md-12 float-left px-3 department-checkbox text-center">
                                Hold tight there, we will process {{ department_payslips_to_create_sum }} pay slips for
                                this payrun as per your selection.<br><br>
                                Selected Work locations: {{ department_names.join(', ') }}<br>
                                Want to change work location selections, please click cancel!
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5"
                            v-if="!leaver_process">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left"
                                    @click="processWorkLocationPayrun(fdata.id)">Ok</button>
                                <button class="btn btn-primary float-right"
                                    @click="confirm_box_create = !confirm_box_create; if (fdata.run_type != 11) { ask_leaver = true; leaver_process = true; }">Cancel</button>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row no-margin align-items-center">
                            <span style="color: #28a745;">{{ department_success_text }}</span>
                            <div class="col-md-12 float-left px-3 department-checkbox">
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                    <div class="department-select-all position-relative text-left px-2 custom-checkbox">
                                        <input type="checkbox" id="branchAll" v-model="selectAllBranch"
                                            class="custom-control-input" v-on:change="setDepartment()" />
                                        <label class="custom-control-label" for="branchAll"><span>Select
                                                All</span></label>
                                    </div>
                                    <b-form-checkbox-group id="work_location" class="row" v-model="work_location"
                                        :aria-describedby="ariaDescribedby" name="work_location"
                                        v-on:change="setDepartment()">
                                        <template v-for="work_location in work_locations">
                                            <b-form-checkbox class="col-md-6 mr-0"
                                                v-if="work_location.has_employee == 'no'" :value="work_location.id"
                                                :key="work_location.id" disabled><span
                                                    v-if="work_location.payrun_processed == 'yes'"
                                                    style="color: rgb(29, 104, 167);">{{ work_location.name }}
                                                    ({{ work_location.employee_count }})</span><span
                                                    v-else>{{ work_location.name }}
                                                    ({{ work_location.employee_count }})</span> <b-icon
                                                    v-if="work_location.payrun_processed == 'yes'"
                                                    icon="check-circle-fill" class="ml-3 mt-1 float-right"
                                                    variant="success"></b-icon><b-icon class="ml-2" icon="info-circle"
                                                    title="This work location does not have any employee assigned"
                                                    v-b-tooltip></b-icon></b-form-checkbox>
                                            <b-form-checkbox class="col-md-6 mr-0" v-else :value="work_location.id"
                                                :key="work_location.id"><span
                                                    v-if="work_location.payrun_processed == 'yes'"
                                                    style="color: rgb(29, 104, 167);">{{ work_location.name }}
                                                    ({{ work_location.employee_count }})</span><span
                                                    v-else>{{ work_location.name }}
                                                    ({{ work_location.employee_count }})</span> <b-icon
                                                    v-if="work_location.payrun_processed == 'yes'"
                                                    icon="check-circle-fill" class="ml-3 mt-1 float-right"
                                                    variant="success"></b-icon></b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left"
                                    @click="deleteWorkLocationPayslipsPre(fdata.id)">Delete Pay
                                    Slip(s)</button>
                                <button class="btn btn-primary float-right"
                                    @click="processWorkLocationPayrunPre(fdata.id)">Create Pay
                                    Slip(s)</button>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="col-md-12 pay-run-loader overflow-hidden text-center" style="z-index: 9; min-height: 250px;"
                    v-if="loading != ''">
                    <h3 style="color: #fff;">
                        {{ fdata.month }} - {{ fdata.year }}
                    </h3>
                    <h4 style="color: #fff;">

                    </h4>
                    <p style="color: #fff;">
                        Alright world, time to take you on!
                        <br />
                        Payrun calculations in progress ...
                    </p>
                    <img :src="$api_url + '/images/loading.gif'" width="40">
                    <div class="loading-stroke"></div>
                    <b-progress :max="number_of_employees" class="payroll-progress" show-progress animated>
                        <b-progress-bar :value="progress_value"
                            :label="(progress_value) + ' / ' + (number_of_employees)"></b-progress-bar>
                    </b-progress>
                </div>
                <!-- Modal Content Ends -->
            </b-modal>

            <!-- Department selection wizard modal -->
            <b-modal id="department-selection-wizard" title="Select Departments" size="lg" hide-footer
                @hidden="onHiddenPayrun">
                <!-- Modal Content Starts -->
                <div>
                    <template>
                        <div class="row no-margin align-items-center">
                            <div class="col-md-12 float-left px-3 department-checkbox">
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                    <div class="department-select-all position-relative text-left px-2 custom-checkbox">
                                        <input type="checkbox" id="departmentAllExport"
                                            v-model="selectAllDepartmentExport" class="custom-control-input" />
                                        <label class="custom-control-label" for="departmentAllExport"><span>Select
                                                All</span></label>
                                    </div>
                                    <b-form-checkbox-group id="department" class="row" v-model="department"
                                        :aria-describedby="ariaDescribedby" name="department">
                                        <template v-for="department in departments">
                                            <b-form-checkbox class="col-md-6 mr-0" :value="department.id"
                                                :key="department.id"
                                                v-if="department.payrun_processed == 'yes'">{{ department.name }}
                                                ({{ department.employee_count }})</b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left" @click="exportPayslipsByDepartment()">Export
                                    Pay Slip(s)</button>
                                <button class="btn btn-primary float-right" @click="cancelExport()">Cancel</button>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- Modal Content Ends -->
            </b-modal>

            <!-- Work location selection wizard modal -->
            <b-modal id="work-location-selection-wizard" title="Select Work Locations" size="lg" hide-footer
                @hidden="onHiddenPayrun">
                <!-- Modal Content Starts -->
                <div>
                    <template>
                        <div class="row no-margin align-items-center">
                            <div class="col-md-12 float-left px-3 department-checkbox">
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                    <div class="department-select-all position-relative text-left px-2 custom-checkbox">
                                        <input type="checkbox" id="branchAllExport"
                                            v-model="selectAllWorkLocationExport" class="custom-control-input" />
                                        <label class="custom-control-label" for="branchAllExport"><span>Select
                                                All</span></label>
                                    </div>

                                    <b-form-checkbox-group id="work_location" class="row" v-model="work_location"
                                        :aria-describedby="ariaDescribedby" name="work_location">
                                        <template v-for="work_location in work_locations">
                                            <b-form-checkbox class="col-md-6 mr-0" :value="work_location.id"
                                                :key="work_location.id"
                                                v-if="work_location.payrun_processed == 'yes'">{{ work_location.name }}
                                                ({{ work_location.employee_count }})</b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row no-margin justify-content-center align-items-center mt-5">
                            <div class="col-md-12 float-left px-0 text-center department-checkbox">
                                <button class="btn btn-primary float-left"
                                    @click="exportPayslipsByWorkLocation()">Export Pay
                                    Slip(s)</button>
                                <button class="btn btn-primary float-right" @click="cancelExport()">Cancel</button>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- Modal Content Ends -->
            </b-modal>



            <!-- this code block commented out by Faroque and added new code bellow

   <br />
   <div v-if="this.payslip_loading==1" style="margin-bottom: 10px;">Loading...</div>
    <div v-else>
	<table class="table" style="margin-top: 20px;">
	  <tbody>
        <tr class="table-head table-head-center">
            <td class="text-left"><input type="checkbox" v-model="selectAll" class=""/></td>
            <td>Name</td>
            <td>Gross Salary</td>
            <td>Variable Pay</td>
            <td>Total Deductions</td>
            <td>Income Tax</td> <td>Net Pay</td>
            <td style="width:285px; text-align: right;"  v-if="fdata.status != '1'">Action</td>
		</tr>
		<tr class="table-row hover-bg" v-for="pslip in payslips" :key="pslip.id" v-if="pslip.id>0">
        <td><input type='checkbox' v-model="payslipids" name='payslipids[]' :value="pslip.id"></td>
		  <td>
          <a  v-if="fdata.status != '1'" @click="displaymodal(pslip.id, pslip.employee_id, pslip.fiscal_year, pslip.from_date, pslip.to_date, pslip.pay_slip_ref, pslip.pay_slip_name, pslip.employee_name, pslip.pic, pslip.position, pslip.ait, pslip.medical_reimbursement)" ><span style="color:#1d68a7; cursor:pointer;">{{pslip.employee}}</span></a>
          <a  v-if="fdata.status == '1'"><span style="color:#3ec197; cursor:pointer;" @click="displaymodal(pslip.id, pslip.employee_id, pslip.fiscal_year, pslip.from_date, pslip.to_date, pslip.pay_slip_ref, pslip.pay_slip_name, pslip.employee_name, pslip.pic, pslip.position, pslip.ait, pslip.medical_reimbursement)">{{pslip.employee}}</span></a>

          </td>
		  <td class="text-right">&#2547; {{pslip.salary_without_additions}}</td>
		  <td class="text-right">&#2547; {{pslip.additions}}</td>
		  <td class="text-right">&#2547; {{pslip.deduction_total}}</td>
		  <td class="text-right">&#2547; {{pslip.taxes_total}}</td>
          <td class="text-right">&#2547; {{pslip.net_salary_total}}</td>
		  <td class="position-relative text-right"  v-if="fdata.status != '1'">
            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
            <div class="dropdown-menu action-dropdown-menu w-200" aria-labelledby="actionDropdown">
                <div><a class="btn btn-primary" style="color: #FFFFFF;" @click="displaymodal(pslip.id, pslip.employee_id, pslip.fiscal_year, pslip.from_date, pslip.to_date, pslip.pay_slip_ref, pslip.pay_slip_name, pslip.employee_name, pslip.pic, pslip.position, pslip.ait, pslip.medical_reimbursement)" ><b-icon icon="pencil-square"></b-icon>Review</a><a class="btn btn-primary" style="color: #FFFFFF;"  @click="displaytaxcardmodal(pslip.id)" ><b-icon icon="eye"></b-icon>Preview Taxcard</a></div>
                <div style="color: green;" v-if="pslip.reviewed=='1'"><i class="fa fa-check-circle" aria-hidden="true"></i>Reviewed</div>
            </div>
		  </td>
		</tr>
	  </tbody>
	  <tfoot>
		<tr>
		  <td colspan="8" class="border-0">

                  <div class="row p-2 float-right" v-if="pagination.total > 0">
                         <ul class="pagination b-pagination" style="margin-bottom: 0;">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                            <b-form-select class="input" type="text" v-model="per_page" @change="setSearch()">
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            </b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{pagination.total}} records found.</li>
                         </ul>
                        <b-pagination-nav class="float-right" :link-gen="linkGen" v-model="pagination.currentPage" :number-of-pages="pagination_length" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
            </td>
		</tr>
	  </tfoot>
	</table>
    </div>

    -->
            <div class="payrunpayslip-details">
                <common-list :checkbox="checkbox" :is_action="is_action" :appended_column="appended_column"
                    :key="list_key" :company_options="company_options" :employees="custom_list"
                    :default_column="default_column" :primary_key="primary_key" :is_payruns="is_payruns"
                    v-on:childToParent="listReturn"></common-list>
            </div>


            <!-- Payrun User Data Starts Here -->
            <div class="payrun-user-data">
                <div v-for="p_userdata in payrun_userdata" :key="p_userdata.id">
                    <div class="row no-margin">
                        <div class="col-md-12 p-0 border-top">
                            <span class="p-2 d-inline-block mt-2">Created By</span> - <span
                                class="p-2 d-inline-block mt-2">{{ p_userdata.created_user_name }}</span> - <span
                                class="p-2 d-inline-block mt-2">{{ formatMe(p_userdata.created_at) }}</span><span
                                class="p-2 d-inline-block mt-2">{{ formatTime(p_userdata.created_at) }}</span>
                        </div>

                        <div class="col-md-12 p-0" v-if="p_userdata.status == 1">
                            <span class="p-2 d-inline-block">Approved By</span> - <span
                                class="p-2 d-inline-block">{{ p_userdata.approved_user_name }}</span> - <span
                                class="p-2 d-inline-block">{{ formatMe(p_userdata.updated_at) }}</span><span
                                class="p-2 d-inline-block">{{ formatTime(p_userdata.updated_at) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Payrun User Data Ends Here -->

            <!-- New Recalculate Modal Starts Here -->
            <b-modal id="payslip_modal_recalculate" :title="'Draft Pay Slip: ' + fiscal_year" modal-class="payslip_modal"
                size="lg" hide-footer>
                <div class="custom-loader-wrapper" v-if="payslip_loader">
                    <div class="text-center">
                        <span class="d-block max-450">{{ payslip_loader_text }}</span>
                        <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo" width="100px" />
                    </div>
                </div>
                <div v-else>
                    <p class="text-center">Tax recalculation of the pay slip is completed.</p>
                </div>
            </b-modal>
            <!-- New Recalculate Modal Ends Here -->

        </div>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    props: ['payrun'],
    mounted() {
        console.log('started..');
        this.permission = this.$acl['payroll/wizard'];
    },
    data() {

        /** Faroque Code Starts Here */
        let sortOrders = {};
        /** Faroque Code Ends Here */

        return {

            /** custom field sorting starts **/

            checkbox: 1,
            is_action: 0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
            list_key: 0, /* Component Key */
            custom_list: [],  /* Data List */
            default_column: ['name'], /* Default Column List */
            appended_column: [
                { value: "salary_without_additions", text: "Gross Salary", type: "number" },
                { value: "additions", text: "Other Benefits & Allowances", type: "number" },
                { value: "total_earnings", text: "Total Earnings", type: "number" },
                { value: "taxes_total", text: "Income Tax", type: "number" },
                { value: "total_deduction", text: "Other Deductions", type: "number" },
                { value: "net_salary_total", text: "Net Pay", type: "number" },
                { value: "reviewed", text: "Reviewed", type: "text" },
            ],                   /* Appended Column List  and there title and type */
            primary_key: 'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
            company_options: [],         /* Company Filterable options */

            /***Child Component property data */

            tmp_custom_list: [],
            is_payruns: 'yes',

            /** custom field sorting ends **/

            /** Faroque Code Starts Here */
            blankmsg: 'Fetching data..',
            this_search: '',
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 20,
            temp_length: 20,
            length_two: 20,
            temp_length_two: 20,
            length_options: [],
            length_options_np: [],
            this_pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            this_employees: [],

            /** Faroque Code Ends Here */


            payslipids: [],
            employeeids: [],
            single_employee_id: [],
            encashment_list: [],
            addons: [],
            salaryheads: [],
            taxinfo: [],
            fiscalyears: [],
            adhocfields: [],
            adhocdeductionfields: [],
            adhocpredeductionfields: [],
            adhocnontaxablefields: [],
            adhocheadsnvalues: [],
            slabs_and_values: [],
            fadatamodal: [],   //this.payslip,
            modalsuccess: '',
            employee_id: '',
            fiscal_year: '',
            from_date: '',
            to_date: '',
            pay_slip_ref: '',
            pay_slip_name: '',
            month: '',
            year: '',
            adhoc_field: '',
            adhoc_deduction_field: '',
            adhoc_pre_deduction_field: '',
            adhoc_field_value: '',
            adhoc_deduction_field_value: '',
            ait_adjust_value: '',
            medical_reimbursement_value: '',
            payrun_delete_msg: '',
            pagination_length: 0,
            link_tracker: 0,
            mri_action: 0,
            medical_reimbursement_value_display: '',
            medical_reimbursement_show_control: '',

            /**one-off management**/
            one_off_tx: '',
            monthly_tx: '',
            total_tx: '',
            /********************/
            adhoc_pre_deduction_field_value: '',
            adhoc_nontaxable_field: '',
            adhoc_nontaxable_field_value: '',
            payslip_loading: 0,
            approvepass: '',
            incorrectpass: '',
            /** off-cycle edit option **/
            edit_basic: 0,
            edit_hra: 0,
            edit_conv: 0,
            edit_medical: 0,
            show_edit_div: 0,
            fixed_component_edit_status: '',
            edit_gross: '',
            emailing: '',
            emailing_success: '',
            emailsuccess: '',

            ////////////Challan Modal elements Start/////////

            users: [],
            challanemployees: [],
            employeenames: [],
            employeetds: [],
            employeeetins: [],
            challansearch: { name: '' },
            challanfdata: [],
            success: '',
            company_code: '',
            company_name: '',
            company_address: '',
            tds_field: '',
            tds_remaining: '',
            tds_total: 0,
            employee_counter: 0,
            current_employee_id: '',
            current_employee_etin: '',


            ////////////Challan Modal elements End/////////


            payslips: [],
            employees: [],
            payrunsfiscalyear: [],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', nextbuttonstatus: 'true', prebuttonstatus: 'disabled' },
            search: { pay_slip_name: '', pay_slip_ref: '', fiscal_year: '', month: '', allparams: '' },
            search_by_id: { employee_id: '', payrun: this.payrun.id, allparams: '' },
            per_page: 50,

            fdata: this.payrun,
            payrun_modification_flag: '',
            loading: '',
            upload_all: false,
            empfile: null,
            //search_by_id.payrun: this.payrun.id,



            /////////////////////Payslip creation modal

            employees_np: [],
            success_np: '',
            prun_id_np: this.payrun_id,
            employee_np: [],
            new_payslip_loading: '',
            showoverlay: false,
            download_loader: false,
            import_loader: false,
            payslip_loader: false,
            download_text: '',
            employee_np_manual: [],

            payrun_userdata: [],

            this_search_two: '',
            length: 100,
            this_pagination_two: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

            column_selected: [],

            pre_gross_flag: 0,
            //showdataoverlay: false,
            payrun_download_msg: '',
            bulk_download: '',
            encashment_processing: false,

            // Contracted variablr
            contracted_variable_fields: [],
            bonus_incentive_fields: [],
            overtime_holiday_manual_fields: [],
            overtime_holiday_fixed_fields: [],
            overtime_holiday_incremental_days_fields: [],
            overtime_holiday_incremental_hours_fields: [],
            overtime_holiday_manual_non_taxable_fields: [],
            overtime_holiday_fixed_non_taxable_fields: [],
            overtime_holiday_incremental_days_non_taxable_fields: [],
            overtime_holiday_incremental_hours_non_taxable_fields: [],

            pre_deduction_manual_fields: [],
            pre_deduction_fixed_fields: [],
            pre_deduction_incremental_days_fields: [],
            pre_deduction_incremental_hours_fields: [],

            post_deduction_manual_fields: [],
            post_deduction_fixed_fields: [],
            post_deduction_incremental_days_fields: [],
            post_deduction_incremental_hours_fields: [],

            contracted_variable_field_value: '',
            contracted_variable_field: '',
            bonus_incentive_field: '',
            bonus_incentive_field_value: '',
            overtime_holiday_manual_field: '',
            overtime_holiday_manual_field_value: '',
            overtime_holiday_fixed_field: '',
            overtime_holiday_fixed_field_value: '',
            overtime_holiday_incremental_days_field: '',
            overtime_holiday_incremental_days_field_value: '',
            overtime_holiday_incremental_hours_field: '',
            overtime_holiday_incremental_hours_field_value: '',
            overtime_holiday_manual_non_taxable_field: '',
            overtime_holiday_manual_non_taxable_field_value: '',
            overtime_holiday_fixed_non_taxable_field: '',
            overtime_holiday_fixed_non_taxable_field_value: '',
            overtime_holiday_incremental_days_non_taxable_field: '',
            overtime_holiday_incremental_days_non_taxable_field_value: '',
            overtime_holiday_incremental_hours_non_taxable_field: '',
            overtime_holiday_incremental_hours_non_taxable_field_value: '',

            pre_deduction_manual_field: '',
            pre_deduction_manual_field_value: '',
            pre_deduction_fixed_field: '',
            pre_deduction_fixed_field_value: '',
            pre_deduction_incremental_days_field: '',
            pre_deduction_incremental_days_field_value: '',
            pre_deduction_incremental_hours_field: '',
            pre_deduction_incremental_hours_field_value: '',

            post_deduction_manual_field: '',
            post_deduction_manual_field_value: '',
            post_deduction_fixed_field: '',
            post_deduction_fixed_field_value: '',
            post_deduction_incremental_days_field: '',
            post_deduction_incremental_days_field_value: '',
            post_deduction_incremental_hours_field: '',
            post_deduction_incremental_hours_field_value: '',
            payslip_loader_text: 'We are preparing the data for this employee.',

            add_adhc_fields_arr: [],
            add_adhc_field_title: '',
            add_adhc_field_value: [],
            adhoc_field_arr: [],
            adhoc_field_value_arr: [],

            add_adhc_fields_manual_arr: [],
            overtime_holiday_manual_field_arr: [],
            overtime_holiday_manual_field_value_arr: [],

            add_adhc_fields_fixed_arr: [],
            overtime_holiday_fixed_field_arr: [],
            overtime_holiday_fixed_field_value_arr: [],

            add_adhc_fields_days_arr: [],
            overtime_holiday_days_field_arr: [],
            overtime_holiday_days_field_value_arr: [],

            add_adhc_fields_hours_arr: [],
            overtime_holiday_hours_field_arr: [],
            overtime_holiday_hours_field_value_arr: [],

            add_adhc_fields_nontax_arr: [],
            adhoc_nontax_field_arr: [],
            adhoc_nontax_field_value_arr: [],

            add_adhc_fields_nontax_manual_arr: [],
            overtime_holiday_nontax_manual_field_arr: [],
            overtime_holiday_nontax_manual_field_value_arr: [],

            add_adhc_fields_nontax_fixed_arr: [],
            overtime_holiday_nontax_fixed_field_arr: [],
            overtime_holiday_nontax_fixed_field_value_arr: [],

            add_adhc_fields_nontax_days_arr: [],
            overtime_holiday_nontax_days_field_arr: [],
            overtime_holiday_nontax_days_field_value_arr: [],

            add_adhc_fields_nontax_hours_arr: [],
            overtime_holiday_nontax_hours_field_arr: [],
            overtime_holiday_nontax_hours_field_value_arr: [],

            add_adhc_fields_contracted_arr: [],
            adhoc_contracted_field_arr: [],
            adhoc_contracted_field_value_arr: [],

            add_pre_deduction_fields_arr: [],
            pre_deduction_field_arr: [],
            pre_deduction_field_value_arr: [],

            add_pre_manual_fields_arr: [],
            pre_manual_field_arr: [],
            pre_manual_field_value_arr: [],

            add_pre_fixed_fields_arr: [],
            pre_fixed_field_arr: [],
            pre_fixed_field_value_arr: [],

            add_pre_days_fields_arr: [],
            pre_days_field_arr: [],
            pre_days_field_value_arr: [],

            add_pre_hours_fields_arr: [],
            pre_hours_field_arr: [],
            pre_hours_field_value_arr: [],

            add_post_deduction_fields_arr: [],
            post_deduction_field_arr: [],
            post_deduction_field_value_arr: [],

            add_post_manual_fields_arr: [],
            post_manual_field_arr: [],
            post_manual_field_value_arr: [],

            add_post_fixed_fields_arr: [],
            post_fixed_field_arr: [],
            post_fixed_field_value_arr: [],

            add_post_days_fields_arr: [],
            post_days_field_arr: [],
            post_days_field_value_arr: [],

            add_post_hours_fields_arr: [],
            post_hours_field_arr: [],
            post_hours_field_value_arr: [],

            success_msg: false,
            closePayslipModal: false,

            number_of_employees: 0,
            progress_value: 0,
            file_imported: false,

            custom_gross_heads: [],
            custom_gross_heads_models: [],

            departments: [],
            department: [],
            work_locations: [],
            work_location: [],
            payrun_department_data: [],
            confirm_box: false,
            confirm_box_create: false,
            download_loader_dep: false,
            department_payslips_sum: 0,
            department_payslips_to_create_sum: 0,
            department_names: [],
            department_loader_text: '',
            department_success_text: '',
            leaver_process: true,
            ask_leaver: true,
            show_leaver: false,
            componentKey: 0,
            people: 0,
            bonus_export: false,

            checked_banks: [],
            selected_banks: [],

        }
    },
    methods: {

        addAdhcFields: function (item_name, bonus_arr) {
            let can_add_adhoc = true;
            let has_data = 'no';
            //this.getSalaryDataFromDB('no');
            this.salaryheads.forEach(element => {
                if (element.head == item_name && element.rawvalue > 0) {
                    has_data = 'yes';
                    return false;
                }
            });
            bonus_arr.forEach(element => {
                if (element.title === item_name) {
                    can_add_adhoc = false;
                }

            });
            if (can_add_adhoc) {
                bonus_arr.push({ title: item_name, value: '', has_data: has_data });
            } else {
                alert(item_name + ' has been added already.');
            }
            this.adhoc_field = '';
            console.log(bonus_arr);
        },

        removeBonusItem: function (pageflg, bonus_arr) {
            bonus_arr.forEach((element, index) => {
                if (element.title === pageflg) {
                    bonus_arr.splice(index, 1);
                }

            });
            console.log(bonus_arr);
        },

        create_bonus_title_value_arr: function (source_arr, title_arr, value_arr) {
            source_arr.forEach(element => {
                if (element.title != '' && element.value != '') {
                    title_arr.push(element.title);
                    value_arr.push(element.value);
                }
            });
        },
        // added by faroque
        downloadAll: function (function_name) {
            if (this.approvepass != '') {

                let currentObj = this;
                let formData = new FormData();
                let user_inputs = { 'all_payslips': 'yes', 'payrun_id': this.payrun.id };
                var pass = this.approvepass;


                formData.append('pass', pass);
                formData.append('function_name', function_name);
                formData.append('user_inputs', JSON.stringify(user_inputs));

                this.loading = 'load';
                axios.post(this.$api_url + '/schedule/request', formData).then(function (response) {
                    this.loading = '';
                    if (response.data.success == '1') {
                        this.incorrectpass = '';
                        this.$bvModal.hide('download-all-modal');
                        this.$bvToast.toast('We have successfully scheduled your download request.', { title: 'Scheduled!', variant: 'success', solid: true });

                    }
                    else {
                        this.incorrectpass = "Incorrect Password";
                    }


                }.bind(this))
                    .catch(function (error) {
                        currentObj.$bvToast.toast('Something went wrong. Please reload and try again.', { title: 'Error!', variant: 'danger', solid: true });
                        //currentObj.serverError(error);
                    });
                return;
            }
        },
        showDownloadModal: function (pageflg) {
            this.bulk_download = pageflg;
            this.approvepass = "";

            this.payrun_download_msg = "Are you sure to request the schedule download?";
            this.$bvModal.show('download-all-modal');
        },

        // added by sohel starts
        choosenewpayslip(name, id) {
            this.employee_np = id;
            document.getElementById('employee_dropdown_payslip').style.display = "none";
        },

        paginate(array, length, pageNumber) {
            let l = parseInt(array.length);
            let m = parseInt(length);
            this.this_pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.this_pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.this_pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.this_pagination.nextPage = array.length > this.this_pagination.to ? pageNumber + 1 : '';

            if (l > 0) {
                this.this_pagination.pages = Math.ceil(l / m);
            }
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        resetPagination() {
            if (document.getElementById('employee_dropdown_payslip')) {
                if (this.this_search != "")
                    document.getElementById('employee_dropdown_payslip').style.display = "block";
                else
                    document.getElementById('employee_dropdown_payslip').style.display = "none";
            }
            this.this_pagination.currentPage = 1;
            this.this_pagination.prevPage = '';
            this.this_pagination.nextPage = '';
        },
        setFirstPage() {
            this.this_pagination.currentPage = 1;
            this.length = this.temp_length;
        },

        paginateTwo(array, length, pageNumber) {
            let l = parseInt(array.length);
            let m = parseInt(length);
            this.this_pagination_two.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.this_pagination_two.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.this_pagination_two.prevPage = pageNumber > 1 ? pageNumber : '';
            this.this_pagination_two.nextPage = array.length > this.this_pagination_two.to ? pageNumber + 1 : '';

            if (l > 0) {
                this.this_pagination_two.pages = Math.ceil(l / m);
            }
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        resetPaginationTwo() {
            this.this_pagination_two.currentPage = 1;
            this.this_pagination_two.prevPage = '';
            this.this_pagination_two.nextPage = '';
        },
        setFirstPageTwo() {
            this.this_pagination_two.currentPage = 1;
            this.length_two = this.temp_length;
        },
        // added by sohel ends

        formatMe(d) {
            return moment(d).format('YYYY/MM/DD');
        },

        formatTime(d) {
            return moment(d).format('hh:mm:ss A');
        },

        /** Faroque Code Starts Here */
        getPayrunPayslips: function () {

            if (!this.checkNet()) return false;
            //this.showdataoverlay = true;
            axios.get(this.$api_url + '/list-payslips/', {
                params: {
                    search_query_by_id: this.search_by_id,
                    flg: 1
                }
            }).then(function (response) {

                //this.this_employees = response.data.employee_data;

                //this.payslipids = this.$refs.selected

                /* Assingning the Options */
                this.company_options = response.data.options;

                /* Assingning the list */
                this.tmp_custom_list = response.data.employee_data;

                if (this.tmp_custom_list.length > 0) {
                    this.tmp_custom_list.forEach(element => {
                        if (element.id > 0) {
                            let dop = [];
                            if (element.payrun_status != 1 || element.payrun_status == 1) {
                                this.is_action = 1;
                                if (this.$acl['salary-slip'] == 2) {
                                    dop = dop.concat([{ label: 'Review', value: 1 }]);
                                }
                                dop = dop.concat([{ label: 'Preview Tax Card', value: 2 }]);
                                if (this.$acl['createpayslipbyid'] == 2 && element.payrun_status != 1 && element.payrun_status != 0 && element.payrun_status != 2) {
                                    dop = dop.concat([{ label: 'Re Calculate', value: 3 }]);
                                }
                            }

                            element.actions = dop;
                        }
                    });

                }
                this.custom_list = this.tmp_custom_list;
                this.list_key = this.list_key + 1;


            }.bind(this)).catch(function (error) { this.serverError(error); });
        },

        /** Faroque Code Ends Here */




        displaytaxcardmodal: function (payslip_id) {
            this.$bvModal.show('taxcard' + payslip_id);
        },

        showWorkLocationList: function (payrun_id) {
            this.work_location = [];
            this.getWorkLocationData(payrun_id);
            this.$bvModal.show('payrun-work-location-list');
            if (this.fdata.run_type == 11) {
                this.leaver_process = false;
                this.ask_leaver = false;
            }
        },

        getWorkLocationData: function (payrun_id) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/payrun/worklocation/list/' + payrun_id, {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.work_locations = response.data;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        deleteWorkLocationPayslipsPre: function (payrun_id) {
            if (this.work_location.length > 0) {
                this.confirm_box = true;
                this.download_loader_dep = true;
                this.department_loader_text = '';

                axios.get(this.$api_url + '/payrun/department/get-work-location-payslip-count?work_location_ids=' + this.work_location, {
                    params: {
                        payrun_id: payrun_id,
                    }
                }).then(function (response) {
                    this.department_payslips_sum = response.data.payslip_count;
                    this.department_names = response.data.work_location_names;
                    this.download_loader_dep = false;

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            } else {
                this.$bvToast.toast('Please select work location', { title: 'Error!', variant: 'danger', solid: true });
            }
        },

        deleteWorkLocationPayslips: function (payrun_id) {
            if (!this.checkNet()) return false;
            if (this.work_location.length > 0) {
                this.download_loader_dep = true;
                this.department_loader_text = 'Selected payslip(s) delete process in progress...';
                let currentObj = this;
                axios.get(this.$api_url + '/payrun/worklocation/delete?work_location_ids=' + this.work_location, {
                    params: {
                        payrun_id: payrun_id,
                    }
                }).then(function (response) {
                    this.getWorkLocationData(payrun_id);
                    this.getPayrunPayslips();
                    this.download_loader_dep = false;
                    this.work_location = [];
                    this.$cookies.set("payrun_work_location_selected", '', '24h');
                    this.department_loader_text = '';
                    this.department_success_text = 'Selected payslip(s) were deleted successfully.';
                    this.confirm_box = false;
                    this.department_payslips_sum = 0;
                    this.department_names = [];

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            } else {
                this.$bvToast.toast('Please select work location', { title: 'Error!', variant: 'danger', solid: true });
            }
        },

        processWorkLocationPayrunPre: function (payrun_id) {
            if (this.work_location.length > 0) {
                this.confirm_box_create = true;
                this.download_loader_dep = true;
                this.department_loader_text = '';

                axios.get(this.$api_url + '/payrun/department/get-work-location-payslip-count?work_location_ids=' + this.work_location, {
                    params: {
                        payrun_id: payrun_id,
                    }
                }).then(function (response) {
                    this.department_payslips_to_create_sum = response.data.employee_count_payslip;
                    this.department_names = response.data.work_location_names;
                    this.download_loader_dep = false;

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            } else {
                this.$bvToast.toast('Please select work location', { title: 'Error!', variant: 'danger', solid: true });
            }
        },

        processWorkLocationPayrun: function (payrun_id) {
            if (!this.checkNet()) return false;
            if (this.work_location.length == 0) {
                this.$bvToast.toast('Please select work location', { title: 'Error!', variant: 'danger', solid: true });
                return false;
            }
            this.number_of_employees = 0;
            this.progress_value = 0;
            this.loading = 'load';
            this.$cookies.set("payrun_id", payrun_id, '24h');
            // Payrun progress bar code start
            let check_payrun = setInterval(() => {
                axios.get(this.$api_url + '/get-inactive-payrun-payslips?work_location_ids=' + this.work_location + '&payrun_id=' + payrun_id, {
                    params: {

                    }
                }).then(function (response) {
                    //console.log(response.data);
                    if (response.data.payslip_count != 0) {
                        currentObj.payslip_array = response.data;

                        for (let [key, value] of Object.entries(currentObj.payslip_array)) {
                            currentObj.number_of_employees = value.payslip_count;
                            currentObj.progress_value = value.created_payslip_count;
                        }
                    } else {
                        clearInterval(check_payrun);
                    }

                }.bind(this)).catch(function (error) { currentObj.output = error; });
            }, 3000);
            // Payrun progress bar code end
            let currentObj = this;
            axios.get(this.$api_url + '/payrun/worklocation/process?work_location_ids=' + this.work_location, {
                params: {
                    payrun_id: payrun_id,
                }
            }).then(function (response) {
                this.getWorkLocationData(payrun_id);
                this.getPayrunPayslips();
                this.loading = '';
                this.work_location = [];
                this.department_success_text = 'Selected payslip(s) were created successfully.';
                this.$cookies.set("payrun_work_location_selected", '', '24h');
                this.$cookies.set("payrun_id", '', '24h');
                this.confirm_box_create = false;
                this.department_payslips_to_create_sum = 0;
                this.department_names = [];

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        getPayrunDepartmentData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/payrun/department/data/' + this.fdata.id, {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.payrun_department_data = response.data;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        getDepartmentData: function (payrun_id) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/payrun/department/list/' + payrun_id, {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.departments = response.data;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        showDepartmentList: function (payrun_id) {
            this.department = [];
            this.getDepartmentData(payrun_id);
            this.$bvModal.show('payrun-department-list');
            if (this.fdata.run_type == 11) {
                this.leaver_process = false;
                this.ask_leaver = false;
            }
        },


        setDepartment: function () {
            this.$cookies.set("payrun_department_selected", this.department, '24h');
            this.$cookies.set("payrun_work_location_selected", this.work_location, '24h');
        },

        deleteDepartmentPayslipsPre: function (payrun_id) {
            if (this.department.length > 0) {
                this.confirm_box = true;
                this.download_loader_dep = true;
                this.department_loader_text = '';

                axios.get(this.$api_url + '/payrun/department/get-department-payslip-count?department_ids=' + this.department, {
                    params: {
                        payrun_id: payrun_id,
                    }
                }).then(function (response) {
                    this.department_payslips_sum = response.data.payslip_count;
                    this.department_names = response.data.depertments_names;
                    this.download_loader_dep = false;

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            } else {
                this.$bvToast.toast('Please select department', { title: 'Error!', variant: 'danger', solid: true });
            }
        },

        deleteDepartmentPayslips: function (payrun_id) {
            if (!this.checkNet()) return false;

            if (this.department.length > 0) {
                this.download_loader_dep = true;
                this.department_loader_text = 'Selected payslip(s) delete process in progress...';
                let currentObj = this;
                axios.get(this.$api_url + '/payrun/department/delete?department_ids=' + this.department, {
                    params: {
                        payrun_id: payrun_id,
                    }
                }).then(function (response) {
                    this.getDepartmentData(payrun_id);
                    this.getPayrunPayslips();
                    this.download_loader_dep = false;
                    this.department = [];
                    this.$cookies.set("payrun_department_selected", '', '24h');
                    this.department_loader_text = '';
                    this.department_success_text = 'Selected payslip(s) were deleted successfully.';
                    this.confirm_box = false;
                    this.department_payslips_sum = 0;
                    this.department_names = [];

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            } else {
                this.$bvToast.toast('Please select department', { title: 'Error!', variant: 'danger', solid: true });
            }
        },

        processDepartmentPayrunPre: function (payrun_id) {
            if (this.department.length > 0) {
                this.confirm_box_create = true;
                this.download_loader_dep = true;
                this.department_loader_text = '';

                axios.get(this.$api_url + '/payrun/department/get-department-payslip-count?department_ids=' + this.department, {
                    params: {
                        payrun_id: payrun_id,
                    }
                }).then(function (response) {
                    this.department_payslips_to_create_sum = response.data.employee_count_payslip;
                    this.department_names = response.data.depertments_names;
                    this.download_loader_dep = false;

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            } else {
                this.$bvToast.toast('Please select department', { title: 'Error!', variant: 'danger', solid: true });
            }
        },

        processDepartmentPayrun: function (payrun_id) {
            if (!this.checkNet()) return false;
            if (this.department.length == 0) {
                this.$bvToast.toast('Please select department', { title: 'Error!', variant: 'danger', solid: true });
                return false;
            }
            this.number_of_employees = 0;
            this.progress_value = 0;
            this.loading = 'load';
            this.$cookies.set("payrun_id", payrun_id, '24h');

            // Payrun progress bar code start
            let check_payrun = setInterval(() => {
                axios.get(this.$api_url + '/get-inactive-payrun-payslips?department_ids=' + this.department + '&payrun_id=' + payrun_id, {
                    params: {

                    }
                }).then(function (response) {
                    //console.log(response.data);
                    if (response.data.payslip_count != 0) {
                        currentObj.payslip_array = response.data;

                        for (let [key, value] of Object.entries(currentObj.payslip_array)) {
                            currentObj.number_of_employees = value.payslip_count;
                            currentObj.progress_value = value.created_payslip_count;
                        }
                    } else {
                        clearInterval(check_payrun);
                    }

                }.bind(this)).catch(function (error) { currentObj.output = error; });
            }, 3000);
            // Payrun progress bar code end
            let currentObj = this;
            axios.get(this.$api_url + '/payrun/department/process?department_ids=' + this.department, {
                params: {
                    payrun_id: payrun_id,
                }
            }).then(function (response) {
                this.getDepartmentData(payrun_id);
                this.getPayrunPayslips();
                this.loading = '';
                this.department = [];
                this.department_success_text = 'Selected payslip(s) were created successfully.';
                this.$cookies.set("payrun_department_selected", '', '24h');
                this.$cookies.set("payrun_id", '', '24h');
                this.confirm_box_create = false;
                this.department_payslips_to_create_sum = 0;
                this.department_names = [];
                this.ask_leaver = true;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        onHiddenPayrun: function () {
            console.log('the modal was hidden');
            this.leaver_process = true;
            this.ask_leaver = true;
            this.show_leaver = false;
            this.confirm_box = false;
            this.confirm_box_create = false;
            this.bonus_export = false;
            //window.location.reload();
        },

        showLeaveEncashmentList: function (payrun_id) {
            let currentObj = this;
            let formData = new FormData();
            formData.append('fiscal_year', this.fdata.fiscal_year);
            formData.append('month', this.fdata.month);
            formData.append('payrun_id', this.fdata.id);

            axios.get(this.$api_url + '/leave-encashment-list?payrun_id=' + this.fdata.id)

                .then(function (response) {
                    //console.log(response.data);
                    currentObj.encashment_list = response.data.success;

                    currentObj.length_options = [{ value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                    ];
                })

                .catch(function (error) {

                    currentObj.output = error;

                });
            this.$bvModal.show('leave-encashment-list');
            this.employeeids = [];
        },

        processLeaveEncashment: function () {
            if (this.employeeids.length < 1) {
                alert('Please select employee(s).');
                return false;
            }
            this.encashment_processing = true;
            let currentObj = this;

            let formData = new FormData();
            formData.append('employeeids', this.employeeids);
            formData.append('fiscal_year', this.fdata.fiscal_year);
            formData.append('month', this.fdata.month);
            formData.append('payrun_id', this.fdata.id);

            axios.post(this.$api_url + '/process-leave-encashment', formData)

                .then(function (response) {
                    //console.log('Employee IDs: '+currentObj.employeeids.length);
                    currentObj.showLeaveEncashmentList();
                    currentObj.encashment_processing = false;
                })

                .catch(function (error) {

                    currentObj.output = error;

                });
        },

        processSingleLeaveEncashment: function (employee_id) {
            this.single_employee_id = employee_id;
            this.encashment_processing = true;
            let currentObj = this;

            let formData = new FormData();
            formData.append('employeeids', this.single_employee_id);
            formData.append('fiscal_year', this.fdata.fiscal_year);
            formData.append('month', this.fdata.month);
            formData.append('payrun_id', this.fdata.id);

            axios.post(this.$api_url + '/process-leave-encashment', formData)

                .then(function (response) {
                    //console.log('Employee IDs: '+currentObj.employeeids.length);
                    currentObj.showLeaveEncashmentList();
                    currentObj.encashment_processing = false;
                })

                .catch(function (error) {

                    currentObj.output = error;

                });
        },

        reverseLeaveEncashment: function () {
            this.encashment_processing = true;
            let currentObj = this;

            let formData = new FormData();
            formData.append('employeeids', this.employeeids);
            formData.append('fiscal_year', this.fdata.fiscal_year);
            formData.append('month', this.fdata.month);
            formData.append('payrun_id', this.fdata.id);

            axios.post(this.$api_url + '/undo-process-leave-encashment', formData)

                .then(function (response) {
                    //console.log('Employee IDs: '+currentObj.employeeids.length);
                    currentObj.showLeaveEncashmentList();
                    currentObj.encashment_processing = false;
                })

                .catch(function (error) {

                    currentObj.output = error;

                });
        },

        undoLeaveEncashment: function (employee_id) {
            this.encashment_processing = true;
            let currentObj = this;

            let formData = new FormData();
            formData.append('employeeids', employee_id);
            formData.append('fiscal_year', this.fdata.fiscal_year);
            formData.append('month', this.fdata.month);
            formData.append('payrun_id', this.fdata.id);

            axios.post(this.$api_url + '/undo-single-leave-encashment', formData)

                .then(function (response) {
                    //console.log('Employee IDs: '+currentObj.employeeids.length);
                    currentObj.showLeaveEncashmentList();
                    currentObj.encashment_processing = false;
                })

                .catch(function (error) {

                    currentObj.output = error;

                });
        },

        getCompanyAddons: function () {

            axios.get(this.$api_url + '/company/get-addons', {

            }).then(function (response) {

                this.addons = response.data;
                if (this.addons.includes('LeaveAttendances')) {
                    console.log(this.addons);
                }
                //console.log(this.addons);


            }.bind(this));
        },


        displaychallanmodal: function (payrun_id) {


            /////////init for modal/////
            this.users = [],
                this.challanemployees = [],
                this.employeenames = [],
                this.employeetds = [],
                this.employeeetins = [],
                this.challanfdata = [],

                this.modalsuccess = '',
                this.company_code = '',
                this.company_name = '',
                this.company_address = '',
                this.tds_field = '',
                this.tds_remaining = '',
                this.tds_total = 0,
                this.employee_counter = 0,
                this.current_employee_id = '',
                this.current_employee_etin = '',
                ///////////////////////////
                this.getCompanyinfo();
            this.$bvModal.show('challan_modal');
        },



        displaynewpayslipmodal: function (payrun_id) {
            this.resetPagination();
            this.employee_np = [];
            this.getEmployeesnewpayslip();
            this.$bvModal.show('new_payslip_modal');
        },


        linkGen: function (pageNum) {
            if (this.link_tracker != this.pagination.currentPage) {
                this.link_tracker = this.pagination.currentPage;
                this.getPayrunPayslips();
                this.sortBy('employee_name');
            }

        },




        getOptimized: function (pageflg) {

            this.pagination.currentPage = 1;
            axios.get(this.$api_url + '/optimizearrear', {
                params: {
                    gross_salary: this.edit_gross,
                    medical: 1,
                    hra: 1,
                    conv: 1,
                }
            }).then(function (response) {

                this.edit_basic = response.data.data.basic_salary;
                this.edit_hra = response.data.data.house_rent;
                this.edit_medical = response.data.data.medical_allowance;
                this.edit_conv = response.data.data.conveyance_allowance;
                //console.log(response.data.data.basic_salary);


            }.bind(this));

            // this.getchallans();
        },



        calculateGross: function (pageflg) {

            var basic = ",0";
            if (this.edit_basic != "")
                basic = this.edit_basic + ",";

            var hra = ",0";
            if (this.edit_hra != "")
                hra = this.edit_hra + ",";


            var medical = ",0";
            if (this.edit_medical != "")
                medical = this.edit_medical + ",";


            var conv = ",0";
            if (this.edit_conv != "")
                conv = this.edit_conv + ",";



            this.edit_gross = parseInt(basic.replaceAll(",", "")) + parseInt(hra.replaceAll(",", "")) + parseInt(medical.replaceAll(",", "")) + parseInt(conv.replaceAll(",", ""));


            this.custom_gross_heads_models.forEach(element => {
                // element.value = element.value + ",";
                this.edit_gross = parseInt(this.edit_gross) + parseInt((element.value).toString().replace(/,/g, ""));
            });
        },

        displaymodal_recalculate: function (payslip_id, employee_id, fiscal_year) {
            this.employee_id = employee_id;
            this.fadatamodal.id = payslip_id;
            this.fiscal_year = fiscal_year;
            this.setSearchmodal();
            this.$bvModal.show('payslip_modal_recalculate');
        },
        displaymodal: function (payslip_id, employee_id, fiscal_year, from_date, to_date, pay_slip_ref, pay_slip_name, employee_name, pic, position, ait, medical_reimbursement) {
            //alert(payslip_id);

            /*this.getFiscalyears(); */
            //alert(pay_slip_ref);
            this.payslip_loader_text = 'We are preparing the data for this employee.';
            this.pre_gross_flag = 0;
            this.fixed_component_edit_status = '';

            let pay_run_type = parseInt(this.fdata.run_type);

            if (pay_run_type == 11 || pay_run_type == 12)
                this.show_edit_div = 1;

            this.medical_reimbursement_value = medical_reimbursement;


            this.medical_reimbursement_value_display = medical_reimbursement;
            if (parseInt(medical_reimbursement) > 0)
                this.medical_reimbursement_show_control = 0;


            this.ait_adjust_value = ait;
            this.fiscal_year = fiscal_year;
            this.employee_id = employee_id;
            this.from_date = from_date;
            this.to_date = to_date;
            this.pay_slip_ref = pay_slip_ref;
            this.fadatamodal.id = payslip_id;
            this.fadatamodal.employee_name = employee_name;
            this.fadatamodal.pic = pic;
            this.fadatamodal.position = position;
            this.fadatamodal.employee_id = employee_id;
            this.success = '';

            //this.setSearchmodal();
            if (this.from_date != '') {
                this.createTag();
            }
            this.getSalaryDataFromDB('no');
            this.pay_slip_name = pay_slip_name;



            this.$bvModal.show('payslip_modal');
        },



        getTotalChallan: function (pageflg) {
            this.pagination.currentPage = 1;
            axios.get(this.$api_url + '/getpayrunid/' + this.fdata.month + '/' + this.fdata.fiscal_year, {
                params: {
                    page: this.pagination.currentPage,
                    per_page: this.per_page,
                    search_query: '',
                    search_query_by_id: '',
                }
            }).then(function (response) {

                this.fdata.total_challans = response.data.number_of_challan;


            }.bind(this));

            // this.getchallans();
        },


        showApproveModal: function (pageflg) {
            this.approvepass = "";
            this.$bvModal.show('pass-modal');
        },


        showDeleteModal: function (pageflg) {
            this.approvepass = "";
            this.payrun_delete_msg = "Are you sure to delete this payrun (" + this.fdata.month + ", " + this.fdata.year + ")?";
            this.$bvModal.show('delete-payrun-modal');
        },




        approvePayrun: function (pageflg) {
            // var pass = prompt(" Are you sure to Approve? \n All the previous payrun/payslips will be locked after this process is done. \n Please enter your password to continue:", "");

            // alert(pageflg);

            if (this.approvepass != '') {
                var pass = this.approvepass;
                this.loading = 'load';

                this.pagination.currentPage = 1;
                axios.get(this.$api_url + '/payrun-update-status/' + pageflg + '/1', {
                    params: {
                        jsonmode: 'on',
                        pass: pass,
                    }
                }).then(function (response) {

                    this.fdata.status = response.data.success;
                    if (this.fdata.status == '1') {
                        this.incorrectpass = '';
                        this.$bvModal.hide('pass-modal');

                    }
                    else {
                        this.incorrectpass = "Incorrect Password";
                    }
                    this.loading = '';


                }.bind(this));
            }

            // this.getchallans();
        },

        destroyMask: function (string) {
            return string.replace(/\,/g, '');
        },


        deletePayrun: function (modification_flag) {
            var msg = "Are you Sure?";
            var routename = "";
            if (modification_flag == 1) {
                msg = "Are you sure to reset this Payrun?";
                routename = 'resetpayrun';
            }

            if (modification_flag == 2) {
                msg = "Are you sure to delete this Payrun?";
                routename = 'deletepayrun';
            }

            if (this.approvepass != '') {
                var pass = this.approvepass;
                this.loading = 'load';

                axios.get(this.$api_url + '/' + routename + '/' + this.fdata.id, {
                    params: {
                        page: 1,
                        jsonmode: 'on',
                        pass: pass,
                    }
                }).then(function (response) {


                    if (response.data.success == '1') {
                        this.incorrectpass = '';
                        this.$bvModal.hide('pass-modal');

                        //if(routename=='deletepayrun')
                        window.location.href = this.$api_url + '/payruns';

                    }
                    else {
                        this.incorrectpass = "Incorrect Password";
                    }
                    this.loading = '';

                    if (routename == 'resetpayrun')
                        this.getPayrunPayslips();
                    this.sortBy('employee_name');




                    //this.employees = response.data.data;
                }.bind(this));

            }
            // Mustafijur: 14-05-2026: Starts
            // else{
            //     this.$bvToast.toast('Enter a valid password', {
            //         title: 'Failed',
            //         variant: 'warning',
            //         solid: true
            //     });
            // }
            // Mustafijur: 14-05-2026: Ends
            //  <!-- Abdullah 13-05-26 added this else -->
            else {
                this.incorrectpass = "Please enter your password";
            }


        },

        modifyPayslipsEmail: function (modification_flag) {
            var msg = "Are you Sure?";
            this.emailing_success = '';
            if (modification_flag == 3) {
                if (this.payslipids.length > 100) {
                    alert("You are not allowed to send more than 100 emails in one go!");
                    return false;
                } else if (this.payslipids.length < 1) {
                    alert("Please Select Payslip(s).");
                    return false;
                } else {
                    msg = "Do you want to Email the selected Payslip(s)?";
                    //routename='emailpayslips';
                }
                if (confirm(msg)) {
                    this.emailing = '1';
                    setTimeout(() => {
                        this.emailing = '';
                        this.emailing_success = 'Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';
                        this.modifyPayslips(3);
                    }, 5000);
                }
            }
            if (modification_flag == 4) {
                if (this.payslipids.length > 100) {
                    alert("You are not allowed to send more than 100 emails in one go!");
                    return false;
                } else if (this.payslipids.length < 1) {
                    alert("Please Select TaxCard(s)");
                    return false;
                } else {
                    msg = "Do you want to Email the selected Taxcard(s)?";
                    //routename='emailpayslips';
                }

                if (confirm(msg)) {
                    this.emailing = '1';
                    setTimeout(() => {
                        this.emailing = '';
                        this.emailing_success = 'Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';
                        this.modifyPayslips(4);
                    }, 5000);
                }
            }
        },

        modifyPayslips: function (modification_flag) {

            var routename = "";
            if (modification_flag == 1) {
                var msg = "Are you Sure?";
                msg = "Are you sure to reset the selected Payslips?";
                routename = 'resetpayslips';
            }

            // Abdullah 13-05-26 commented  this
            // if(modification_flag==2)
            // {
            //     var msg="Are you Sure?";
            //     msg="Are you sure to delete the selected Payslips?";
            //     routename='deletepayslips';
            // }

            // Abdullah 13-05-26 edited this
            if (modification_flag == 2) {
                if (this.payslipids.length < 1) {
                    this.$bvToast.toast('Please select at least one payslip to delete.', {
                        title: 'No Payslip Selected',
                        variant: 'warning',
                        solid: true
                    });
                    return false;
                }

                var msg = "Are you Sure?";
                msg = "Are you sure to delete the selected Payslips?";
                routename = 'deletepayslips';
            }


            /*if(modification_flag==3)
            {
            if(this.payslipids.length > 100){
                alert("You are not allowed to send more than 100 emails in one go!");
                return false;
            }else if(this.payslipids.length < 1){
                alert("Please Select Payslip(s).");
                return false;
            }else{
                msg="Do you want to Email the selected Payslip(s)?";
                routename='emailpayslips';
            }
            }*/



            /*if(modification_flag==4)
            {

            if(this.payslipids.length > 100){
                alert("You are not allowed to send more than 100 emails in one go!");
                return false;
            }else if(this.payslipids.length < 1){
                alert("Please Select TaxCard(s)");
                return false;
            }else{
                msg="Do you want to Email the selected Taxcard(s)?";
                routename='emailpayslips';
            }
            }*/

            //console.log(this.payslipids);

            if (modification_flag == 1) {
                if (confirm(msg)) {

                    /*if(modification_flag==3 || modification_flag==4)
                    {
                    //this.emailing='1';
                    this.emailsuccess='';

                    }*/

                    let currentObj = this;

                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }


                    let formData = new FormData();
                    formData.append('payslipids', this.payslipids);
                    formData.append('modification_flag', modification_flag);

                    axios.post(this.$api_url + '/resetpayslips', formData, config)

                        .then(function (response) {

                            currentObj.getPayrunPayslips();
                            currentObj.sortBy('employee_name');
                            //currentObj.emailing='';
                            currentObj.emailsuccess = response.data.success;
                            //console.log('Payslip IDs: '+currentObj.payslipids.length);
                            currentObj.payslipids = [];


                        })

                        .catch(function (error) {

                            currentObj.output = error;

                        });



                }
            } else if (modification_flag == 2) {
                if (confirm(msg)) {

                    /*if(modification_flag==3 || modification_flag==4)
                    {
                    //this.emailing='1';
                    this.emailsuccess='';

                    }*/

                    let currentObj = this;

                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }


                    let formData = new FormData();
                    formData.append('payslipids', this.payslipids);
                    formData.append('modification_flag', modification_flag);

                    axios.post(this.$api_url + '/deletepayslips', formData, config)

                        .then(function (response) {

                            currentObj.getPayrunPayslips();
                            currentObj.sortBy('employee_name');
                            //currentObj.emailing='';
                            currentObj.emailsuccess = response.data.success;
                            //console.log('Payslip IDs: '+currentObj.payslipids.length);
                            currentObj.payslipids = [];


                        })

                        .catch(function (error) {

                            currentObj.output = error;

                        });



                }
            } else {
                let currentObj = this;

                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }


                let formData = new FormData();
                formData.append('payslipids', this.payslipids);
                formData.append('modification_flag', modification_flag);

                axios.post(this.$api_url + '/modifypayslips', formData, config)

                    .then(function (response) {

                        currentObj.getPayrunPayslips();
                        currentObj.sortBy('employee_name');
                        //currentObj.emailing='';
                        currentObj.emailsuccess = response.data.success;
                        //console.log('Payslip IDs: '+currentObj.payslipids.length);
                        currentObj.payslipids = [];


                    })

                    .catch(function (error) {

                        currentObj.output = error;

                    });
            }


        },



        downloadTaxcards: function () {

            if (this.payslipids.length > 0) {
                if (this.payslipids.length > 100) {
                    alert("You are not allowed to download more than 100 Taxcards in one go!");
                    return false;
                } else if (this.payslipids.length < 1) {
                    alert("Please Select Payslip(s).");
                    return false;
                } else {
                    var msg = "Are you sure to download the selected Taxcards?";
                }

                if (confirm(msg)) {

                    let currentObj = this;

                    const config = {
                        headers: { 'Content-Type': 'application/json; charset=utf-8', },
                        responseType: 'blob',
                    }

                    let formData = new FormData();
                    formData.append('payslipids', this.payslipids);
                    //formData.append('modification_flag', modification_flag);
                    currentObj.download_loader = true;
                    currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';

                    axios.post(this.$api_url + '/downloadtaxcards', formData, config)

                        .then(function (response) {

                            if (response.data) {
                                /* var fname = response.data.file_name;
                                if(response.data.download_file_name)
                                var download_f_name =   response.data.download_file_name;
                                else
                                var download_f_name =   fname;
                                if(download_f_name.length>0){
                                    if(currentObj.payslipids.length>1){
                                        window.location.href = currentObj.$api_url+'/downloadziptaxcard?file_name='+fname+'&download_file_name='+download_f_name;
                                    }else{
                                        window.location.href = currentObj.$api_url+'/downloadziptaxcard?file_name='+fname+'&download_file_name='+download_f_name+'&file_count=1';
                                    }
                                }
                                else
                                currentObj.$bvToast.toast('Unable to download. Server error', {title: 'Error!',variant: 'danger',solid: true}); */

                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                                if (response.data.type == 'application/json') {
                                    let file = new Blob([response.data], { type: 'application/json' });
                                    const cast = Promise.resolve(file.text());
                                    cast.then((value) => {
                                        let err_obj = JSON.parse(`${value}`);
                                        currentObj.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                                    });
                                } else {
                                    currentObj.global_download_file_content(response);
                                }
                            } else {
                                currentObj.$bvToast.toast('A previously initiated download process is already in progress. Please try again later.', { title: 'Error!', variant: 'danger', solid: true });
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            }
                        })

                        .catch(function (error) {

                            currentObj.output = error;
                            currentObj.download_loader = false;
                            currentObj.download_text = '';

                        });

                }

            } else {
                this.$bvToast.toast('Please select Employee', { title: 'Error!', variant: 'danger', solid: true });
            }
        },






        downloadAllTaxcards: function () {

            var msg = "Are you sure to download all Taxcards?";
            if (confirm(msg)) {

                let currentObj = this;

                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();
                //formData.append('payslipids', this.payslipids);
                //formData.append('modification_flag', modification_flag);

                //formData.append('payslipids', this.payslipids);
                formData.append('all_payslips', 'yes');

                //alert(this.payrun.id);
                formData.append('payrun_id', this.payrun.id);

                //this.$bvToast.toast('We are processing your download. This may take a while.', {title: 'Downloading!',variant: 'success',solid: true});


                currentObj.download_loader = true;
                currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';

                axios.post(this.$api_url + '/downloadtaxcards', formData, config)

                    .then(function (response) {

                        if (response.data.file_name) {
                            var fname = response.data.file_name;
                            if (response.data.download_file_name)
                                var download_f_name = response.data.download_file_name;
                            else
                                var download_f_name = fname;

                            if (download_f_name.length > 0)
                                window.location.href = currentObj.$api_url + '/downloadziptaxcard?file_name=' + fname + '&download_file_name=' + download_f_name;
                            else
                                currentObj.$bvToast.toast('Unable to download. Server error', { title: 'Error!', variant: 'danger', solid: true });

                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                        }
                        else {
                            currentObj.$bvToast.toast('A previously initiated download process is already in progress. Please try again later.', { title: 'Error!', variant: 'danger', solid: true });
                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                        }
                    })

                    .catch(function (error) {

                        currentObj.output = error;
                        currentObj.download_loader = false;
                        currentObj.download_text = '';

                    });

            }


        },






        downloadPayslips: function () {

            if (this.payslipids.length > 0) {
                if (this.payslipids.length > 100) {
                    alert("You are not allowed to download more than 100 Payslips in one go!");
                    return false;
                } else if (this.payslipids.length < 1) {
                    alert("Please Select Payslip(s).");
                    return false;
                } else {
                    var msg = "Are you sure to download the selected Payslips?";
                }
                if (confirm(msg)) {

                    let currentObj = this;
                    /* const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    } */
                    const config = {
                        headers: { 'Content-Type': 'application/json; charset=utf-8', },
                        responseType: 'blob',
                    }
                    let formData = new FormData();
                    formData.append('payslipids', this.payslipids);
                    currentObj.download_loader = true;
                    currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
                    axios.post(this.$api_url + '/downloadpayslips', formData, config)
                        .then(function (response) {
                            if (response.data) {
                                /* var fname=response.data.file_name;
                                if(response.data.download_file_name)
                                var download_f_name =   response.data.download_file_name;
                                else
                                var download_f_name =   fname;  */
                                /* if(download_f_name.length>0){
                                    if(currentObj.payslipids.length>1){
                                        window.location.href = currentObj.$api_url+'/downloadzippayslip?file_name='+fname+'&download_file_name='+download_f_name;
                                    }else{
                                        window.location.href = currentObj.$api_url+'/downloadzippayslip?file_name='+fname+'&download_file_name='+download_f_name+'&file_count=1';
                                    }
                                }
                                else
                                currentObj.$bvToast.toast('Unable to download. Server error', {title: 'Error!',variant: 'danger',solid: true});
                                currentObj.download_loader = false;
                                currentObj.download_text = '';  */
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                                if (response.data.type == 'application/json') {
                                    let file = new Blob([response.data], { type: 'application/json' });
                                    const cast = Promise.resolve(file.text());
                                    cast.then((value) => {
                                        let err_obj = JSON.parse(`${value}`);
                                        currentObj.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                                    });
                                } else {
                                    currentObj.global_download_file_content(response);
                                }
                            } else {
                                currentObj.$bvToast.toast('A previously initiated download process is already in progress. Please try again later.', { title: 'Error!', variant: 'danger', solid: true });
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            }
                        })
                        .catch(function (error) {
                            currentObj.output = error;
                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                        });
                }
            } else {
                this.$bvToast.toast('Please select Employee', { title: 'Error!', variant: 'danger', solid: true });
            }
        },




        downloadAllPayslips: function () {

            var msg = "Are you sure to download all Payslips?";
            if (confirm(msg)) {

                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                //formData.append('payslipids', this.payslipids);
                formData.append('all_payslips', 'yes');

                //alert(this.payrun.id);
                formData.append('payrun_id', this.payrun.id);

                //this.$bvToast.toast('We are processing your download. This may take a while.', {title: 'Downloading!',variant: 'success',solid: true});

                currentObj.download_loader = true;
                currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
                axios.post(this.$api_url + '/downloadpayslips', formData, config)
                    .then(function (response) {
                        if (response.data.file_name) {
                            var fname = response.data.file_name;
                            if (response.data.download_file_name)
                                var download_f_name = response.data.download_file_name;
                            else
                                var download_f_name = fname;
                            if (download_f_name.length > 0)
                                window.location.href = currentObj.$api_url + '/downloadzippayslip?file_name=' + fname + '&download_file_name=' + download_f_name;
                            else
                                currentObj.$bvToast.toast('Unable to download. Server error', { title: 'Error!', variant: 'danger', solid: true });

                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                        } else {
                            currentObj.$bvToast.toast('A previously initiated download process is already in progress. Please try again later.', { title: 'Error!', variant: 'danger', solid: true });
                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                        }
                    })
                    .catch(function (error) {
                        currentObj.output = error;
                        currentObj.download_loader = false;
                        currentObj.download_text = '';
                    });
            }

        },





        downloadBankfile: function (bank_name) {

            window.location.href = this.$api_url + '/payroll_bankfile?payrun_id=' + this.fdata.id + '&bank_name=' + bank_name + '&bank_template=' + bank_name;

        },






        redirect_to_payruns: function () {
            window.location.href = this.$api_url + '/payruns?fiscal_year=' + this.search.fiscal_year + '&month=' + this.search.month;
        },

        saveAIT: function () {
            this.$bvModal.hide('payslip_modal');
            this.getPayrunPayslips();
            this.sortBy('employee_name');
        },



        savemri: function () {

            this.getPayrunPayslips();
            this.sortBy('employee_name');
        },


        removemri: function () {
            this.medical_reimbursement_show_control = '';
            this.medical_reimbursement_value = 0;

            //document.getElementById('mri_add').click();

            this.getPayrunPayslips();
            this.sortBy('employee_name');
        },




        getpayrunsfiscalyear: function () {

            axios.get(this.$api_url + '/list-payruns-fiscalyear/0', {
                params: {
                    page: this.pagination.currentPage,
                    per_page: 100,
                    search_query: '',
                    search_query_by_id: '',
                }
            }).then(function (response) {
                this.payrunsfiscalyear = response.data.data;

                this.pagination.from = response.data.from;
                this.pagination.to = response.data.to;
                this.pagination.total = response.data.total;

                if (this.pagination.to == this.pagination.total) {

                    this.pagination.nextbuttonstatus = 'disabled';

                }
                else {
                    this.pagination.nextbuttonstatus = '';
                }

                if (this.pagination.from == 1) {
                    this.pagination.prebuttonstatus = 'disabled';
                }
                else {
                    this.pagination.prebuttonstatus = '';
                }



                if (this.pagination.currentPage < response.data.last_page)
                    this.pagination.nextPage = this.pagination.currentPage + 1;

                if (this.pagination.currentPage == 1)
                    this.pagination.prevPage = 1;
                else
                    this.pagination.prevPage = this.pagination.currentPage - 1;
            }.bind(this));
        },



        setSearch: function (pageflg) {
            this.pagination.currentPage = 1;
            this.getPayrunPayslips();
            this.sortBy('employee_name');
        },
        setPagination: function (pageflg) {
            if (pageflg)
                this.pagination.currentPage = this.pagination.nextPage;
            else
                this.pagination.currentPage = this.pagination.prevPage;

            this.getPayrunPayslips();
            this.sortBy('employee_name');
        },
        getpayslips: function () {
            this.payslip_loading = 1;

            axios.get(this.$api_url + '/list-payslips', {
                params: {
                    page: this.pagination.currentPage,
                    per_page: this.per_page,
                    search_query: this.search,
                    search_query_by_id: this.search_by_id,
                }
            }).then(function (response) {

                //console.log(response.data[1]);
                // alert(response.data.data.allparams);
                //alert(this.search.allparams);
                this.payslip_loading = 0;
                if (response.data[1] == this.search.allparams)
                    this.payslips = response.data[0].data;                //response.data.data;

                this.pagination.from = response.data[0].from;
                this.pagination.to = response.data[0].to;
                this.pagination.total = response.data[0].total;


                if (this.pagination.total > 0) {
                    this.pagination_length = Math.ceil((this.pagination.total / this.per_page));
                }


                if (this.pagination.to == this.pagination.total) {

                    this.pagination.nextbuttonstatus = 'disabled';

                }
                else {
                    this.pagination.nextbuttonstatus = '';
                }

                if (this.pagination.from == 1) {
                    this.pagination.prebuttonstatus = 'disabled';
                }
                else {
                    this.pagination.prebuttonstatus = '';
                }



                if (this.pagination.currentPage < response.data.last_page)
                    this.pagination.nextPage = this.pagination.currentPage + 1;

                if (this.pagination.currentPage == 1)
                    this.pagination.prevPage = 1;
                else
                    this.pagination.prevPage = this.pagination.currentPage - 1;
            }.bind(this));
        },


        /******* Payslip Modal Methods starts**************/

        createTag: function () {
            //alert(this.from_date);
            var fromdate = this.from_date;
            var fromdatearray = fromdate.split("-");
            var mnth = fromdatearray[1];
            var month = "";
            var day = "";
            var year = fromdatearray[0];
            if (mnth == "01")
                month = "January";

            if (mnth == "02")
                month = "February";

            if (mnth == "03")
                month = "March";

            if (mnth == "04")
                month = "April";

            if (mnth == "05")
                month = "May";

            if (mnth == "06")
                month = "June";

            if (mnth == "07")
                month = "July";

            if (mnth == "08")
                month = "August";

            if (mnth == "09")
                month = "September";

            if (mnth == "10")
                month = "October";

            if (mnth == "11")
                month = "November";

            if (mnth == "12")
                month = "December";

            if (mnth == "09" || mnth == "04" || mnth == "06" || mnth == "11")
                day = "30";
            else
                day = "31";

            this.to_date = day + " " + month + ", " + year;

            var employee_name = "Employee";
            var employeearray = this.employees;
            this.employees.forEach((value, index) => {
                if (this.employee_id == value.employee_id)
                    employee_name = value.name;
                //console.log(value.name);
                //console.log(index);
            });

            //this.pay_slip_name="Salary Slip of "+employee_name+" for "+month+", "+year;
            //this.pay_slip_ref=this.employee_id+"-"+month+"-"+year;
            this.month = month;
            this.year = year;



        },

        setSearchmodal: function (pageflg) {
            if (this.from_date != '')
                this.createTag();
            this.getSalaryinfo();
        },

        showAdhoc: function (pageflg) {
            document.getElementById("adhoc_div").style.display = "block";
            document.getElementById("adhoc_link_div").style.display = "none";
            document.getElementById("status_div").style.display = "none";

        },

        hideAdhoc: function (pageflg) {
            document.getElementById("adhoc_div").style.display = "none";
            document.getElementById("adhoc_link_div").style.display = "block";
            document.getElementById("status_div").style.display = "block";

        },

        removeItem: function (pageflg) {
            //alert(pageflg);
            if (confirm("Are you Sure to Delete?")) {
                axios.get(this.$api_url + '/delete-adhoc/' + pageflg, {
                    params: {
                        page: 1,

                    }
                }).then(function (response) {
                    this.getSalaryinfo();
                    this.getSalaryDataFromDB('update');

                }.bind(this));
            }

        },

        reviewed: function (pageflg) {

            axios.get(this.$api_url + '/review-status/' + pageflg, {
                params: {
                    page: 1,

                }
            }).then(function (response) {
                //this.getSalaryinfo();
                this.$bvModal.hide('payslip_modal');
                this.getPayrunPayslips();
                this.sortBy('employee_name');

            }.bind(this));


        },

        saveAdhoc: function (pageflg) {
            if (this.adhoc_field == "") {
                alert("Please Choose an Adhoc Head");
            }
            else {
                if (this.adhoc_field_value == "")
                    alert("Please Enter Adhoc Head Value");
            }


        },

        saveBonusIncentive: function (pageflg) {
            if (this.bonus_incentive_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.bonus_incentive_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeManual: function (pageflg) {
            if (this.overtime_holiday_manual_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_manual_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeFixed: function (pageflg) {
            if (this.overtime_holiday_fixed_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_fixed_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeIncrementalDays: function (pageflg) {
            if (this.overtime_holiday_incremental_days_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_incremental_days_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeIncrementalHours: function (pageflg) {
            if (this.overtime_holiday_incremental_hours_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_incremental_hours_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeManualNonTaxable: function (pageflg) {
            if (this.overtime_holiday_manual_non_taxable_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_manual_non_taxable_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeFixedNonTaxable: function (pageflg) {
            if (this.overtime_holiday_fixed_non_taxable_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_fixed_non_taxable_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeIncrementalDaysNonTaxable: function (pageflg) {
            if (this.overtime_holiday_incremental_days_non_taxable_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_incremental_days_non_taxable_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        saveOvertimeIncrementalHoursNonTaxable: function (pageflg) {
            if (this.overtime_holiday_incremental_hours_non_taxable_field == "") {
                alert("Please Choose an Bonus Head");
            }
            else {
                if (this.overtime_holiday_incremental_hours_non_taxable_field_value == "")
                    alert("Please Enter Bonus Head Value");
            }


        },

        savePreLopManual: function (pageflg) {
            if (this.pre_deduction_manual_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.pre_deduction_manual_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        savePreLopFixed: function (pageflg) {
            if (this.pre_deduction_fixed_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.pre_deduction_fixed_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        savePreLopIncrementalDays: function (pageflg) {
            if (this.pre_deduction_incremental_days_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.pre_deduction_incremental_days_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        savePreLopIncrementalHours: function (pageflg) {
            if (this.pre_deduction_incremental_hours_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.pre_deduction_incremental_hours_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        savePostLopManual: function (pageflg) {
            if (this.post_deduction_manual_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.post_deduction_manual_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        savePostLopFixed: function (pageflg) {
            if (this.post_deduction_fixed_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.post_deduction_fixed_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        savePostLopIncrementalDays: function (pageflg) {
            if (this.post_deduction_incremental_days_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.post_deduction_incremental_days_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        savePostLopIncrementalHours: function (pageflg) {
            if (this.post_deduction_incremental_hours_field == "") {
                alert("Please Choose an Deduction Head");
            }
            else {
                if (this.post_deduction_incremental_hours_field_value == "")
                    alert("Please Enter Deduction Head Value");
            }


        },

        getEmployees: function () {

            axios.get(this.$api_url + '/getemployees', {
                params: {
                    page: 1,
                    per_page: 1000000,
                    search_query: this.search,
                    search_query_by_id: '',
                }
            }).then(function (response) {
                this.employees = response.data.data;


            }.bind(this));
        },


        update_fixed_salary: function () {
            let formData = new FormData();
            this.custom_gross_heads_models.forEach(element => {
                element.title = element.title.replace(/ /g, "_");
                formData.append(element.title, element.value);
            });
            formData.append('payslip_id', this.fadatamodal.id);

            axios.post(this.$api_url + '/add-custom-arrear-data', formData)
                .then(function (response) {

                })
                .catch(function (error) {
                    currentObj.output = error;
                    currentObj.download_loader = false;
                    currentObj.download_text = '';
                });

            axios.get(this.$api_url + '/update_fixed_salary', {
                params: {
                    basic: this.edit_basic,
                    conv: this.edit_conv,
                    medical: this.edit_medical,
                    hra: this.edit_hra,
                    payslip_id: this.fadatamodal.id,
                }
            }).then(function (response) {

                this.fixed_component_edit_status = response.data.success;
                this.getSalaryinfo();


            }.bind(this));
        },

        getFiscalyears: function () {

            axios.get(this.$api_url + '/getfiscalyears', {
                params: {
                    page: 1,
                    per_page: 10,
                    search_query: this.search,
                    search_query_by_id: '',
                }
            }).then(function (response) {
                this.fiscalyears = response.data;


            }.bind(this));
        },



        getSalaryinfo: function () {
            this.payslip_loader = true;
            axios.get(this.$api_url + '/salary-slip/' + this.employee_id, {
                params: {
                    fiscal_year: this.fiscal_year,
                    payslip_id: this.fadatamodal.id,
                    search_query_by_id: '',
                }
            }).then(function (response) {
                //alert(response.data.salary);
                //this.getPayrunPayslips();
                this.getPayrunPayslips();
                this.sortBy('employee_name');

                var test = response.data.salary;

                this.salaryheads = response.data.salary;
                /* Added by Sohel starts */
                this.salaryheads.forEach(element => {

                    if (element.field_key == 'basic_salary_before_pregross' || element.field_key == 'house_rent_before_pregross' || element.field_key == 'conveyance_allowance_before_pregross' || element.field_key == 'medical_allowance_before_pregross') {
                        this.pre_gross_flag = 1;
                    }

                });
                /* Added by Sohel ends */
                this.slabs_and_values = response.data.slabsnvalues;
                this.taxinfo = response.data.tax;
                this.adhocfields = response.data.adhocfields;
                this.adhocdeductionfields = response.data.adhocdeductionfields;
                this.adhocpredeductionfields = response.data.adhocpredeductionfields;
                this.adhocheadsnvalues = response.data.adhocheadsnvalues;
                this.adhocnontaxablefields = response.data.adhocnontaxablefields;
                this.contracted_variable_fields = response.data.contracted_variable_fields;
                this.bonus_incentive_fields = response.data.bonus_incentive_fields;
                this.overtime_holiday_manual_fields = response.data.overtime_holiday_manual_fields;
                this.overtime_holiday_fixed_fields = response.data.overtime_holiday_fixed_fields;
                this.overtime_holiday_incremental_days_fields = response.data.overtime_holiday_incremental_days_fields;
                this.overtime_holiday_incremental_hours_fields = response.data.overtime_holiday_incremental_hours_fields;
                this.overtime_holiday_manual_non_taxable_fields = response.data.overtime_holiday_manual_nontax_fields;
                this.overtime_holiday_fixed_non_taxable_fields = response.data.overtime_holiday_fixed_nontax_fields;
                this.overtime_holiday_incremental_days_non_taxable_fields = response.data.overtime_holiday_incremental_days_nontax_fields;
                this.overtime_holiday_incremental_hours_non_taxable_fields = response.data.overtime_holiday_incremental_hours_nontax_fields;

                this.pre_deduction_manual_fields = response.data.pre_deduction_manual_fields;
                this.pre_deduction_fixed_fields = response.data.pre_deduction_fixed_fields;
                this.pre_deduction_incremental_days_fields = response.data.pre_deduction_incremental_days_fields;
                this.pre_deduction_incremental_hours_fields = response.data.pre_deduction_incremental_hours_fields;

                this.post_deduction_manual_fields = response.data.post_deduction_manual_fields;
                this.post_deduction_fixed_fields = response.data.post_deduction_fixed_fields;
                this.post_deduction_incremental_days_fields = response.data.post_deduction_incremental_days_fields;
                this.post_deduction_incremental_hours_fields = response.data.post_deduction_incremental_hours_fields;



                test.forEach((value, index) => {

                    if (value.head == "Basic Salary")
                        this.edit_basic = value.value;

                    if (value.head == "House Rent Allowance")
                        this.edit_hra = value.value;


                    if (value.head == "Conveyance Allowance")
                        this.edit_conv = value.value;


                    if (value.head == "Medical Allowance")
                        this.edit_medical = value.value;



                    let arr_field_val = value.value;
                    //alert(arr_field_val);

                    if (value.head == "Arrear Basic Salary" && arr_field_val.length > 0)
                        this.edit_basic = value.value;

                    if (value.head == "Arrear House Rent Allowance" && arr_field_val.length > 0)
                        this.edit_hra = value.value;

                    if (value.head == "Arrear Conveyance Allowance" && arr_field_val.length > 0)
                        this.edit_conv = value.value;

                    if (value.head == "Arrear Medical Allowance" && arr_field_val.length > 0)
                        this.edit_medical = value.value;

                    this.custom_gross_heads_models.forEach(element => {
                        if ("Arrear " + element.title == value.head) {
                            element.value = value.value;
                        }
                    });


                    this.calculateGross();

                    //console.log(index);
                });
                this.getSalaryDataFromDB('update');
                if (this.success_msg) {
                    this.$bvToast.toast('Payslip updated successfully', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
                }
                this.payslip_loader = false;



            }.bind(this));
        },

        getSalaryDataFromDB: function (is_taxcard) {
            this.payslip_loader = true;
            axios.get(this.$api_url + '/salary-slip-db/' + this.employee_id, {
                params: {
                    fiscal_year: this.fiscal_year,
                    payslip_id: this.fadatamodal.id,
                    is_taxcard: is_taxcard,
                    search_query_by_id: '',
                }
            }).then(function (response) {
                //alert(response.data.salary);
                //this.getPayrunPayslips();
                this.getPayrunPayslips();
                this.sortBy('employee_name');

                var test = response.data.salary;

                this.salaryheads = response.data.salary;
                /* Added by Sohel starts */
                this.salaryheads.forEach(element => {

                    if (element.field_key == 'basic_salary_before_pregross' || element.field_key == 'house_rent_before_pregross' || element.field_key == 'conveyance_allowance_before_pregross' || element.field_key == 'medical_allowance_before_pregross') {
                        this.pre_gross_flag = 1;
                    }

                });
                /* Added by Sohel ends */
                this.slabs_and_values = response.data.slabsnvalues;
                this.taxinfo = response.data.tax;
                this.adhocfields = response.data.adhocfields;
                this.adhocdeductionfields = response.data.adhocdeductionfields;
                this.adhocpredeductionfields = response.data.adhocpredeductionfields;
                this.adhocheadsnvalues = response.data.adhocheadsnvalues;
                this.adhocnontaxablefields = response.data.adhocnontaxablefields;
                this.contracted_variable_fields = response.data.contracted_variable_fields;
                this.bonus_incentive_fields = response.data.bonus_incentive_fields;
                this.overtime_holiday_manual_fields = response.data.overtime_holiday_manual_fields;
                this.overtime_holiday_fixed_fields = response.data.overtime_holiday_fixed_fields;
                this.overtime_holiday_incremental_days_fields = response.data.overtime_holiday_incremental_days_fields;
                this.overtime_holiday_incremental_hours_fields = response.data.overtime_holiday_incremental_hours_fields;
                this.overtime_holiday_manual_non_taxable_fields = response.data.overtime_holiday_manual_nontax_fields;
                this.overtime_holiday_fixed_non_taxable_fields = response.data.overtime_holiday_fixed_nontax_fields;
                this.overtime_holiday_incremental_days_non_taxable_fields = response.data.overtime_holiday_incremental_days_nontax_fields;
                this.overtime_holiday_incremental_hours_non_taxable_fields = response.data.overtime_holiday_incremental_hours_nontax_fields;

                this.pre_deduction_manual_fields = response.data.pre_deduction_manual_fields;
                this.pre_deduction_fixed_fields = response.data.pre_deduction_fixed_fields;
                this.pre_deduction_incremental_days_fields = response.data.pre_deduction_incremental_days_fields;
                this.pre_deduction_incremental_hours_fields = response.data.pre_deduction_incremental_hours_fields;

                this.post_deduction_manual_fields = response.data.post_deduction_manual_fields;
                this.post_deduction_fixed_fields = response.data.post_deduction_fixed_fields;
                this.post_deduction_incremental_days_fields = response.data.post_deduction_incremental_days_fields;
                this.post_deduction_incremental_hours_fields = response.data.post_deduction_incremental_hours_fields;



                test.forEach((value, index) => {

                    if (value.head == "Basic Salary")
                        this.edit_basic = value.value;

                    if (value.head == "House Rent Allowance")
                        this.edit_hra = value.value;


                    if (value.head == "Conveyance Allowance")
                        this.edit_conv = value.value;


                    if (value.head == "Medical Allowance")
                        this.edit_medical = value.value;



                    let arr_field_val = value.value;
                    //alert(arr_field_val);

                    if (value.head == "Arrear Basic Salary" && arr_field_val.length > 0)
                        this.edit_basic = value.value;

                    if (value.head == "Arrear House Rent Allowance" && arr_field_val.length > 0)
                        this.edit_hra = value.value;

                    if (value.head == "Arrear Conveyance Allowance" && arr_field_val.length > 0)
                        this.edit_conv = value.value;

                    if (value.head == "Arrear Medical Allowance" && arr_field_val.length > 0)
                        this.edit_medical = value.value;

                    this.custom_gross_heads_models.forEach(element => {
                        if ("Arrear " + element.title == value.head) {
                            element.value = value.value;
                        }
                    });


                    this.calculateGross();

                    //console.log(index);
                });
                if (is_taxcard != 'update') {
                    this.payslip_loader = false;
                }

                if (is_taxcard == 'update') {
                    this.success_msg = true;
                }



            }.bind(this));
        },



        setSalaryinfo: function () {
            //
        },

        onHidden(e) {
            if (this.closePayslipModal == false) {
                this.success_msg = false;
                if (this.add_adhc_fields_arr.length > 0) {
                    if (this.add_adhc_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_manual_arr.length > 0) {
                    if (this.add_adhc_fields_manual_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_fixed_arr.length > 0) {
                    if (this.add_adhc_fields_fixed_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_days_arr.length > 0) {
                    if (this.add_adhc_fields_days_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_hours_arr.length > 0) {
                    if (this.add_adhc_fields_hours_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_nontax_arr.length > 0) {
                    if (this.add_adhc_fields_nontax_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_nontax_manual_arr.length > 0) {
                    if (this.add_adhc_fields_nontax_manual_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_nontax_fixed_arr.length > 0) {
                    if (this.add_adhc_fields_nontax_fixed_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_nontax_days_arr.length > 0) {
                    if (this.add_adhc_fields_nontax_days_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_nontax_hours_arr.length > 0) {
                    if (this.add_adhc_fields_nontax_hours_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_adhc_fields_contracted_arr.length > 0) {
                    if (this.add_adhc_fields_contracted_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_pre_deduction_fields_arr.length > 0) {
                    if (this.add_pre_deduction_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_pre_manual_fields_arr.length > 0) {
                    if (this.add_pre_manual_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_pre_fixed_fields_arr.length > 0) {
                    if (this.add_pre_fixed_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_pre_days_fields_arr.length > 0) {
                    if (this.add_pre_days_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_pre_hours_fields_arr.length > 0) {
                    if (this.add_pre_hours_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_post_deduction_fields_arr.length > 0) {
                    if (this.add_post_deduction_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_post_manual_fields_arr.length > 0) {
                    if (this.add_post_manual_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_post_fixed_fields_arr.length > 0) {
                    if (this.add_post_fixed_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_post_days_fields_arr.length > 0) {
                    if (this.add_post_days_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else if (this.add_post_hours_fields_arr.length > 0) {
                    if (this.add_post_hours_fields_arr[0].value != '') {
                        e.preventDefault();
                        this.$bvModal.show('unsaved-alert-modal');
                    } else {
                        this.$bvModal.hide('payslip_modal');
                    }
                } else {
                    this.$bvModal.hide('payslip_modal');
                }
            }

            console.log(this.success_msg);
            console.log(this.add_adhc_fields_arr);
        },

        hidePayslipModal: function () {
            this.closePayslipModal = true;
            this.$bvModal.hide('payslip_modal');
            this.$bvModal.hide('unsaved-alert-modal');
            this.add_adhc_fields_arr = [];
            this.add_adhc_fields_manual_arr = [];
            this.add_adhc_fields_fixed_arr = [];
            this.add_adhc_fields_days_arr = [];
            this.add_adhc_fields_hours_arr = [];
            this.add_adhc_fields_nontax_arr = [];
            this.add_adhc_fields_nontax_manual_arr = [];
            this.add_adhc_fields_nontax_fixed_arr = [];
            this.add_adhc_fields_nontax_days_arr = [];
            this.add_adhc_fields_nontax_hours_arr = [];
            this.add_adhc_fields_contracted_arr = [];
            this.add_pre_deduction_fields_arr = [];
            this.add_pre_manual_fields_arr = [];
            this.add_pre_fixed_fields_arr = [];
            this.add_pre_days_fields_arr = [];
            this.add_pre_hours_fields_arr = [];
            this.add_post_deduction_fields_arr = [];
            this.add_post_manual_fields_arr = [];
            this.add_post_fixed_fields_arr = [];
            this.add_post_days_fields_arr = [];
            this.add_post_hours_fields_arr = [];
        },





        formSubmit(e) {

            e.preventDefault();

            this.success_msg = false;
            this.payslip_loader = true;

            let currentObj = this;



            const config = {

                headers: { 'content-type': 'multipart/form-data' }

            }



            let formData = new FormData();

            //formData.append('filename', this.image);

            //alert(this.pay_slip_ref);

            if (this.add_adhc_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_arr, this.adhoc_field_arr, this.adhoc_field_value_arr);
            }
            if (this.add_adhc_fields_manual_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_manual_arr, this.overtime_holiday_manual_field_arr, this.overtime_holiday_manual_field_value_arr);
            }
            if (this.add_adhc_fields_fixed_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_fixed_arr, this.overtime_holiday_fixed_field_arr, this.overtime_holiday_fixed_field_value_arr);
            }
            if (this.add_adhc_fields_days_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_days_arr, this.overtime_holiday_days_field_arr, this.overtime_holiday_days_field_value_arr);
            }
            if (this.add_adhc_fields_hours_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_hours_arr, this.overtime_holiday_hours_field_arr, this.overtime_holiday_hours_field_value_arr);
            }
            if (this.add_adhc_fields_nontax_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_nontax_arr, this.adhoc_nontax_field_arr, this.adhoc_nontax_field_value_arr);
            }
            if (this.add_adhc_fields_nontax_manual_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_nontax_manual_arr, this.overtime_holiday_nontax_manual_field_arr, this.overtime_holiday_nontax_manual_field_value_arr);
            }
            if (this.add_adhc_fields_nontax_fixed_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_nontax_fixed_arr, this.overtime_holiday_nontax_fixed_field_arr, this.overtime_holiday_nontax_fixed_field_value_arr);
            }
            if (this.add_adhc_fields_nontax_days_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_nontax_days_arr, this.overtime_holiday_nontax_days_field_arr, this.overtime_holiday_nontax_days_field_value_arr);
            }
            if (this.add_adhc_fields_nontax_hours_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_nontax_hours_arr, this.overtime_holiday_nontax_hours_field_arr, this.overtime_holiday_nontax_hours_field_value_arr);
            }
            if (this.add_adhc_fields_contracted_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_adhc_fields_contracted_arr, this.adhoc_contracted_field_arr, this.adhoc_contracted_field_value_arr);
            }
            if (this.add_pre_deduction_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_pre_deduction_fields_arr, this.pre_deduction_field_arr, this.pre_deduction_field_value_arr);
            }
            if (this.add_pre_manual_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_pre_manual_fields_arr, this.pre_manual_field_arr, this.pre_manual_field_value_arr);
            }
            if (this.add_pre_fixed_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_pre_fixed_fields_arr, this.pre_fixed_field_arr, this.pre_fixed_field_value_arr);
            }
            if (this.add_pre_days_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_pre_days_fields_arr, this.pre_days_field_arr, this.pre_days_field_value_arr);
            }
            if (this.add_pre_hours_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_pre_hours_fields_arr, this.pre_hours_field_arr, this.pre_hours_field_value_arr);
            }
            if (this.add_post_deduction_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_post_deduction_fields_arr, this.post_deduction_field_arr, this.post_deduction_field_value_arr);
            }
            if (this.add_post_manual_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_post_manual_fields_arr, this.post_manual_field_arr, this.post_manual_field_value_arr);
            }
            if (this.add_post_fixed_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_post_fixed_fields_arr, this.post_fixed_field_arr, this.post_fixed_field_value_arr);
            }
            if (this.add_post_days_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_post_days_fields_arr, this.post_days_field_arr, this.post_days_field_value_arr);
            }
            if (this.add_post_hours_fields_arr.length > 0) {
                this.create_bonus_title_value_arr(this.add_post_hours_fields_arr, this.post_hours_field_arr, this.post_hours_field_value_arr);
            }


            formData.append('id', this.fadatamodal.id);
            formData.append('employee_id', this.employee_id);
            formData.append('pay_slip_ref', this.pay_slip_ref);
            formData.append('pay_slip_name', this.pay_slip_name);
            formData.append('month', this.month);
            formData.append('year', this.year);
            formData.append('from_date', this.from_date);
            formData.append('to_date', this.to_date);
            formData.append('fiscal_year', this.fiscal_year);

            if (this.adhoc_field_arr != '') {
                //formData.append('adhoc_field', this.adhoc_field);
                formData.append('adhoc_field', this.adhoc_field_arr);
            }
            if (this.adhoc_field_value_arr != '') {
                //formData.append('adhoc_field_value', this.adhoc_field_value);
                formData.append('adhoc_field_value', this.adhoc_field_value_arr);
            }

            if (this.post_deduction_field_arr != '')
                formData.append('adhoc_deduction_field', this.post_deduction_field_arr);
            if (this.post_deduction_field_value_arr != '')
                formData.append('adhoc_deduction_field_value', this.post_deduction_field_value_arr);



            //if(this.medical_reimbursement_value!='')
            formData.append('medical_reimbursement_value', this.medical_reimbursement_value);


            //if(this.ait_adjust_value!='')
            //formData.append('ait_adjust_value', this.ait_adjust_value);

            if (this.pre_deduction_field_arr != '')
                formData.append('adhoc_pre_deduction_field', this.pre_deduction_field_arr);
            if (this.pre_deduction_field_value_arr != '')
                formData.append('adhoc_pre_deduction_field_value', this.pre_deduction_field_value_arr);


            if (this.adhoc_nontax_field_arr != '')
                formData.append('adhoc_nontaxable_field', this.adhoc_nontax_field_arr);
            if (this.adhoc_nontax_field_value_arr != '')
                formData.append('adhoc_nontaxable_field_value', this.adhoc_nontax_field_value_arr);

            if (this.adhoc_contracted_field_arr != '')
                formData.append('contracted_variable_field', this.adhoc_contracted_field_arr);
            if (this.adhoc_contracted_field_value_arr != '')
                formData.append('contracted_variable_field_value', this.adhoc_contracted_field_value_arr);

            if (this.bonus_incentive_field != '')
                formData.append('bonus_incentive_field', this.bonus_incentive_field);
            if (this.bonus_incentive_field_value != '')
                formData.append('bonus_incentive_field_value', this.bonus_incentive_field_value);

            // Overtime compensation
            if (this.overtime_holiday_manual_field_arr != '')
                formData.append('overtime_holiday_manual_field', this.overtime_holiday_manual_field_arr);
            if (this.overtime_holiday_manual_field_value_arr != '')
                formData.append('overtime_holiday_manual_field_value', this.overtime_holiday_manual_field_value_arr);

            if (this.overtime_holiday_fixed_field_arr != '')
                formData.append('overtime_holiday_fixed_field', this.overtime_holiday_fixed_field_arr);
            if (this.overtime_holiday_fixed_field_value_arr != '')
                formData.append('overtime_holiday_fixed_field_value', this.overtime_holiday_fixed_field_value_arr);

            if (this.overtime_holiday_days_field_arr != '')
                formData.append('overtime_holiday_incremental_days_field', this.overtime_holiday_days_field_arr);
            if (this.overtime_holiday_days_field_value_arr != '')
                formData.append('overtime_holiday_incremental_days_field_value', this.overtime_holiday_days_field_value_arr);

            if (this.overtime_holiday_hours_field_arr != '')
                formData.append('overtime_holiday_incremental_hours_field', this.overtime_holiday_hours_field_arr);
            if (this.overtime_holiday_hours_field_value_arr != '')
                formData.append('overtime_holiday_incremental_hours_field_value', this.overtime_holiday_hours_field_value_arr);

            // Non Tax Overtime compensation
            if (this.overtime_holiday_nontax_manual_field_arr != '')
                formData.append('overtime_holiday_manual_non_taxable_field', this.overtime_holiday_nontax_manual_field_arr);
            if (this.overtime_holiday_nontax_manual_field_value_arr != '')
                formData.append('overtime_holiday_manual_non_taxable_field_value', this.overtime_holiday_nontax_manual_field_value_arr);

            if (this.overtime_holiday_nontax_fixed_field_arr != '')
                formData.append('overtime_holiday_fixed_non_taxable_field', this.overtime_holiday_nontax_fixed_field_arr);
            if (this.overtime_holiday_nontax_fixed_field_value_arr != '')
                formData.append('overtime_holiday_fixed_non_taxable_field_value', this.overtime_holiday_nontax_fixed_field_value_arr);

            if (this.overtime_holiday_nontax_days_field_arr != '')
                formData.append('overtime_holiday_incremental_days_non_taxable_field', this.overtime_holiday_nontax_days_field_arr);
            if (this.overtime_holiday_nontax_days_field_value_arr != '')
                formData.append('overtime_holiday_incremental_days_non_taxable_field_value', this.overtime_holiday_nontax_days_field_value_arr);

            if (this.overtime_holiday_nontax_hours_field_arr != '')
                formData.append('overtime_holiday_incremental_hours_non_taxable_field', this.overtime_holiday_nontax_hours_field_arr);
            if (this.overtime_holiday_nontax_hours_field_value_arr != '')
                formData.append('overtime_holiday_incremental_hours_non_taxable_field_value', this.overtime_holiday_nontax_hours_field_value_arr);

            // Pre LOP
            if (this.pre_manual_field_arr != '')
                formData.append('pre_deduction_manual_field', this.pre_manual_field_arr);
            if (this.pre_manual_field_value_arr != '')
                formData.append('pre_deduction_manual_field_value', this.pre_manual_field_value_arr);

            if (this.pre_fixed_field_arr != '')
                formData.append('pre_deduction_fixed_field', this.pre_fixed_field_arr);
            if (this.pre_fixed_field_value_arr != '')
                formData.append('pre_deduction_fixed_field_value', this.pre_fixed_field_value_arr);

            if (this.pre_days_field_arr != '')
                formData.append('pre_deduction_incremental_days_field', this.pre_days_field_arr);
            if (this.pre_days_field_value_arr != '')
                formData.append('pre_deduction_incremental_days_field_value', this.pre_days_field_value_arr);

            if (this.pre_hours_field_arr != '')
                formData.append('pre_deduction_incremental_hours_field', this.pre_hours_field_arr);
            if (this.pre_hours_field_value_arr != '')
                formData.append('pre_deduction_incremental_hours_field_value', this.pre_hours_field_value_arr);


            // Post LOP
            if (this.post_manual_field_arr != '')
                formData.append('post_deduction_manual_field', this.post_manual_field_arr);
            if (this.post_manual_field_value_arr != '')
                formData.append('post_deduction_manual_field_value', this.post_manual_field_value_arr);

            if (this.post_fixed_field_arr != '')
                formData.append('post_deduction_fixed_field', this.post_fixed_field_arr);
            if (this.post_fixed_field_value_arr != '')
                formData.append('post_deduction_fixed_field_value', this.post_fixed_field_value_arr);

            if (this.post_days_field_arr != '')
                formData.append('post_deduction_incremental_days_field', this.post_days_field_arr);
            if (this.post_days_field_value_arr != '')
                formData.append('post_deduction_incremental_days_field_value', this.post_days_field_value_arr);

            if (this.post_hours_field_arr != '')
                formData.append('post_deduction_incremental_hours_field', this.post_hours_field_arr);
            if (this.post_hours_field_value_arr != '')
                formData.append('post_deduction_incremental_hours_field_value', this.post_hours_field_value_arr);


            axios.post(this.$api_url + '/payslip-action-vue', formData, config)

                .then(function (response) {
                    if (response.data.success != 'Not updated') {
                        currentObj.payslip_loader_text = 'Please wait! We are updating the data and recalculating the tax for this employee.';
                        //currentObj.getSalaryinfo();
                        currentObj.success = response.data.success;
                        currentObj.fadatamodal.id = response.data.payslip_id;
                        currentObj.adhoc_field_value = "";
                        currentObj.adhoc_field = "";

                        currentObj.medical_reimbursement_value_display = currentObj.medical_reimbursement_value;

                        if (parseInt(currentObj.medical_reimbursement_value) > 0)
                            currentObj.medical_reimbursement_show_control = 0;

                        currentObj.adhoc_deduction_field_value = "";
                        currentObj.adhoc_deduction_field = "";
                        currentObj.adhoc_pre_deduction_field_value = "";
                        currentObj.adhoc_pre_deduction_field = "";
                        currentObj.adhoc_nontaxable_field_value = "";
                        currentObj.adhoc_nontaxable_field = "";
                        currentObj.contracted_variable_field_value = "";
                        currentObj.contracted_variable_field = "";
                        currentObj.bonus_incentive_field_value = "";
                        currentObj.bonus_incentive_field = "";
                        currentObj.overtime_holiday_manual_field = '';
                        currentObj.overtime_holiday_manual_field_value = '';
                        currentObj.overtime_holiday_fixed_field = '';
                        currentObj.overtime_holiday_fixed_field_value = '';
                        currentObj.overtime_holiday_incremental_days_field = '';
                        currentObj.overtime_holiday_incremental_days_field_value = '';
                        currentObj.overtime_holiday_incremental_hours_field = '';
                        currentObj.overtime_holiday_incremental_hours_field_value = '';
                        currentObj.overtime_holiday_manual_non_taxable_field = '';
                        currentObj.overtime_holiday_manual_non_taxable_field_value = '';
                        currentObj.overtime_holiday_fixed_non_taxable_field = '';
                        currentObj.overtime_holiday_fixed_non_taxable_field_value = '';
                        currentObj.overtime_holiday_incremental_days_non_taxable_field = '';
                        currentObj.overtime_holiday_incremental_days_non_taxable_field_value = '';
                        currentObj.overtime_holiday_incremental_hours_non_taxable_field = '';
                        currentObj.overtime_holiday_incremental_hours_non_taxable_field_value = '';

                        currentObj.pre_deduction_manual_field = '';
                        currentObj.pre_deduction_manual_field_value = '';
                        currentObj.pre_deduction_fixed_field = '';
                        currentObj.pre_deduction_fixed_field_value = '';
                        currentObj.pre_deduction_incremental_days_field = '';
                        currentObj.pre_deduction_incremental_days_field_value = '';
                        currentObj.pre_deduction_incremental_hours_field = '';
                        currentObj.pre_deduction_incremental_hours_field_value = '';

                        currentObj.post_deduction_manual_field = '';
                        currentObj.post_deduction_manual_field_value = '';
                        currentObj.post_deduction_fixed_field = '';
                        currentObj.post_deduction_fixed_field_value = '';
                        currentObj.post_deduction_incremental_days_field = '';
                        currentObj.post_deduction_incremental_days_field_value = '';
                        currentObj.post_deduction_incremental_hours_field = '';
                        currentObj.post_deduction_incremental_hours_field_value = '';

                        // New updates for bulk data submit
                        currentObj.add_adhc_fields_arr = [];
                        currentObj.add_adhc_fields_manual_arr = [];
                        currentObj.add_adhc_fields_fixed_arr = [];
                        currentObj.add_adhc_fields_days_arr = [];
                        currentObj.add_adhc_fields_hours_arr = [];
                        currentObj.add_adhc_fields_nontax_arr = [];
                        currentObj.add_adhc_fields_nontax_manual_arr = [];
                        currentObj.add_adhc_fields_nontax_fixed_arr = [];
                        currentObj.add_adhc_fields_nontax_days_arr = [];
                        currentObj.add_adhc_fields_nontax_hours_arr = [];
                        currentObj.add_adhc_fields_contracted_arr = [];
                        currentObj.add_pre_deduction_fields_arr = [];
                        currentObj.add_pre_manual_fields_arr = [];
                        currentObj.add_pre_fixed_fields_arr = [];
                        currentObj.add_pre_days_fields_arr = [];
                        currentObj.add_pre_hours_fields_arr = [];
                        currentObj.add_post_deduction_fields_arr = [];
                        currentObj.add_post_manual_fields_arr = [];
                        currentObj.add_post_fixed_fields_arr = [];
                        currentObj.add_post_days_fields_arr = [];
                        currentObj.add_post_hours_fields_arr = [];

                        currentObj.getSalaryinfo();
                        currentObj.getSalaryDataFromDB('update');

                        //currentObj.getpayslips();
                        currentObj.hideAdhoc();
                    } else {
                        alert(response.data.msg);
                        this.$bvToast.toast(response.data.msg, {
                            title: `Update Failed`,
                            variant: 'danger',
                            solid: true
                        });
                    }


                })

                .catch(function (error) {

                    currentObj.output = error;

                });

        },


        /*****************Payslip Modal Method Ends******/


        ////////////Challan Modal Method Starts////////////

        chooseemployee: function (name, id, etin) {
            var default_tds = 0;
            var default_remaining = 0;
            axios.get(this.$api_url + '/gettds/' + id, {
                params: {
                    page: '',
                    per_page: '',
                    search_query: '',
                    search_query_by_id: '',
                }
            }).then(function (response) {

                default_tds = response.data.tds;
                default_remaining = response.data.remains;


                if (this.challanemployees.indexOf(id) === -1) {
                    /*var val=name+"---"+id;
                    this.challanemployees.push(id);
                    this.employeenames.push(name);
                    this.employeetds.push(default_tds);*/

                    this.challansearch.name = name;
                    this.current_employee_id = id;
                    this.current_employee_etin = etin;
                    this.tds_field = default_tds;
                    this.tds_remaining = default_remaining;
                    this.users = [];
                    //this.updatestack();
                    document.getElementById("employee_dropdown").style.display = "none";


                }
                else { alert("This employee already added."); }

            }.bind(this));


        },


        addemployee: function (index) {
            var tds_validity = "No";
            var tds = Number(this.tds_field);
            var remaining = Number(this.tds_remaining);
            if (tds <= remaining)
                tds_validity = "Yes";
            else {
                alert("TDS can not be greater than remaining.");
            }



            if (this.current_employee_id != "" && this.challansearch.name != "" && this.tds_field != "" && tds_validity == "Yes") {
                this.challanemployees.push(this.current_employee_id);
                this.employeenames.push(this.challansearch.name);
                this.employeetds.push(this.tds_field);
                this.employeeetins.push(this.current_employee_etin);
                this.updatestack();

                this.challansearch.name = "";
                this.current_employee_id = "";
                this.tds_field = "";
                this.tds_remaining = "";
                this.current_employee_etin = "";
                this.users = [];
            }

        },



        removeemployee: function (index) {

            this.challanemployees.splice(index, 1);
            this.employeenames.splice(index, 1);
            this.employeetds.splice(index, 1);
            this.employeeetins.splice(index, 1);

            this.updatestack();

        },


        updatestack: function () {

            //alert(this.challanemployees.length);
            var arlength = this.challanemployees.length;
            var counter = 0;
            var stacktxt = "";
            var endofstack = arlength - 1;
            this.tds_total = 0;
            this.employee_counter = 0;
            for (counter = 0; counter < arlength; counter++) {

                if (counter == endofstack)
                    stacktxt = stacktxt + this.challanemployees[counter] + "=" + this.employeetds[counter];
                else
                    stacktxt = stacktxt + this.challanemployees[counter] + "=" + this.employeetds[counter] + "^^";

                this.tds_total = this.tds_total + Number(this.employeetds[counter]);
                this.employee_counter = this.employee_counter + 1;

            }

            this.challanfdata.company_employee = stacktxt;
            this.challanfdata.total_amount = this.tds_total;
            this.challanfdata.money_details = "Cheque-" + this.challanfdata.cheque_no + " from " + this.challanfdata.bank_name;


        },

        challansetSearch: function (pageflg) {

            this.challangetEmployees();

        },


        challangetEmployees: function () {
            if (this.challansearch.name != "")
                document.getElementById("employee_dropdown").style.display = "block";
            else
                document.getElementById("employee_dropdown").style.display = "none";

            axios.get(this.$api_url + '/allemployees', {
                params: {
                    page: 1,
                    per_page: 15,
                    search_query: this.challansearch,
                    search_query_by_id: '',
                }
            }).then(function (response) {
                this.users = response.data.data;


            }.bind(this));
        },

        getCompanyinfo: function () {

            axios.get(this.$api_url + '/companyinfo', {
                params: {
                    page: 1,

                }
            }).then(function (response) {
                this.company_code = response.data.company_code;
                this.company_name = response.data.company_name;
                this.company_address = response.data.company_address;

                this.challanfdata.month = response.data.month;
                this.challanfdata.fiscal_year = response.data.year;
                this.challanfdata.challan_title = "Challan of " + this.company_name + ", " + this.challanfdata.month + " " + this.challanfdata.fiscal_year;
                this.challanfdata.payee = this.company_name + "\n" + this.company_address;
                this.challanfdata.paying_for = "Employees of \n" + this.company_name + "\n" + this.company_address;
                this.challanfdata.citation = "Tax deducted at source from salary under section 50 of the Income tax Ordinance 1984";


            }.bind(this));
        },


        setemployee: function () {

            //alert(this.challanfdata.company_employee);
            var eployeelist = this.challanfdata.company_employee;
            var employeearray = eployeelist.split("^^");

            var arlength = employeearray.length;
            var counter = 0;
            var endofstack = arlength - 1;
            for (counter = 0; counter < arlength; counter++) {
                var empltxt = employeearray[counter];
                var empltxtarray = empltxt.split("=");

                this.challanemployees.push(empltxtarray[0]);
                this.employeenames.push(empltxtarray[2]);
                this.employeetds.push(empltxtarray[1]);

            }

            this.updatestack();


        },


        saveAdhocnontaxable: function () {

            if (this.adhoc_nontaxable_field == "") {
                alert("Please Choose a Non-Taxable Adhoc Head");
            }
            else {
                if (this.adhoc_nontaxable_field_value == "")
                    alert("Please Enter Non-Taxable Adhoc Head Value");
            }

        },

        saveContractedVariable: function () {

            if (this.contracted_variable_field == "") {
                alert("Please Choose a Contracted Bonus Head");
            }
            else {
                if (this.contracted_variable_field_value == "")
                    alert("Please Enter Contracted Bonus Head Value");
            }

        },

        savePreAdhocdeduction: function () {
            if (this.adhoc_pre_deduction_field == "") {
                alert("Please Choose a Pre Deduction Head");
            }
            else {
                if (this.adhoc_pre_deduction_field_value == "")
                    alert("Please Enter Pre Deduction Head Value");
            }


        },


        saveAdhocdeduction: function () {

            if (this.adhoc_deduction_field == "") {
                alert("Please Choose a Post Deduction Head");
            }
            else {
                if (this.adhoc_deduction_field_value == "")
                    alert("Please Enter Post Deduction Head Value");
            }


        },







        challanformSubmit(e) {

            var added_employee = this.employeenames.length;

            if (added_employee < 1) {
                // alert("Please Add an Employee");
                return 0;
            }


            e.preventDefault();

            let currentObj = this;

            const config = {

                headers: { 'content-type': 'multipart/form-data' }

            }



            let formData = new FormData();

            for (let [key, value] of Object.entries(this.challanfdata)) {

                var nm = `${key}`;
                var fval = `${value}`;
                formData.append(nm, fval);

                console.log(`${key}: ${value}`);
            }


            axios.post(this.$api_url + '/challanstorevue', formData, config)

                .then(function (response) {

                    currentObj.modalsuccess = response.data.success;
                    currentObj.$bvModal.hide('challan_modal');
                    currentObj.getTotalChallan();

                })

                .catch(function (error) {

                    currentObj.output = error;

                });

        },

        ///////////////////////////////////////


        /*************************** Payslip creation modal functions **************/


        getEmployeesnewpayslip: function () {

            axios.get(this.$api_url + '/remainingemployees/' + this.prun_id_np, {
                params: {
                    page: 1,

                }
            }).then(function (response) {

                //console.log(response.data.employees);

                this.employees_np = response.data.employees;
                this.people = response.data.employees.length;
                this.length_options_np = [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ];


            }.bind(this));
        },




        newpayslipformSubmit: function (e) {
            e.preventDefault();
            this.new_payslip_loading = 1;
            axios.get(this.$api_url + '/create-regular-payslip/' + this.prun_id_np + '/' + this.employee_np, {
                params: {
                    page: 1,

                }
            }).then(function (response) {

                //alert(1);

                //console.log(response.data.success);
                this.modalsuccess = response.data.status;
                this.getPayrunPayslips();
                this.sortBy('employee_name');
                this.$bvModal.hide('new_payslip_modal');
                this.new_payslip_loading = '';

            }.bind(this));
        },


        /************************************************************************/

        //Overtime Data Export
        exportOvertimeData: function (type) {
            this.bonus_export = true;
            if (type == 'department') {
                this.getDepartmentData(this.fdata.id);
                this.$bvModal.show('department-selection-wizard');
                return false;
                // type = 'regular';
            }

            if (type == 'work_location') {
                this.getWorkLocationData(this.fdata.id);
                this.$bvModal.show('work-location-selection-wizard');
                return false;
                // type = 'regular';
            }
            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            this.download_loader = true;
            this.download_text = 'Please hold tight. We are exporting the template for you.';
            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }
            axios.get(this.$api_url + '/payrun/export/overtime-data/' + this.fdata.id + '?payslip_type=' + type, config)
                .then(function (response) {
                    this.download_loader = false;
                    // window.location.href= response.data;
                    if (response.data.type == 'application/json') {
                        let file = new Blob([response.data], { type: 'application/json' });
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                        });
                    } else {
                        this.global_download_file_content(response);
                    }
                    this.download_text = '';
                    this.bonus_export = false;
                    //window.open(response.data);
                }.bind(this));
        },

        importOvertimeData: function (type) {
            this.empfile = null;
            this.import_type = type;
            document.getElementById('datafile_overtime').click();
        },

        uploadFile_overtime: function (event) {
            this.empfile = event.target.files[0];
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            const data = new FormData();
            data.append('empfile', this.empfile);
            data.append('bonus_type', 'overtime');

            this.$bvToast.toast('We are uploading the excel and will initiate the import process accordingly.', { title: 'Uploading!', variant: 'success', solid: true });

            axios.post(this.$api_url + '/payrun/import/uploadfile/' + this.fdata.id, data, config).
                then(function (response) {



                    this.download_loader = true;
                    this.import_loader = true;
                    this.download_text = 'We are importing the excel file and will process the calculation accordingly. This may take some time.';

                    this.processFileData_overtime(this.import_type);

                }.bind(this)).
                catch(function (error) {
                    //alert(error.response.data.errors);
                });
        },
        processFileData_overtime: function (type) {
            this.importProgressBar();

            axios.get(this.$api_url + '/payrun/overtimedata/import/process/' + this.fdata.id, {
                params: {
                    payslip_type: type,
                }
            }).then(function (response) {

                if (response.data.status) {
                    this.download_loader = false;
                    this.import_loader = false;
                    this.file_imported = false;
                    this.download_text = '';

                    if (response.data.status == "File Imported Successfully") {
                        this.$bvToast.toast(response.data.status, {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                    }



                    if (response.data.status == "File Imported Successfully")
                        window.location.href = window.location;
                    else {
                        this.$bvToast.toast(response.data.status, {
                            title: `Import Failed`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                    //alert(response.data.status);


                }
                else {
                    this.errormsg = response.data.errors;
                }



            }.bind(this));
        },

        // Faroque code starts here
        exportAll: function (type) {
            if (type == 'department') {
                this.getDepartmentData(this.fdata.id);
                this.$bvModal.show('department-selection-wizard');
                return false;
                // type = 'regular';
            }

            if (type == 'work_location') {
                this.getWorkLocationData(this.fdata.id);
                this.$bvModal.show('work-location-selection-wizard');
                return false;
                // type = 'regular';
            }

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            this.download_loader = true;
            this.download_text = 'Please hold tight. We are exporting the template for you.';
            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }
            axios.get(this.$api_url + '/payrun/export/' + this.fdata.id + '?payslip_type=' + type, config)
                .then(function (response) {
                    this.download_loader = false;
                    //window.location.href= response.data;
                    this.download_text = '';
                    //window.open(response.data);
                    if (response.data.type == 'application/json') {
                        let file = new Blob([response.data], { type: 'application/json' });
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                        });
                    } else {
                        this.global_download_file_content(response);
                    }
                }.bind(this));
        },
        importAll: function (type) {
            this.empfile = null;
            this.import_type = type;
            document.getElementById('datafile').click();

        },

        uploadFile: function (event) {
            this.empfile = event.target.files[0];
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            const data = new FormData();
            data.append('empfile', this.empfile);

            this.$bvToast.toast('We are uploading the excel and will initiate the import process accordingly.', { title: 'Uploading!', variant: 'success', solid: true });

            axios.post(this.$api_url + '/payrun/import/uploadfile/' + this.fdata.id, data, config).
                then(function (response) {



                    this.download_loader = true;
                    this.import_loader = true;
                    this.download_text = 'We are importing the excel file and will process the calculation accordingly. This may take some time.';

                    this.processFileData(this.import_type);

                }.bind(this)).
                catch(function (error) {
                    //alert(error.response.data.errors);
                });
        },
        processFileData: function (type) {
            this.importProgressBar();
            axios.get(this.$api_url + '/payrun/import/process/' + this.fdata.id, {
                params: {
                    payslip_type: type,
                }
            }).then(function (response) {

                if (response.data.status) {
                    this.download_loader = false;
                    this.import_loader = false;
                    this.file_imported = false;
                    this.download_text = '';

                    if (response.data.status == "File Imported Successfully") {
                        this.$bvToast.toast(response.data.status, {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                    }



                    if (response.data.status == "File Imported Successfully")
                        window.location.href = window.location;
                    else {
                        this.$bvToast.toast(response.data.status, {
                            title: `Import Failed`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                    //alert(response.data.status);


                }
                else {
                    this.errormsg = response.data.errors;
                }



            }.bind(this));
        },

        importProgressBar: function () {
            let currentObj = this;
            currentObj.number_of_employees = 0;
            currentObj.progress_value = 0;
            // Payrun progress bar code start
            let check_payrun = setInterval(() => {
                axios.get(this.$api_url + '/read-import-progress-file', {
                    params: {

                    }
                }).then(function (response) {
                    //console.log(response.data);
                    if (response.data.process_count != 0) {
                        currentObj.payslip_array = response.data;

                        for (let [key, value] of Object.entries(currentObj.payslip_array)) {
                            currentObj.number_of_employees = value.total_count;
                            if (value.current_count) {
                                currentObj.progress_value = value.current_count;
                            } else {
                                currentObj.progress_value = 0;
                            }
                            if (value.import_completed) {
                                currentObj.file_imported = true;
                                currentObj.download_text = 'We are processing the tax calculation. This may take some time.';
                            }
                            //this.import_completed = value.import_completed;
                        }
                    } else {
                        clearInterval(check_payrun);
                    }

                }.bind(this)).catch(function (error) { currentObj.output = error; });
            }, 3000);
            // Payrun progress bar code end
        },


        failed_request_recovery: function () {
            if (this.payslip_loading == 1) {
                this.getPayrunPayslips();
                this.sortBy('employee_name');
            }
        },





        // Faroque code ends here
        get_decimal_settings: function () {
            axios.get(this.$api_url + '/decimal-settings')

                .then(function (response) {
                    this.decimal_setting = response.data;
                }.bind(this));
        },
        sumTotals: function (value1, value2) {
            let sum = 0;
            let val1 = value1.replace(/\,/g, '');
            let val2 = value2.replace(/\,/g, '');
            sum = (parseFloat(val1) + parseFloat(val2)).toFixed(2);
            if (this.decimal_setting == 'no') {
                //sum = (parseInt(val1) + parseInt(val2));
                sum = Math.round(sum);
            } else {
                sum = sum;
            }
            sum = sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            return sum;
        },

        deductTax: function (value1, value2) {
            let sum = 0;
            let val1 = value1.replace(/\,/g, '');
            let val2 = value2.replace(/\,/g, '');
            sum = (parseFloat(val1) - parseFloat(val2)).toFixed(2);
            if (this.decimal_setting == 'no') {
                //sum = (parseInt(val1) - parseInt(val2));
                sum = Math.round(sum);
            } else {
                sum = sum;
            }
            sum = sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            return sum;
        },

        /** custom fields **/

        listReturn: function (data) {
            console.log(data);
            if (data.selected.length > 0) {
                this.payslipids = data.selected;
            } else if (data.column_selected.length > 0) {
                this.column_selected = data.column_selected;
            } else {
                this.payslipids = [];
                if (data.action_id == 1) {
                    this.custom_list.forEach(element => {
                        if (element.id == data.id) {
                            this.displaymodal(element.id, element.employee_id, element.fiscal_year, element.from_date, element.to_date, element.pay_slip_ref, element.pay_slip_name, element.employee_name, element.pic, element.position, element.ait, element.medical_reimbursement);
                        }
                    });
                }
                else if (data.action_id == 2) {
                    this.displaytaxcardmodal(data.id);
                }
                else if (data.action_id == 3) {
                    this.custom_list.forEach(element => {
                        if (element.id == data.id) {
                            this.displaymodal_recalculate(element.id, element.employee_id, element.fiscal_year);
                        }
                    });
                }
                else if (data.id > 0) {
                    this.custom_list.forEach(element => {
                        if (element.id == data.id) {
                            this.displaymodal(element.id, element.employee_id, element.fiscal_year, element.from_date, element.to_date, element.pay_slip_ref, element.pay_slip_name, element.employee_name, element.pic, element.position, element.ait, element.medical_reimbursement);
                        }
                    });
                }
            }

        },
        /** custom fields **/

        getPayrunUserdata: function (payrun_id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/get-payrun-userdata/?payrun_id=' + payrun_id, {

            }).then(function (response) {
                this.payrun_userdata = response.data;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        getSalaryReport: function (year, month) {
            if (!this.checkNet()) return false;
            this.loader = true;
            this.download_loader = true;
            this.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
            if (this.column_selected.indexOf('name') === -1) {
                this.column_selected.unshift('name');
            }
            let currentObj = this;
            let formData = new FormData();
            formData.append('year', year);
            formData.append('month', month);
            formData.append('grid_report', 'Excel');
            formData.append('column_selected', this.column_selected);
            formData.append('report', 1);
            formData.append('show_break_down', 'none');
            formData.append('extra_fields', '');
            formData.append('extra_signature_fields', '');
            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }
            let url = this.$api_url + '/payroll_monthly_report_custom';
            axios.post(url, formData, config).then(function (response) {
                //this.payroll_reporting_data = response.data;
                //var fileURL = this.$api_url+'/payroll_monthly_report?grid_report=Excel&year='+year+'&month='+month;
                //this.download_file(response.data);
                this.loader = false;
                this.download_loader = false;
                this.download_text = '';
                if (response.data.type == 'application/json') {
                    let file = new Blob([response.data], { type: 'application/json' });
                    const cast = Promise.resolve(file.text());
                    cast.then((value) => {
                        let err_obj = JSON.parse(`${value}`);
                        this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                    });
                } else {
                    this.global_download_file_content(response);
                }

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            return false;
        },

        download_file(fileURL) {
            if (!this.checkNet()) return false;

            var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
                if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                } else {
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }
            else if (!!window.ActiveXObject && document.execCommand) {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        },

        get_custom_gross_heads: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/get-custom-gross-heads', {

            }).then(function (response) {
                this.custom_gross_heads = response.data;
                for (let [key, value] of Object.entries(this.custom_gross_heads)) {
                    this.custom_gross_heads_models.push({ title: value, value: 0, });
                }

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        exportPayslipsByWorkLocation: function () {
            this.payslipids = [];
            let formData = new FormData();
            formData.append('work_location', this.work_location);
            formData.append('payrun_id', this.fdata.id);
            axios.post(this.$api_url + '/payrun/worklocation/get-work-location-payslips', formData).
                then(function (response) {
                    if (response.data) {
                        var payslip_ids = [];
                        response.data.forEach(function (pslip) {
                            payslip_ids.push(pslip.id);
                        });
                    }
                    this.payslipids = payslip_ids;
                    if (this.bonus_export) {
                        this.exportOvertimeDataSelected('regular');
                    } else {
                        this.exportPayslips('regular');
                    }
                    this.$bvModal.hide('work-location-selection-wizard');
                    this.work_location = [];
                    this.bonus_export = false;

                }.bind(this)).
                catch(function (error) {
                    //alert(error.response.data.errors);
                });
        },

        exportPayslipsByDepartment: function () {
            this.payslipids = [];
            let formData = new FormData();
            formData.append('department', this.department);
            formData.append('payrun_id', this.fdata.id);
            axios.post(this.$api_url + '/payrun/department/get-department-payslips', formData).
                then(function (response) {
                    if (response.data) {
                        var payslip_ids = [];
                        response.data.forEach(function (pslip) {
                            payslip_ids.push(pslip.id);
                        });
                    }
                    this.payslipids = payslip_ids;
                    if (this.bonus_export) {
                        this.exportOvertimeDataSelected('regular');
                    } else {
                        this.exportPayslips('regular');
                    }

                    this.$bvModal.hide('department-selection-wizard');
                    this.department = [];
                    this.bonus_export = false;

                }.bind(this)).
                catch(function (error) {
                    //alert(error.response.data.errors);
                });
        },

        exportPayslips: function (type) {
            if (this.payslipids.length > 0) {
                this.$bvToast.toast('It might take a while', {
                    title: `Info`,
                    variant: 'info',
                    solid: true
                });
                this.download_loader = true;
                this.download_text = 'Please hold tight. We are exporting the template for you.';

                let formData = new FormData();
                formData.append('payslipids', this.payslipids);
                axios.get(this.$api_url + '/payrun/export/' + this.fdata.id, {
                    params: {
                        payslipids: this.payslipids,
                        payslip_type: type,
                    },
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }).then(function (response) {
                    this.download_loader = false;
                    //window.location.href= response.data;
                    this.download_text = '';
                    //window.open(response.data);
                    if (response.data.type == 'application/json') {
                        let file = new Blob([response.data], { type: 'application/json' });
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                        });
                    } else {
                        this.global_download_file_content(response);
                        this.payslipids = [];
                    }
                }.bind(this));
            } else {
                alert("Please Select Payslip(s).");
                return false;
            }
        },

        displaynewpayslipmodalManual: function (payrun_id) {
            this.resetPagination();
            this.employee_np_manual = [];
            this.getEmployeesnewpayslip();
            this.$bvModal.show('new_payslip_modal_manual');
        },

        newpayslipformSubmitManual: function (e) {
            e.preventDefault();
            this.new_payslip_loading = 1;
            axios.get(this.$api_url + '/create-manual-payslip/' + this.prun_id_np + '/' + this.employee_np_manual, {
                params: {
                    page: 1,

                }
            }).then(function (response) {

                //alert(1);

                //console.log(response.data.success);
                this.modalsuccess = response.data.status;
                this.getPayrunPayslips();
                this.sortBy('employee_name');
                this.$bvModal.hide('new_payslip_modal_manual');
                this.new_payslip_loading = '';

            }.bind(this));
        },

        exportOvertimeDataSelected: function (type) {
            if (this.payslipids.length > 0) {
                this.$bvToast.toast('It might take a while', {
                    title: `Info`,
                    variant: 'info',
                    solid: true
                });
                this.download_loader = true;
                this.download_text = 'Please hold tight. We are exporting the template for you.';

                let formData = new FormData();
                formData.append('payslipids', this.payslipids);
                axios.get(this.$api_url + '/payrun/export/overtime-data/' + this.fdata.id, {
                    params: {
                        payslipids: this.payslipids,
                        payslip_type: type,
                    },
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }).then(function (response) {
                    this.download_loader = false;
                    //window.location.href= response.data;
                    this.download_text = '';
                    //window.open(response.data);
                    if (response.data.type == 'application/json') {
                        let file = new Blob([response.data], { type: 'application/json' });
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                        });
                    } else {
                        this.global_download_file_content(response);
                    }
                    this.bonus_export = false;
                }.bind(this));
            } else {
                alert("Please Select Payslip(s).");
                return false;
            }
        },

        showHideBlock: function () {
            this.show_leaver = true;
            this.ask_leaver = false;
        },

        moveNext: function (step) {
            if (step == 'leaver') {
                this.leaver_process = false;
                this.show_leaver = false;
            }
        },

        cancelExport: function () {
            this.department = [];
            this.work_location = [];
            this.$bvModal.hide('department-selection-wizard');
            this.$bvModal.hide('work-location-selection-wizard');
        },

        getSelectedBanks: function () {
            axios.get(this.$api_url + '/get-payment-selcted-banks', {
                params: {
                }
            }).then(function (response) {
                this.checked_banks = response.data;
                for (var f_key in this.checked_banks) {
                    this.selected_banks[this.checked_banks[f_key]] = 1;
                }
            }.bind(this));
        },



    },
    created: function () {
        this.getEmployees();
        this.getpayrunsfiscalyear();
        //this.getPayrunPayslips();
        //alert(this.fdata.id);
        this.search_by_id.payrun = this.fdata.id;
        this.prun_id_np = this.fdata.id;
        this.getEmployeesnewpayslip();
        //this.getCustomList();
        // setInterval(this.failed_request_recovery, 9000);

        /** Following line added by Faroque */
        this.getPayrunPayslips();
        this.get_decimal_settings();
        this.getPayrunUserdata(this.fdata.id);
        this.getCompanyAddons();
        this.get_custom_gross_heads();
        this.getPayrunDepartmentData();
        this.getSelectedBanks();
        // console.log('ACL--'+$acl);

    },
    computed:
    {
        selectAll: {
            get: function () {
                //return this.payslips ? this.payslipids.length == this.payslips.length : false;
            },
            set: function (value) {
                var employeeids = [];
                if (value) {
                    this.encashment_list.forEach(function (pslip) {
                        if (pslip.encash_data == 'no') {
                            employeeids.push(pslip.employee_id);
                        }
                    });
                }
                this.employeeids = employeeids;
            }
        },

        selectAllNewEmployee: {
            get: function () {
                //return this.payslips ? this.payslipids.length == this.payslips.length : false;
            },
            set: function (value) {
                var employeeids = [];
                if (value) {
                    this.employees_np.forEach(function (pslip) {
                        employeeids.push(pslip.employee_id);
                    });
                }
                this.employee_np = employeeids;
            }
        },

        selectAllNewEmployeeManual: {
            get: function () {
                //return this.payslips ? this.payslipids.length == this.payslips.length : false;
            },
            set: function (value) {
                var employeeids = [];
                if (value) {
                    this.employees_np.forEach(function (pslip) {
                        employeeids.push(pslip.employee_id);
                    });
                }
                this.employee_np_manual = employeeids;
            }
        },

        selectAllDepartment: {
            get: function () {
                //return this.payslips ? this.payslipids.length == this.payslips.length : false;
            },
            set: function (value) {
                var departmentids = [];
                if (value) {
                    this.departments.forEach(function (department) {
                        if (department.has_employee == 'yes') {
                            departmentids.push(department.id);
                        }
                    });
                }
                this.department = departmentids;
                this.$cookies.set("payrun_department_selected", this.department, '24h');
            }
        },

        selectAllDepartmentExport: {
            get: function () {
                //return this.payslips ? this.payslipids.length == this.payslips.length : false;
            },
            set: function (value) {
                var departmentids = [];
                if (value) {
                    this.departments.forEach(function (department) {
                        if (department.payrun_processed == 'yes') {
                            departmentids.push(department.id);
                        }
                    });
                }
                this.department = departmentids;
                // this.$cookies.set("payrun_department_selected", this.department,'24h');
            }
        },

        selectAllBranch: {
            get: function () {
                //return this.payslips ? this.payslipids.length == this.payslips.length : false;
            },
            set: function (value) {
                var work_location_ids = [];
                if (value) {
                    this.work_locations.forEach(function (work_location) {
                        if (work_location.has_employee == 'yes') {
                            work_location_ids.push(work_location.id);
                        }
                    });
                }
                this.work_location = work_location_ids;
                this.$cookies.set("payrun_work_location_selected", this.work_location, '24h');
            }
        },

        selectAllWorkLocationExport: {
            get: function () {
                //return this.payslips ? this.payslipids.length == this.payslips.length : false;
            },
            set: function (value) {
                var work_location_ids = [];
                if (value) {
                    this.work_locations.forEach(function (work_location) {
                        if (work_location.payrun_processed == 'yes') {
                            work_location_ids.push(work_location.id);
                        }
                    });
                }
                this.work_location = work_location_ids;
            }
        },

        filteredData() {
            let filtered_list = this.employees_np;
            if (this.this_search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.this_search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            return filtered_list;
        },
        paginatedData() {
            this.backdoor;

            return this.paginate(this.filteredData, this.length, this.this_pagination.currentPage);
        },
        filteredDataTwo() {
            let filtered_list = this.encashment_list;
            if (this.this_search_two) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.this_search_two.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            return filtered_list;
        },
        paginatedDataTwo() {
            this.backdoor;

            return this.paginateTwo(this.filteredDataTwo, this.length_two, this.this_pagination_two.currentPage);
        },

    }
}
</script>
<style>
#leave-encashment-list .table .btn {
    width: 180px;
}

#leave-encashment-list .custom-loader-wrapper {
    position: absolute;
    width: 100%;
    height: calc(100% + 69px);
    top: -69px;
}
</style>
